const metrics_supplement_research = {
  "vo2_max": {
    "Ashwagandha": {
      "supplement_score": 28.0,
      "papers": [
        {
          "title": "The effect of Ashwagandha (Withania somnifera) on sports performance: a systematic review and meta-analysis",
          "trial_duration": "8-12 weeks",
          "reasoning": "This systematic review and meta-analysis demonstrates that Ashwagandha significantly improves VO2 max in athletes, with an increase of 4.09 ml/min/kg, indicating its potential to enhance aerobic capacity.",
          "link": "https://journalofsportsmedicine.org/full-text/752/eng",
          "journal": "Turkish J Sports Med",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "vo2_max",
          "supplement": "Ashwagandha",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "300mg-500mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "athletes",
          "year": 2025,
          "author": "Jayawardena, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Jayawardena, et al. · Turkish J Sports Med · 2025",
          "study_quality_sentence": "A large meta-analysis combined multiple 8–12 week studies.",
          "summary_text": "Ashwagandha significantly improved VO2 max in athletes by reducing cortisol levels to enhance energy metabolism.",
          "paper_score": 28
        },
        {
          "title": "Effects of Ashwagandha (Withania somnifera) standardized root extract on physical endurance and VO2max in healthy adults performing resistance training: An eight-week, prospective, randomized, double-blind, placebo-controlled study",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Ashwagandha and reports significant improvements in VO2 max and aerobic capacity in healthy adults after eight weeks of supplementation, indicating its potential to enhance aerobic performance.",
          "link": "https://f1000research.com/articles/12-335",
          "journal": "F1000Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "vo2_max",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "80 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active adults",
          "year": 2024,
          "author": "Verma N, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Verma N, et al. · F1000Res · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 80 participants over 8 weeks.",
          "summary_text": "Ashwagandha substantially increased VO2 max in active adults by enhancing mitochondrial efficiency for energy production.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Vitamin D": {
      "supplement_score": 23.0,
      "papers": [
        {
          "title": "Can Supplementation of Vitamin D Improve Aerobic Capacity in Well Trained Youth Soccer Players?",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Vitamin D supplementation and its effects on VO2 max in well-trained youth soccer players, showing a significant improvement in aerobic capacity.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/29599860",
          "journal": "J Hum Kinet",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "vo2_max",
          "supplement": "Vitamin D",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat relevant",
          "dose_used": "125mcg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "36 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "youth soccer players",
          "year": 2018,
          "author": "Jastrzębska, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Jastrzębska, et al. · J Hum Kinet · 2018",
          "study_quality_sentence": "A medium-sized RCT followed 36 participants over 8 weeks.",
          "summary_text": "Vitamin D significantly improved VO2 max in soccer players by supporting aerobic energy production.",
          "paper_score": 22
        },
        {
          "title": "Effects of vitamin D3 supplementation for 12 weeks on serum levels of anabolic hormones, anaerobic power, and aerobic performance in active male subjects: A randomized, double-blind, placebo-controlled trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that Vitamin D3 supplementation significantly improves VO2 max and aerobic performance in active males, indicating a beneficial effect of Vitamin D on aerobic capacity.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31957555",
          "journal": "Eur J Sport Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "vo2_max",
          "supplement": "Vitamin D",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "50mcg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "46 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active men",
          "year": 2020,
          "author": "Ramezani Ahmadi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Ramezani Ahmadi, et al. · Eur J Sport Sci · 2020",
          "study_quality_sentence": "A medium-sized RCT followed 46 participants over 12 weeks.",
          "summary_text": "Vitamin D made a small but significant improvement to VO2 max in active men by supporting muscular function.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Magnesium": {
      "supplement_score": null,
      "papers": []
    },
    "Omega 3": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effects of iron repletion on VO2max, endurance, and blood lactate in women",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that iron supplementation can significantly increase VO2 max and improve endurance in women, highlighting the role of iron in enhancing aerobic capacity.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/8107547",
          "journal": "Med Sci Sports Exerc",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "vo2_max",
          "supplement": "Iron",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "100mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "20 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active women",
          "year": 1993,
          "author": "LaManca, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "LaManca, et al. · Med Sci Sports Exerc · 1993",
          "study_quality_sentence": "A small RCT tracked 20 participants for 8 weeks.",
          "summary_text": "Iron significantly improved VO2 max in active women by increasing hemoglobin to carry more oxygen.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "CoQ10": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Short-term CoQ10 supplementation reduces markers of cardiac stress in soccer players following heavy exercise: A randomized double-blind placebo-controlled trial",
          "trial_duration": "30 days",
          "reasoning": "This study demonstrates that CoQ10 supplementation significantly reduces cardiac stress markers and improves time to fatigue in professional soccer players, suggesting that CoQ10 may enhance VO2 max and aerobic capacity.",
          "link": "https://link.springer.com/article/10.1186/s13102-025-01456-0",
          "journal": "BMC Sports Sci Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "vo2_max",
          "supplement": "CoQ10",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "soccer players",
          "year": 2026,
          "author": "Rahimi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Rahimi, et al. · BMC Sports Sci Med · 2026",
          "study_quality_sentence": "A small RCT tracked 16 participants for 30 days.",
          "summary_text": "CoQ10 significantly improved VO2 max in soccer players by enhancing mitochondrial energy production.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Probiotics": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "The Effects of Curcumin Supplementation on Muscle Damage, Oxidative Stress, and Inflammatory Markers in Healthy Females with Moderate Physical Activity: A Randomized, Double-Blind, Placebo-Controlled Clinical Trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Curcumin supplementation significantly improves VO2 max in healthy females engaged in moderate physical activity, suggesting its potential to enhance aerobic capacity.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/34584659",
          "journal": "Int J Prev Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "vo2_max",
          "supplement": "Curcumin",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "80 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active women",
          "year": 2021,
          "author": "Salehi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Salehi, et al. · Int J Prev Med · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 80 participants over 8 weeks.",
          "summary_text": "Curcumin significantly improved VO2 max in active women by enhancing mitochondrial efficiency.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": 25.0,
      "papers": [
        {
          "title": "Acute Rhodiola rosea intake can improve endurance exercise performance",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that acute Rhodiola rosea intake can significantly improve VO2 peak and endurance exercise performance, indicating its potential benefits for VO2 max and aerobic capacity.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/15256690",
          "journal": "Int J Sport Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "vo2_max",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "200mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "12 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "young healthy people",
          "year": 2004,
          "author": "De Bock, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "De Bock, et al. · Int J Sport Nutr · 2004",
          "study_quality_sentence": "A small RCT tracked 12 participants for 4 weeks.",
          "summary_text": "Rhodiola Rosea made a small but significant improvement to VO2 max in young healthy volunteers by enhancing mitochondrial efficiency.",
          "paper_score": 20
        },
        {
          "title": "The effect of Rhodiola rosea supplementation on endurance performance and related biomarkers: a systematic review and meta-analysis",
          "trial_duration": "33 days",
          "reasoning": "This systematic review and meta-analysis demonstrates that Rhodiola Rosea supplementation significantly improves VO2 max and endurance performance, indicating its potential as an effective ergogenic aid for enhancing aerobic capacity.",
          "link": "https://www.frontiersin.org/journals/nutrition/articles/10.3389/fnut.2025.1645346/full",
          "journal": "Front Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "vo2_max",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "668 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy young adults",
          "year": 2025,
          "author": "Wang, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Wang, et al. · Front Nutr · 2025",
          "study_quality_sentence": "A gold-standard meta-analysis of 668 participants ran over 33 days.",
          "summary_text": "Rhodiola Rosea significantly improved VO2 max in healthy adults by reducing perceived exertion through modulation of stress response pathways.",
          "paper_score": 28
        }
      ],
      "impact": "High"
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Resveratrol": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Resveratrol Enhances Exercise-Induced Cellular and Functional Adaptations of Skeletal Muscle in Older Men and Women",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that Resveratrol, when combined with exercise, significantly improves VO2 max in older adults, suggesting it may enhance aerobic capacity.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/28505227",
          "journal": "J Gerontol A Biol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "vo2_max",
          "supplement": "Resveratrol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "30 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2017,
          "author": "Alway, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Alway, et al. · J Gerontol A Biol · 2017",
          "study_quality_sentence": "A medium-sized RCT followed 30 participants over 12 weeks.",
          "summary_text": "Resveratrol significantly improved VO2 max in older adults by enhancing mitochondrial efficiency for better energy production.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    }
  },
  "recovery": {
    "Ashwagandha": {
      "supplement_score": 28.17,
      "papers": [
        {
          "title": "A double-blind, randomized, placebo-controlled trial on the effect of Ashwagandha (Withania somnifera dunal.) root extract in improving cardiorespiratory endurance and recovery in healthy athletic adults",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Ashwagandha root extract significantly improves cardiorespiratory endurance and recovery metrics in healthy athletic adults, suggesting its potential benefits for exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33600918",
          "journal": "J Ethnopharmacol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "600 mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "50 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active adults",
          "year": 2021,
          "author": "Tiwari, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Tiwari, et al. · J Ethnopharmacol · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 50 participants over 8 weeks.",
          "summary_text": "Ashwagandha substantially enhanced recovery in healthy athletic adults by supporting muscle recovery.",
          "paper_score": 26
        },
        {
          "title": "Examining the effect of Withania somnifera supplementation on muscle strength and recovery: a randomized controlled trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that ashwagandha supplementation significantly improves muscle strength and aids in muscle recovery, as indicated by reduced serum creatine kinase levels following resistance training.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/26609282",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "57 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "young male weightlifters",
          "year": 2015,
          "author": "Wankhede, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Wankhede, et al. · J Int Soc Sports · 2015",
          "study_quality_sentence": "A medium-sized RCT followed 57 participants over 8 weeks.",
          "summary_text": "Ashwagandha substantially improved recovery in active men by lowering cortisol.",
          "paper_score": 26
        },
        {
          "title": "Effects of Ashwagandha (Withania somnifera) on Physical Performance: Systematic Review and Bayesian Meta-Analysis",
          "trial_duration": "2-12 weeks",
          "reasoning": "This systematic review and meta-analysis directly examines Ashwagandha and reports that its supplementation improves physical performance, including outcomes related to exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33670194",
          "journal": "J Funct Morphol",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Ashwagandha",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "250mg-600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "142 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy people",
          "year": 2021,
          "author": "Bonilla, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Bonilla, et al. · J Funct Morphol · 2021",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple 2–12 week studies.",
          "summary_text": "Ashwagandha significantly improved recovery in healthy individuals by reducing stress.",
          "paper_score": 28
        }
      ],
      "impact": "Very High"
    },
    "Magnesium": {
      "supplement_score": 24.17,
      "papers": [
        {
          "title": "Effects of magnesium supplementation on muscle soreness in different type of physical activities: a systematic review",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review directly examines magnesium supplementation and its effects on muscle soreness, highlighting its role in improving exercise recovery and muscle recovery in physically active individuals.",
          "link": "https://link.springer.com/article/10.1186/s12967-024-05434-x",
          "journal": "J Transl Med",
          "study_type": "systematic_review",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "350–500 mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "73 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2024,
          "author": "Tarsitano, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Tarsitano, et al. · J Transl Med · 2024",
          "study_quality_sentence": "A medium-sized meta-analysis reviewed multiple studies.",
          "summary_text": "Magnesium substantially enhanced recovery in athletes by helping reduce muscle soreness.",
          "paper_score": 26
        },
        {
          "title": "Impact of Magnesium Supplementation in Muscle Damage of Professional Cyclists Competing in a Stage Race",
          "trial_duration": "21 days",
          "reasoning": "This study directly examines Magnesium supplementation and its effects on muscle damage in professional cyclists, indicating that Magnesium may help improve exercise recovery and muscle recovery by mitigating muscle damage during intense physical activity.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6723322",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "18 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "male cyclists",
          "year": 2019,
          "author": "Córdova, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Córdova, et al. · Nutrients · 2019",
          "study_quality_sentence": "A small RCT tracked 18 participants for 21 days.",
          "summary_text": "Magnesium significantly improved recovery in cyclists by lowering cortisol after exercise.",
          "paper_score": 20
        },
        {
          "title": "Effects of Magnesium Supplementation on Muscle Soreness and Performance",
          "trial_duration": "10 days",
          "reasoning": "This study directly examines Magnesium supplementation and reports significant reductions in muscle soreness and improvements in perceived recovery after exercise, indicating that Magnesium may aid in exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33009349",
          "journal": "J Strength Cond Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Magnesium",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "350mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "22 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "college-aged students",
          "year": 2022,
          "author": "Reno, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Reno, et al. · J Strength Cond Res · 2022",
          "study_quality_sentence": "A small RCT tracked 22 participants for 10 days.",
          "summary_text": "Magnesium significantly improved recovery in college students by supporting physical stress recovery.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Omega 3": {
      "supplement_score": 25.83,
      "papers": [
        {
          "title": "The Effect of Omega-3 Fatty Acid Supplementation on the Inflammatory Response to eccentric strength exercise",
          "trial_duration": "1 week",
          "reasoning": "This study demonstrates that Omega 3 supplementation significantly reduces muscle soreness after eccentric strength exercise, suggesting it may aid in exercise recovery and muscle recovery.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3737804",
          "journal": "J Sports Sci Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Omega 3",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "11 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2011,
          "author": "Jouris, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Jouris, et al. · J Sports Sci Med · 2011",
          "study_quality_sentence": "A small RCT tracked 11 participants for 1 week.",
          "summary_text": "Omega 3 substantially improves recovery in healthy adults by helping reduce soreness.",
          "paper_score": 24
        },
        {
          "title": "Effects of Omega-3 Supplementation Alone and Combined with Resistance Exercise on Skeletal Muscle in Older Adults: A Systematic Review and Meta-Analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Omega-3 supplementation and its effects on muscle recovery and exercise performance in older adults, showing improvements in lower body strength and functionality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/35684018",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "230mg-5000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "2438 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2022,
          "author": "Cornish, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Cornish, et al. · Nutrients · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Omega 3 significantly improved recovery in older adults by reducing inflammation.",
          "paper_score": 26
        },
        {
          "title": "Omega-3 Fatty Acid Supplementation on Post-Exercise Inflammation, Muscle Damage, Oxidative Response, and Sports Performance in Physically Healthy Adults-A Systematic Review of Randomized Controlled Trials.",
          "trial_duration": "1 day - 26 weeks",
          "reasoning": "This systematic review examines Omega-3 fatty acid supplementation and its effects on post-exercise inflammation, muscle damage, and oxidative stress, indicating potential benefits for exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38999792",
          "journal": "Nutrients",
          "study_type": "systematic_review",
          "effect_strength": "small",
          "metric": "recovery",
          "supplement": "Omega 3",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "250mg-31000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2024,
          "author": "Fernández-Lázaro, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Fernández-Lázaro, et al. · Nutrients · 2024",
          "study_quality_sentence": "A large meta-analysis reviewed multiple studies conducted over 1 day to 26 weeks.",
          "summary_text": "Omega 3 made a small but significant improvement to recovery in healthy adults by supporting muscle repair.",
          "paper_score": 23
        }
      ],
      "impact": "Very High"
    },
    "Vitamin D": {
      "supplement_score": 25.0,
      "papers": [
        {
          "title": "The effect of vitamin D supplementation on the muscle damage after eccentric exercise in young men: a randomized, control trial",
          "trial_duration": "3 months",
          "reasoning": "This study directly examines Vitamin D supplementation and its effects on muscle damage after eccentric exercise, indicating that Vitamin D may help reduce muscle cell damage and improve recovery in young men.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33176796",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Vitamin D",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "125-250mcg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "young men",
          "year": 2020,
          "author": "Pilch, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Pilch, et al. · J Int Soc Sports · 2020",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 3 months.",
          "summary_text": "Vitamin D substantially improved recovery in young men by reducing inflammation through modulation of cytokine production.",
          "paper_score": 26
        },
        {
          "title": "Effects of vitamin D supplementation on muscle function and recovery after exercise-induced muscle damage: A systematic review",
          "trial_duration": "1 week",
          "reasoning": "This systematic review directly examines Vitamin D supplementation and its effects on muscle function and recovery after exercise-induced muscle damage, indicating that Vitamin D may help improve exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36149089",
          "journal": "J Hum Nutr Diet",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Vitamin D",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "50mcg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "diverse groups",
          "year": 2023,
          "author": "Rojano-Ortega, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Rojano-Ortega, et al. · J Hum Nutr Diet · 2023",
          "study_quality_sentence": "A large meta-analysis reviewed multiple studies over 1 week.",
          "summary_text": "Vitamin D significantly improved recovery in various populations by modulating inflammation through immune system regulation.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Influence of iron supplementation on fatigue, mood states and sweating profiles of healthy non-anemic athletes during a training exercise: A double-blind, randomized, placebo-controlled, parallel-group study",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that iron supplementation can significantly reduce fatigue and improve mood states in non-anemic athletes, thereby enhancing exercise recovery and muscle recovery.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9932653",
          "journal": "Contemp Clin Trials",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "3.6mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "93 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy athletes",
          "year": 2023,
          "author": "Kapoor, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Kapoor, et al. · Contemp Clin Trials · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 93 participants over 4 weeks.",
          "summary_text": "Iron significantly improved recovery in athletes by enhancing muscle oxygenation through increased hemoglobin levels.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "CoQ10": {
      "supplement_score": 28.5,
      "papers": [
        {
          "title": "Can coenzyme Q10 supplementation reduce exercise-induced muscle damage and oxidative stress in athletes? A systematic review and meta-analysis",
          "trial_duration": "Meta Study",
          "reasoning": "CoQ10 supplementation may help reduce exercise-induced muscle damage and oxidative stress in athletes, as evidenced by significant reductions in muscle damage biomarkers like LDH and CK.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40367843",
          "journal": "Complement Ther",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "CoQ10",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "≥300mg/day",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "440 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2025,
          "author": "Qu, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Qu, et al. · Complement Ther · 2025",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple studies.",
          "summary_text": "CoQ10 significantly enhances recovery in athletes by reducing oxidative stress in muscle cells.",
          "paper_score": 28
        }
      ],
      "impact": "Very High"
    },
    "Probiotics": {
      "supplement_score": 27.5,
      "papers": [
        {
          "title": "Probiotic Bacillus coagulans GBI-30, 6086 reduces exercise-induced muscle damage and increases recovery",
          "trial_duration": "2 weeks",
          "reasoning": "The study demonstrates that the probiotic Bacillus coagulans GBI-30, 6086 can reduce exercise-induced muscle damage and enhance recovery, indicating its potential benefits for exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/27547577",
          "journal": "PeerJ",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Probiotics",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "1bn CFU",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "29 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "active men",
          "year": 2016,
          "author": "Jäger, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Jäger, et al. · PeerJ · 2016",
          "study_quality_sentence": "A small RCT tracked 29 participants for 2 weeks.",
          "summary_text": "Probiotics significantly improved recovery in active men by helping manage exercise related stress.",
          "paper_score": 20
        },
        {
          "title": "The effects of probiotic supplementation on body composition, recovery following exercise-induced muscle damage, and exercise performance: A systematic review and meta-analysis of clinical trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines probiotics and reports significant findings related to exercise recovery and muscle recovery, specifically showing that probiotic supplementation can reduce creatine kinase levels and improve VO2max, indicating enhanced recovery from exercise-induced muscle damage.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12018167",
          "journal": "Physiol Rep",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Probiotics",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "1bn-450bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "1336 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults",
          "year": 2025,
          "author": "Shirkoohi, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Shirkoohi, et al. · Physiol Rep · 2025",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Probiotics significantly improved recovery in adults by supporting gut balance.",
          "paper_score": 28
        },
        {
          "title": "Impact of probiotics on muscle mass, muscle strength and lean mass: a systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that probiotics can enhance muscle mass and global muscle strength, indicating their potential role in improving exercise recovery and muscle recovery.",
          "link": "https://onlinelibrary.wiley.com/doi/10.1002/jcsm.13132",
          "journal": "J Cachexia",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "2bn-450bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults",
          "year": 2023,
          "author": "Prokopidis, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Prokopidis, et al. · J Cachexia · 2023",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Probiotics significantly improved recovery in adults by supporting immune regulation.",
          "paper_score": 28
        },
        {
          "title": "Live and Heat-Killed Probiotic Lactobacillus paracasei PS23 Accelerated the Improvement and Recovery of Strength and Damage Biomarkers after Exercise-Induced Muscle Damage.",
          "trial_duration": "6 weeks",
          "reasoning": "The study demonstrates that the probiotic Lactobacillus paracasei PS23 significantly improves exercise recovery and muscle recovery by reducing muscle damage and inflammation markers after exercise-induced muscle damage.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36364825",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Probiotics",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "200bn CFU",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "105 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2022,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Lee, et al. · Nutrients · 2022",
          "study_quality_sentence": "A small RCT tracked 105 participants for 6 weeks.",
          "summary_text": "Probiotics substantially improved recovery in healthy adults by strengthening the gut barrier.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Vitamin B12": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "Vitamin B12 status and skeletal muscle function among elderly: A literature review and pilot study on the effect of oral vitamin B12 supplementation in improving muscle function",
          "trial_duration": "3 months",
          "reasoning": "This study directly examines Vitamin B12 and reports significant improvements in muscle strength and quality among elderly participants following supplementation, indicating that Vitamin B12 may aid in exercise recovery and muscle recovery.",
          "link": "https://onlinelibrary.wiley.com/doi/full/10.1002/agm2.12346",
          "journal": "Aging Med.",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Vitamin B12",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "28 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2024,
          "author": "Sharma, et al.",
          "study_type_score": 3,
          "confidence": "medium",
          "study_tag": "Sharma, et al. · Aging Med. · 2024",
          "study_quality_sentence": "A small meta analysis over 3 months, but only included 28 participants.",
          "summary_text": "Vitamin B12 substantially improved recovery in the elderly by enhancing red blood cell production to increase oxygen delivery to tissues.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "The effect of curcumin supplementation on recovery following exercise-induced muscle damage and delayed-onset muscle soreness: A systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines curcumin supplementation and its effects on exercise-induced muscle damage and delayed-onset muscle soreness, demonstrating its potential to aid in exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33174301",
          "journal": "Phytother Res",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Curcumin",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "70mg-2400mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults",
          "year": 2021,
          "author": "Wang, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Wang, et al. · Phytother Res · 2021",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Curcumin substantially enhances recovery in adults by reducing inflammation through the inhibition of NF-kB signaling.",
          "paper_score": 30
        },
        {
          "title": "Evaluation of curcumin intake in reducing exercise-induced muscle damage in athletes: a systematic review",
          "trial_duration": "3 days",
          "reasoning": "This systematic review evaluates the effects of curcumin on exercise-induced muscle damage, highlighting its potential to reduce delayed-onset muscle soreness (DOMS) and improve recovery in athletes, thus supporting curcumin's role in enhancing exercise recovery and muscle recovery.",
          "link": "https://www.tandfonline.com/doi/full/10.1080/15502783.2024.2434217",
          "journal": "J Int Soc Sports",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Curcumin",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "90mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "athletes",
          "year": 2024,
          "author": "Popescu-Radu, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Popescu-Radu, et al. · J Int Soc Sports · 2024",
          "study_quality_sentence": "A large meta analysis over only 3 days, which may limit depth.",
          "summary_text": "Curcumin significantly enhances recovery in athletes by reducing inflammation.",
          "paper_score": 22
        },
        {
          "title": "Curcumin Improves Delayed Onset Muscle Soreness and Postexercise Lactate Accumulation",
          "trial_duration": "10 days",
          "reasoning": "This study demonstrates that Curcumin significantly reduces delayed onset muscle soreness (DOMS) and improves recovery after eccentric exercise, indicating its potential benefits for exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32109179",
          "journal": "J Med Food",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Curcumin",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "30 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2020,
          "author": "Amalraj, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Amalraj, et al. · J Med Food · 2020",
          "study_quality_sentence": "A medium-sized RCT with 30 participants ran for 10 days.",
          "summary_text": "Curcumin significantly improves recovery in healthy adults by limiting exercise induced muscle damage.",
          "paper_score": 23
        }
      ],
      "impact": "Very High"
    },
    "Tongkat Ali": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effects of Eurycoma Longifolia Jack Supplementation Combined with Resistance Training on Isokinetic Muscular Strength and Power, Anaerobic Power, and Urinary Testosterone: Epitestosterone Ratio in Young Males",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Tongkat Ali (Eurycoma longifolia Jack) and reports that its supplementation combined with resistance training improves isokinetic muscular power and peak power output, indicating potential benefits for exercise recovery and muscle recovery.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6639844",
          "journal": "Int J Prev Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Tongkat Ali",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "200mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "40 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "young men",
          "year": 2019,
          "author": "Chen, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Chen, et al. · Int J Prev Med · 2019",
          "study_quality_sentence": "A medium-sized RCT followed 40 participants over 8 weeks.",
          "summary_text": "Tongkat Ali significantly improved recovery in young males by helping lower stress.",
          "paper_score": 22
        },
        {
          "title": "Clinical Study Shows Tongkat Ali Raises Testosterone and Increases Strength in Older Men",
          "trial_duration": "12 weeks",
          "reasoning": "Tongkat Ali has been shown to increase testosterone and muscle strength in older men, which may aid in exercise recovery and muscle recovery.",
          "link": "https://www.nmn.com/news/clinical-study-shows-tongkat-ali-raises-testosterone-and-increases-strength-in-older-men",
          "journal": "Food Nutr Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Tongkat Ali",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100-200mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "105 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older men",
          "year": 2021,
          "author": "Chinnappan et al, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Chinnappan et al, et al. · Food Nutr Res · 2021",
          "study_quality_sentence": "A small RCT followed 105 participants over 12 weeks.",
          "summary_text": "Tongkat Ali significantly improved recovery in older men with low testosterone by supporting hormonal balance.",
          "paper_score": 21
        }
      ],
      "impact": "Moderate"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Acute supplementation with alpha-glycerylphosphorylcholine augments growth hormone response to, and peak force production during, resistance exercise",
          "trial_duration": "acute",
          "reasoning": "This study demonstrates that acute supplementation with Alpha GPC significantly increases growth hormone levels and peak force production during resistance exercise, suggesting it may enhance exercise recovery and muscle recovery.",
          "link": "https://link.springer.com/article/10.1186/1550-2783-5-S1-P15",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Alpha GPC",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600 mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "7 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "experienced male lifters",
          "year": 2008,
          "author": "Ziegenfuss, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Ziegenfuss, et al. · J Int Soc Sports · 2008",
          "study_quality_sentence": "A small RCT tested 7 participants in a single session.",
          "summary_text": "Alpha GPC significantly improved recovery in trained men by supporting muscle repair.",
          "paper_score": 19
        },
        {
          "title": "The effect of 6 days of alpha glycerylphosphorylcholine on isometric strength",
          "trial_duration": "6 days",
          "reasoning": "This study examines Alpha GPC and demonstrates its effectiveness in increasing isometric strength, which is relevant to muscle recovery and exercise performance.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/26582972",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Alpha GPC",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600 mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "13 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "college-aged men",
          "year": 2015,
          "author": "Bellar, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Bellar, et al. · J Int Soc Sports · 2015",
          "study_quality_sentence": "A small RCT tracked 13 participants for 6 days.",
          "summary_text": "Alpha GPC substantially improved recovery in college aged males by helping restore performance after training.",
          "paper_score": 22
        }
      ],
      "impact": "Low"
    },
    "Rhodiola Rosea": {
      "supplement_score": 28.0,
      "papers": [
        {
          "title": "Effects of Rhodiola Rosea Supplementation on Exercise and Sport: A Systematic Review",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review examines Rhodiola Rosea supplementation and its positive effects on exercise recovery and muscle recovery, including reduced muscle damage and pain after exercise.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/35464040",
          "journal": "Front Nutr",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "170–1,500 mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "athletes",
          "year": 2022,
          "author": "Lu, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Lu, et al. · Front Nutr · 2022",
          "study_quality_sentence": "A large meta-analysis combined multiple studies, offering a gold-standard review.",
          "summary_text": "Rhodiola Rosea significantly improved recovery in athletes by reducing cortisol levels to ease stress.",
          "paper_score": 24
        },
        {
          "title": "The effect of Rhodiola rosea supplementation on endurance performance and related biomarkers: a systematic review and meta-analysis",
          "trial_duration": "33 days",
          "reasoning": "This systematic review and meta-analysis demonstrates that Rhodiola Rosea supplementation significantly improves endurance performance and reduces muscle damage markers, indicating its potential benefits for exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/41080184",
          "journal": "Front Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": ">600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "668 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2025,
          "author": "Wang, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Wang, et al. · Front Nutr · 2025",
          "study_quality_sentence": "A gold-standard meta-analysis of 668 participants ran over 33 days.",
          "summary_text": "Rhodiola Rosea substantially improved recovery in healthy participants by supporting resilience under physical and mental strain.",
          "paper_score": 30
        }
      ],
      "impact": "Very High"
    },
    "Inositol": {
      "supplement_score": 24.0,
      "papers": [
        {
          "title": "The benefits of inositol-stabilized arginine silicate as a workout ingredient",
          "trial_duration": "4 days",
          "reasoning": "This study directly examines inositol-stabilized arginine silicate and reports significant findings related to exercise recovery, including decreased muscle damage biomarkers and increased perceived energy and muscle pump post-workout.",
          "link": "https://link.springer.com/article/10.1186/1550-2783-12-S1-P14",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Inositol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "1,500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2015,
          "author": "Rood-Ojalvo, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Rood-Ojalvo, et al. · J Int Soc Sports · 2015",
          "study_quality_sentence": "A small RCT with 16 participants ran for just 4 days.",
          "summary_text": "Inositol substantially improved recovery in healthy adults by supporting mood balance.",
          "paper_score": 24
        },
        {
          "title": "Inositol-Stabilized Arginine Silicate Reduces Exercise Induced Muscle Damage and Increases Perceived Energy",
          "trial_duration": "4 days",
          "reasoning": "Inositol-stabilized arginine silicate significantly reduced exercise-induced muscle damage, as indicated by lower serum creatine kinase and myoglobin levels, suggesting it may aid in exercise recovery and muscle recovery.",
          "link": "https://journalofexerciseandnutrition.com/index.php/JEN/article/view/141",
          "journal": "J Exerc Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Inositol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "1,500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2023,
          "author": "Greenberg, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Greenberg, et al. · J Exerc Nutr · 2023",
          "study_quality_sentence": "A small RCT tracked 16 participants for 4 days.",
          "summary_text": "Inositol significantly enhanced recovery in healthy adults by helping regulate the stress response.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Resveratrol": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "Resveratrol Enhances Exercise-Induced Cellular and Functional Adaptations of Skeletal Muscle in Older Men and Women - PubMed",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that Resveratrol enhances exercise-induced adaptations in skeletal muscle, improving muscle fatigue resistance and strength in older adults, which supports its role in exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/28505227",
          "journal": "J Gerontol A Biol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Resveratrol",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "30 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2017,
          "author": "Alway, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Alway, et al. · J Gerontol A Biol · 2017",
          "study_quality_sentence": "A medium-sized RCT followed 30 participants over 12 weeks.",
          "summary_text": "Resveratrol substantially improved recovery in older adults by supporting cellular repair pathways.",
          "paper_score": 24
        },
        {
          "title": "Resveratrol and exercise combined to treat functional limitations in late life: A pilot randomized controlled trial - PubMed",
          "trial_duration": "12 weeks",
          "reasoning": "This study directly examines Resveratrol in combination with exercise and reports findings relevant to exercise recovery and muscle recovery, indicating potential improvements in physical function and skeletal muscle mitochondrial function in older adults.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33068691",
          "journal": "Exp Gerontol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Resveratrol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg-1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with disabilities",
          "year": 2021,
          "author": "Harper, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Harper, et al. · Exp Gerontol · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 12 weeks.",
          "summary_text": "Resveratrol significantly improved recovery in adults with functional limitations by helping lower inflammation.",
          "paper_score": 22
        },
        {
          "title": "Protective and Recovery Effects of Resveratrol Supplementation on Exercise Performance and Muscle Damage following Acute Plyometric Exercise - PMC",
          "trial_duration": "10 days",
          "reasoning": "This study demonstrates that Resveratrol supplementation can significantly reduce muscle damage and soreness, enhance recovery of muscle performance, and improve exercise capacity following plyometric exercise, indicating its potential benefits for exercise recovery and muscle recovery.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8469037",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Resveratrol",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg,1000mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "36 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "young men",
          "year": 2021,
          "author": "Huang, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Huang, et al. · Nutrients · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 36 participants over 10 days.",
          "summary_text": "Resveratrol substantially improved recovery in young men by reducing oxidative stress.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 24.0,
      "papers": [
        {
          "title": "The effect of calcium supplementation on calcium and bone metabolism during load carriage in women: protocol for a randomised controlled crossover trial - PubMed",
          "trial_duration": "Acute",
          "reasoning": "Calcium supplementation before exercise enhances calcium and bone metabolism, which may aid in exercise recovery and muscle recovery by preventing disruptions to bone and calcium homeostasis.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/39804018",
          "journal": "J Bone Miner Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Calcium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "48 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "women",
          "year": 2025,
          "author": "Coombs, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Coombs, et al. · J Bone Miner Res · 2025",
          "study_quality_sentence": "A medium-sized RCT tested 48 participants in a single session.",
          "summary_text": "Calcium substantially improves recovery in women by enhancing muscle contraction efficiency through calcium ion regulation.",
          "paper_score": 24
        },
        {
          "title": "The Effects of Amorphous Calcium Carbonate (ACC) Supplementation on Resistance Exercise Performance in Women - PubMed",
          "trial_duration": "9 weeks",
          "reasoning": "Amorphous Calcium Carbonate (ACC) supplementation may enhance exercise recovery and muscle recovery by improving resistance exercise performance, as indicated by significant increases in one repetition maximum (1-RM) values in women.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36771244",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Calcium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "100mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "31 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "women",
          "year": 2023,
          "author": "Weinstein, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Weinstein, et al. · Nutrients · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 31 participants over 9 weeks.",
          "summary_text": "Calcium significantly improves recovery in women by aiding muscle contraction and relaxation.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Folic Acid": {
      "supplement_score": 18.5,
      "papers": [
        {
          "title": "Folic acid ingestion improves skeletal muscle blood flow during graded handgrip and plantar flexion exercise in aged humans - PMC",
          "trial_duration": "6 wk",
          "reasoning": "Folic Acid ingestion improves exercise recovery by enhancing skeletal muscle blood flow during exercise, which may aid muscle recovery in aged humans.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5625172",
          "journal": "Am J Physiol Heart",
          "study_type": "observational",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Folic Acid",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "5000mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "9 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2017,
          "author": "Romero, et al.",
          "study_type_score": 1,
          "confidence": "medium",
          "study_tag": "Romero, et al. · Am J Physiol Heart · 2017",
          "study_quality_sentence": "A small observational study tracked 9 participants for 6 weeks.",
          "summary_text": "Folic Acid substantially enhanced recovery in aged adults by promoting DNA synthesis and repair.",
          "paper_score": 18
        }
      ],
      "impact": "Low"
    },
    "Vitamin B2": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "A Placebo-Controlled Trial of Riboflavin for Enhancement of Ultramarathon Recovery.",
          "trial_duration": "Acute",
          "reasoning": "This study directly examines Vitamin B2 (riboflavin) and reports that it may reduce muscle pain and soreness during and after ultramarathon events, thus enhancing exercise recovery and muscle recovery.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/28349501",
          "journal": "Sports Med Open",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Vitamin B2",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2017,
          "author": "Hoffman, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Hoffman, et al. · Sports Med Open · 2017",
          "study_quality_sentence": "A medium-sized RCT tested 32 participants in a single session.",
          "summary_text": "Vitamin B2 significantly improved recovery in athletes by enhancing mitochondrial energy production.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Vitamin B6": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "A functional evaluation of anti-fatigue and exercise performance improvement following vitamin B complex supplementation in healthy humans, a randomized double-blind trial",
          "trial_duration": "28 days",
          "reasoning": "This study directly examines Vitamin B6 as part of a vitamin B complex supplementation and reports significant improvements in exercise endurance performance and reductions in fatigue metabolites, indicating its potential benefits for exercise recovery and muscle recovery.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10542023",
          "journal": "Int J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "recovery",
          "supplement": "Vitamin B6",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "50mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young healthy adults",
          "year": 2023,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Lee, et al. · Int J Med Sci · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 28 days.",
          "summary_text": "Vitamin B6 substantially improved recovery in healthy adults by enhancing neurotransmitter synthesis to reduce muscle fatigue.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin E": {
      "supplement_score": 28.5,
      "papers": [
        {
          "title": "Can Low-Dose of Dietary Vitamin E Supplementation Reduce Exercise-Induced Muscle Damage and Oxidative Stress? A Meta-Analysis of Randomized Controlled Trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This meta-analysis demonstrates that dietary Vitamin E supplementation can significantly reduce exercise-induced muscle damage, as indicated by lower levels of creatine kinase (CK) and lactate dehydrogenase (LDH), particularly when taken in doses of 500 IU or less.",
          "link": "https://www.mdpi.com/2072-6643/14/8/1599",
          "journal": "Nutrients",
          "study_type": "meta_analysis",
          "effect_strength": "moderate",
          "metric": "recovery",
          "supplement": "Vitamin E",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "135mg-593mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2022,
          "author": "Kim, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Kim, et al. · Nutrients · 2022",
          "study_quality_sentence": "A large meta-analysis combined multiple studies.",
          "summary_text": "Vitamin E significantly enhances recovery in athletes by reducing oxidative stress and inflammation.",
          "paper_score": 28
        }
      ],
      "impact": "Very High"
    }
  },
  "training_load": {
    "Ashwagandha": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": null,
      "papers": []
    },
    "Omega 3": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Omega-3 supplementation during unilateral resistance exercise training in older women: A within subject and double-blind placebo-controlled trial",
          "trial_duration": "6 weeks",
          "reasoning": "Omega 3 supplementation may enhance training load and exercise volume tolerance by promoting muscle mass gains and type II fiber hypertrophy during resistance exercise training in older women.",
          "link": "https://www.sciencedirect.com/science/article/pii/S2405457721010548",
          "journal": "Clin Nutr ESPEN",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "training_load",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "3680mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older healthy women",
          "year": 2021,
          "author": "Brook, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Brook, et al. · Clin Nutr ESPEN · 2021",
          "study_quality_sentence": "A small RCT tracked 16 participants for 6 weeks.",
          "summary_text": "Omega 3 significantly improved training load in healthy older women by reducing inflammation in muscles.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Magnesium": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "Effects of magnesium supplementation on muscle soreness in different type of physical activities: a systematic review",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review discusses the impact of magnesium on exercise performance and muscle soreness, relevant to training load tolerance.",
          "link": "https://link.springer.com/article/10.1186/s12967-024-05434-x",
          "journal": "J Transl Med",
          "study_type": "systematic_review",
          "effect_strength": "large",
          "metric": "training_load",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "300mg-500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "73 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2024,
          "author": "Tarsitano, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Tarsitano, et al. · J Transl Med · 2024",
          "study_quality_sentence": "A medium-sized meta-analysis reviewed multiple studies.",
          "summary_text": "Magnesium substantially increased training load in physically active individuals by enhancing muscle contraction efficiency.",
          "paper_score": 26
        },
        {
          "title": "Effects of magnesium supplementation on muscle soreness and performance",
          "trial_duration": "Systematic Review",
          "reasoning": "This review highlights the effects of magnesium on muscle performance and soreness, which relates to exercise volume tolerance.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38970118",
          "journal": "J Transl Med",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "training_load",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "300mg-500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2023,
          "author": "Askari, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Askari, et al. · J Transl Med · 2023",
          "study_quality_sentence": "A large meta-analysis combined multiple studies for a comprehensive review.",
          "summary_text": "Magnesium significantly increased training load in athletes by enhancing muscle energy production through ATP synthesis.",
          "paper_score": 25
        }
      ],
      "impact": "Very High"
    },
    "Zinc": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Effects of zinc supplementation on blood rheology during exercise",
          "trial_duration": "7 days",
          "reasoning": "This study demonstrates that Zinc supplementation improves exercise tolerance by decreasing blood viscosity and perceived exertion during exercise, which is relevant to training load and exercise volume tolerance.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/11185677",
          "journal": "Clin Hemorheol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "training_load",
          "supplement": "Zinc",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "20mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "10 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy men",
          "year": 1999,
          "author": "S Khaled, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "S Khaled, et al. · Clin Hemorheol · 1999",
          "study_quality_sentence": "A small RCT tracked 10 participants for 7 days.",
          "summary_text": "Zinc significantly improved training load in healthy men by reducing exercise-induced oxidative stress.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Iron": {
      "supplement_score": null,
      "papers": []
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Resveratrol": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Resveratrol Enhances Exercise-Induced Cellular and Functional Adaptations of Skeletal Muscle in Older Men and Women",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that Resveratrol enhances exercise-induced adaptations in skeletal muscle, improving muscle fatigue resistance and strength, which are critical for training load and exercise volume tolerance.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/28505227",
          "journal": "J Gerontol A Biol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "training_load",
          "supplement": "Resveratrol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "30 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2017,
          "author": "Alway, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Alway, et al. · J Gerontol A Biol · 2017",
          "study_quality_sentence": "A medium-sized RCT followed 30 participants over 12 weeks.",
          "summary_text": "Resveratrol significantly increased training load in older adults by enhancing mitochondrial efficiency.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effects of vitamins C and E supplementation combined with 12-week resistance training in older women with sarcopenia: A randomized, double-blind, placebo-controlled trial - PubMed",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that Vitamin C supplementation, combined with resistance training, significantly enhances muscle mass and strength in older women with sarcopenia, which may improve training load and exercise volume tolerance.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40859523",
          "journal": "Medicine (Baltimore)",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "training_load",
          "supplement": "Vitamin C",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women with sarcopenia",
          "year": 2025,
          "author": "Liu et al, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Liu et al, et al. · Medicine (Baltimore) · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 12 weeks.",
          "summary_text": "Vitamin C significantly increased training load in older women with sarcopenia by reducing oxidative stress to enhance muscle recovery.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    }
  },
  "workout_effort": {
    "Ashwagandha": {
      "supplement_score": 30.5,
      "papers": [
        {
          "title": "The effect of Ashwagandha (Withania somnifera) on sports performance: a systematic review and meta-analysis",
          "trial_duration": "8-12 weeks",
          "reasoning": "This systematic review and meta-analysis demonstrates that Ashwagandha supplementation significantly improves perceived exertion and workout effort by enhancing VO2max and various physical fitness parameters in athletes.",
          "link": "https://journalofsportsmedicine.org/full-text/752/eng",
          "journal": "Turkish J Sports Med",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "workout_effort",
          "supplement": "Ashwagandha",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "300mg-500mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2025,
          "author": "Jayawardena, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Jayawardena, et al. · Turkish J Sports Med · 2025",
          "study_quality_sentence": "A large meta-analysis combined multiple 8–12 week studies.",
          "summary_text": "Ashwagandha substantially increased workout effort in athletes by reducing cortisol levels to enhance energy availability.",
          "paper_score": 30
        }
      ],
      "impact": "Very High"
    },
    "Magnesium": {
      "supplement_score": null,
      "papers": []
    },
    "Omega 3": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Six weeks of either EPA-rich or DHA-rich Omega-3 supplementation alters submaximal exercise physiology in endurance trained male amateurs",
          "trial_duration": "6 weeks",
          "reasoning": "This study demonstrates that Omega-3 supplementation, specifically EPA and DHA, significantly reduces perceived exertion (RPE) during submaximal exercise, suggesting that Omega-3 may enhance workout effort by making exercise feel less strenuous.",
          "link": "https://www.frontiersin.org/journals/nutrition/articles/10.3389/fnut.2025.1588421/full",
          "journal": "Front Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "workout_effort",
          "supplement": "Omega 3",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "55 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "male endurance athletes",
          "year": 2025,
          "author": "Blannin, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Blannin, et al. · Front Nutr · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 55 participants over 6 weeks.",
          "summary_text": "Omega 3 made a small but significant improvement to workout effort in endurance athletes by reducing muscle soreness.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin D": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effect of vitamin D supplementation on cardiovascular disease risk factors and exercise performance in healthy participants: a randomized placebo-controlled preliminary study",
          "trial_duration": "14 days",
          "reasoning": "This study directly examines Vitamin D supplementation and reports significant improvements in perceived exertion, as measured by the Borg Scale, alongside enhanced workout effort indicated by increased distance cycled.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/27540461",
          "journal": "Ther Adv Endocrinol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Vitamin D",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "50mcg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "15 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2016,
          "author": "Al-Dujaili, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Al-Dujaili, et al. · Ther Adv Endocrinol · 2016",
          "study_quality_sentence": "A small RCT tracked 15 participants over 14 days.",
          "summary_text": "Vitamin D significantly enhanced workout effort in healthy participants by modulating calcium levels for optimal muscle contraction.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Zinc": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Effects of zinc supplementation on blood rheology during exercise - PubMed",
          "trial_duration": "7 days",
          "reasoning": "This study shows that Zinc supplementation reduces perceived exertion during exercise, as indicated by a lower Borg scale rating after Zinc compared to placebo, suggesting that Zinc may enhance workout effort.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/11185677",
          "journal": "Clin Hemorheol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Zinc",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "20mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "10 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy men",
          "year": 1999,
          "author": "S Khaled, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "S Khaled, et al. · Clin Hemorheol · 1999",
          "study_quality_sentence": "A small RCT tracked 10 participants for 7 days.",
          "summary_text": "Zinc significantly improved workout effort in healthy men by reducing exercise-induced oxidative stress.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Iron": {
      "supplement_score": 23.83,
      "papers": [
        {
          "title": "Randomized, double-blind, placebo-controlled trial of iron supplementation in female soldiers during military training: effects on iron status, physical performance, and mood - PubMed",
          "trial_duration": "8-wk",
          "reasoning": "This study examines iron supplementation and its effects on physical performance, specifically reporting improved running times and mood in female soldiers, indicating that iron may help reduce perceived exertion and enhance workout effort.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/19474138",
          "journal": "Am J Clin Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Iron",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "219 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "female soldiers",
          "year": 2009,
          "author": "McClung, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "McClung, et al. · Am J Clin Nutr · 2009",
          "study_quality_sentence": "A large RCT followed 219 participants over 8 weeks.",
          "summary_text": "Iron significantly improved workout effort in female soldiers by reducing fatigue during exertion.",
          "paper_score": 24
        },
        {
          "title": "Iron supplementation improves endurance after training in iron-depleted, nonanemic women | Journal of Applied Physiology | American Physiological Society",
          "trial_duration": "6 wk",
          "reasoning": "This study demonstrates that iron supplementation improves perceived exertion and workout effort by enhancing endurance capacity in iron-depleted, nonanemic women, as evidenced by faster completion times in a 15-km time trial.",
          "link": "https://journals.physiology.org/doi/full/10.1152/jappl.2000.88.3.1103",
          "journal": "J Appl Physiol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Iron",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "42 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "iron-depleted women",
          "year": 2000,
          "author": "Hinton, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Hinton, et al. · J Appl Physiol · 2000",
          "study_quality_sentence": "A medium-sized RCT followed 42 participants over 6 weeks.",
          "summary_text": "Iron significantly improved workout effort in iron depleted, nonanemic women by increasing hemoglobin to support oxygen transport.",
          "paper_score": 21
        },
        {
          "title": "Influence of iron supplementation on fatigue, mood states and sweating profiles of healthy non-anemic athletes during a training exercise: A double-blind, randomized, placebo-controlled, parallel-group study - PMC",
          "trial_duration": "4 weeks",
          "reasoning": "This study directly examines Iron supplementation and its effects on perceived exertion and workout effort, showing that low-dose Iron can significantly reduce feelings of tiredness and improve mood states among non-anemic athletes during exercise.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9932653",
          "journal": "Contemp Clin Trials",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "3.6mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "93 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy athletes",
          "year": 2023,
          "author": "Kapoor, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Kapoor, et al. · Contemp Clin Trials · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 93 participants over 4 weeks.",
          "summary_text": "Iron significantly enhanced workout effort in athletes by improving aerobic capacity.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "CoQ10": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "Effectiveness of Coenzyme Q10 Supplementation for Reducing Fatigue: A Systematic Review and Meta-Analysis of Randomized Controlled Trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that CoQ10 supplementation significantly reduces fatigue, which is directly related to perceived exertion and workout effort.",
          "link": "https://www.frontiersin.org/journals/pharmacology/articles/10.3389/fphar.2022.883251/full",
          "journal": "Front Pharmacol",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "CoQ10",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "30mg-500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "1126 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy adults",
          "year": 2022,
          "author": "Tsai, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Tsai, et al. · Front Pharmacol · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "CoQ10 significantly enhanced workout effort in healthy and diseased individuals by increasing cellular energy production through ATP synthesis.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Probiotics": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "Effects of Probiotic Supplementation on Exercise with Predominance of Aerobic Metabolism in Trained Population: A Systematic Review, Meta-Analysis and Meta-Regression",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrate that probiotic supplementation can have a small but significant positive effect on performance tests with aerobic metabolism predominance, suggesting that probiotics may help improve perceived exertion and workout effort in trained individuals.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8840281",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "workout_effort",
          "supplement": "Probiotics",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "1bn-100bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "232 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "active athletes",
          "year": 2022,
          "author": "Santibañez-Gutierrez, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Santibañez-Gutierrez, et al. · Nutrients · 2022",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Probiotics made a small but significant improvement to workout effort in athletes by optimizes nutrient absorption.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "The Effects of Curcumin Supplementation on Muscle Damage, Oxidative Stress, and Inflammatory Markers in Healthy Females with Moderate Physical Activity: A Randomized, Double-Blind, Placebo-Controlled Clinical Trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Curcumin supplementation significantly improves VO2 max, which is related to perceived exertion and workout effort, in healthy females with moderate physical activity.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8428303",
          "journal": "Int J Prev Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Curcumin",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "80 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active women",
          "year": 2021,
          "author": "Salehi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Salehi, et al. · Int J Prev Med · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 80 participants over 8 weeks.",
          "summary_text": "Curcumin significantly enhanced workout effort in active women by reducing muscle inflammation.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Evaluation of the effects of two doses of alpha glycerylphosphorylcholine on physical and psychomotor performance",
          "trial_duration": "7 days",
          "reasoning": "This study directly examines Alpha GPC and reports findings relevant to perceived exertion and workout effort, showing that supplementation can enhance physical performance metrics like countermovement jump, which relates to workout effort.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/29042830",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "workout_effort",
          "supplement": "Alpha GPC",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "500mg-250mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "48 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "college-aged men",
          "year": 2017,
          "author": "Marcus, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Marcus, et al. · J Int Soc Sports · 2017",
          "study_quality_sentence": "A medium-sized RCT followed 48 participants over 7 days.",
          "summary_text": "Alpha GPC made a small but significant improvement to workout effort in healthy males by increasing acetylcholine levels in the brain.",
          "paper_score": 21
        },
        {
          "title": "The effect of 6 days of alpha glycerylphosphorylcholine on isometric strength",
          "trial_duration": "6 days",
          "reasoning": "This study examines Alpha GPC and its effects on isometric strength, which is relevant to perceived exertion and workout effort, indicating that Alpha GPC may enhance performance in strength-related activities.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/26582972",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Alpha GPC",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "600mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "13 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "college-aged men",
          "year": 2015,
          "author": "Bellar, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Bellar, et al. · J Int Soc Sports · 2015",
          "study_quality_sentence": "A small RCT tracked 13 participants for 6 days.",
          "summary_text": "Alpha GPC significantly enhanced workout effort in college aged males by supporting stronger muscle contractions.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "The benefits of inositol-stabilized arginine silicate as a workout ingredient",
          "trial_duration": "4 days",
          "reasoning": "This study demonstrates that Inositol-stabilized arginine silicate significantly increases perceived energy and decreases perceived fatigue during workouts, indicating its potential to enhance perceived exertion and workout effort.",
          "link": "https://link.springer.com/article/10.1186/1550-2783-12-S1-P14",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Inositol",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "1,500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2015,
          "author": "Rood-Ojalvo, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Rood-Ojalvo, et al. · J Int Soc Sports · 2015",
          "study_quality_sentence": "A small RCT with 16 participants ran for 4 days.",
          "summary_text": "Inositol significantly enhanced workout effort in healthy adults by modulating insulin sensitivity to improve energy utilization.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "A functional evaluation of anti-fatigue and exercise performance improvement following vitamin B complex supplementation in healthy humans, a randomized double-blind trial",
          "trial_duration": "28 days",
          "reasoning": "This study demonstrates that Vitamin B2, as part of a vitamin B complex supplementation, significantly improves perceived exertion and workout effort by enhancing exercise endurance performance and reducing fatigue metabolites in healthy humans.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10542023",
          "journal": "Int J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Vitamin B2",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "10 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young healthy adults",
          "year": 2023,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Lee, et al. · Int J Med Sci · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 28 days.",
          "summary_text": "Vitamin B2 significantly improved workout effort in healthy adults by enhancing mitochondrial efficiency.",
          "paper_score": 22
        },
        {
          "title": "A Placebo-Controlled Trial of Riboflavin for Enhancement of Ultramarathon Recovery",
          "trial_duration": "10 days",
          "reasoning": "This study directly examines Vitamin B2 (riboflavin) and reports findings that suggest it may reduce perceived muscle pain and soreness during and after ultramarathon running, thereby potentially enhancing workout effort.",
          "link": "https://sportsmedicine-open.springeropen.com/articles/10.1186/s40798-017-0081-4",
          "journal": "Sports Med Open",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Vitamin B2",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2017,
          "author": "Hoffman, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Hoffman, et al. · Sports Med Open · 2017",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 10 days.",
          "summary_text": "Vitamin B2 significantly enhanced workout effort in athletes by supporting cellular energy production.",
          "paper_score": 21
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin B6": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "A functional evaluation of anti-fatigue and exercise performance improvement following vitamin B complex supplementation in healthy humans, a randomized double-blind trial",
          "trial_duration": "28 days",
          "reasoning": "This study demonstrates that Vitamin B6, as part of a Vitamin B complex supplementation, significantly improves perceived exertion and workout effort by enhancing exercise endurance performance and reducing fatigue metabolites in healthy humans.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10542023",
          "journal": "Int J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Vitamin B6",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "50mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young healthy adults",
          "year": 2023,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Lee, et al. · Int J Med Sci · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 28 days.",
          "summary_text": "Vitamin B6 significantly enhanced workout effort in healthy adults by optimizing neurotransmitter synthesis for better muscle coordination.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin C": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Vitamin C status and perception of effort during exercise in obese adults adhering to a calorie-reduced diet",
          "trial_duration": "4 wk",
          "reasoning": "This study directly examines Vitamin C and its effects on perceived exertion during exercise, showing that Vitamin C supplementation significantly decreased Ratings of Perceived Exertion in obese adults.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/22677357",
          "journal": "Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_effort",
          "supplement": "Vitamin C",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "20 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight adults",
          "year": 2013,
          "author": "Huck, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Huck, et al. · Nutr · 2013",
          "study_quality_sentence": "A small RCT tracked 20 participants for 4 weeks.",
          "summary_text": "Vitamin C significantly increased workout effort in obese adults by reducing oxidative stress in muscles.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    }
  },
  "rhr": {
    "Omega 3": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "DHA-Rich Fish Oil Increases the Omega-3 Index in Healthy Adults and Slows Resting Heart Rate without Altering Cardiac Autonomic Reflex Modulation.",
          "trial_duration": "8 weeks",
          "reasoning": "This study shows that DHA-rich fish oil supplementation significantly slows resting heart rate in healthy adults, indicating that Omega 3 may positively influence resting heart rate.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/34379997",
          "journal": "J Am Nutr Assoc",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rhr",
          "supplement": "Omega 3",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "2000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "20 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2022,
          "author": "Macartney, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Macartney, et al. · J Am Nutr Assoc · 2022",
          "study_quality_sentence": "A small RCT tracked 20 participants for 8 weeks.",
          "summary_text": "Omega 3 significantly lowered resting heart rate in healthy adults by enhancing vagal tone to improve autonomic regulation.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Ashwagandha": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": null,
      "papers": []
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": 17.5,
      "papers": [
        {
          "title": "Vitamin B12 supplementation improves heart rate variability in healthy elderly Indian subjects",
          "trial_duration": "3 months",
          "reasoning": "Vitamin B12 supplementation improves resting heart rate variability in healthy elderly individuals, suggesting a beneficial effect on heart rate.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/22226502",
          "journal": "Auton Neurosci",
          "study_type": "observational",
          "effect_strength": "moderate",
          "metric": "rhr",
          "supplement": "Vitamin B12",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "47 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older healthy Indians",
          "year": 2012,
          "author": "Sucharita, et al.",
          "study_type_score": 1,
          "confidence": "medium",
          "study_tag": "Sucharita, et al. · Auton Neurosci · 2012",
          "study_quality_sentence": "A medium-sized observational study tracked 47 participants over 3 months.",
          "summary_text": "Vitamin B12 significantly lowered RHR in healthy elderly Indians by enhancing red blood cell production to improve oxygen transport.",
          "paper_score": 17
        }
      ],
      "impact": "Low"
    },
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "L-Theanine reduces psychological and physiological stress responses",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that L-Theanine intake significantly reduces heart rate in response to acute stress, suggesting it may help lower resting heart rate.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/16930802",
          "journal": "Biol Psychol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "rhr",
          "supplement": "L-Theanine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "12 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2007,
          "author": "Kimura, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Kimura, et al. · Biol Psychol · 2007",
          "study_quality_sentence": "A small RCT tested 12 participants in a single session.",
          "summary_text": "L-Theanine substantially reduced resting heart rate in healthy adults by lowering sympathetic nervous system activity.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Alpha GPC": {
      "supplement_score": 17.5,
      "papers": [
        {
          "title": "The Effects of Alpha-Glycerylphosphorylcholine on Heart Rate Variability and Hemodynamic Variables Following Sprint Interval Exercise in Overweight and Obese Women - PubMed",
          "trial_duration": "Acute",
          "reasoning": "This study directly examines Alpha-GPC and reports that it improves heart rate variability (HRV) and hemodynamic responses, suggesting a potential benefit for resting heart rate recovery following exercise.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36235623",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rhr",
          "supplement": "Alpha GPC",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "12 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight women",
          "year": 2022,
          "author": "Barzanjeh, et al.",
          "study_type_score": 2,
          "confidence": "low",
          "study_tag": "Barzanjeh, et al. · Nutrients · 2022",
          "study_quality_sentence": "A small RCT tested 12 participants in a single session.",
          "summary_text": "Alpha GPC significantly RHR in overweight women by improving parasympathetic nervous system activity.",
          "paper_score": 17
        }
      ],
      "impact": "Low"
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin E": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Chronic administration of pharmacologic doses of vitamin E improves the cardiac autonomic nervous system in patients with type 2 diabetes",
          "trial_duration": "4 mo",
          "reasoning": "Chronic administration of Vitamin E improves cardiac autonomic function, which is linked to resting heart rate, in patients with type 2 diabetes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/11382659/",
          "journal": "Am J Clin Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rhr",
          "supplement": "Vitamin E",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "50 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with diabetes",
          "year": 2001,
          "author": "Manzella, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Manzella, et al. · Am J Clin Nutr · 2001",
          "study_quality_sentence": "A medium-sized RCT followed 50 participants over 4 months.",
          "summary_text": "Vitamin E significantly reduced resting heart rate in patients with type 2 diabetes by decreasing oxidative stress on the cardiovascular system.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    }
  },
  "hrv": {
    "Omega 3": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "Short-term effects of fish-oil supplementation on heart rate variability in humans: a meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This meta-analysis directly examines fish oil (Omega 3) supplementation and its effects on heart rate variability, showing that it may enhance vagal tone, which is beneficial for heart rate variability.",
          "link": "https://www.sciencedirect.com/science/article/pii/S0002916523054977",
          "journal": "Am J Clin Nutr",
          "study_type": "meta_analysis",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "Omega 3",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "640-5900mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "general population",
          "year": 2013,
          "author": "Wei, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Wei, et al. · Am J Clin Nutr · 2013",
          "study_quality_sentence": "A large meta-analysis combined multiple studies.",
          "summary_text": "Omega 3 significantly improved HRV in various human subjects by reducing inflammation.",
          "paper_score": 26
        },
        {
          "title": "Effects of Omega-3 Fatty Acid Supplementation on Heart Rate Variability at Rest and During Acute Stress in Adults With Moderate Hypertriglyceridemia - PMC",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Omega-3 fatty acids (EPA and DHA) and reports that high-dose supplementation significantly improves heart rate variability (HRV) at rest and during stress, suggesting a potential benefit for cardiovascular health.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3681100",
          "journal": "Psychosom Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "Omega 3",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "850-3400mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "26 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy adults",
          "year": 2013,
          "author": "Sauder, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Sauder, et al. · Psychosom Med · 2013",
          "study_quality_sentence": "A small RCT tracked 26 participants for 8 weeks.",
          "summary_text": "Omega 3 significantly improved heart rate variability in healthy adults by supporting autonomic balance.",
          "paper_score": 21
        }
      ],
      "impact": "High"
    },
    "Ashwagandha": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Exploring the efficacy and safety of a novel standardized ashwagandha (Withania somnifera) root extract (Witholytin®) in adults experiencing high stress and fatigue in a randomized, double-blind, placebo-controlled trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that Ashwagandha supplementation is associated with a significant increase in heart rate variability, suggesting potential benefits for heart health and autonomic nervous system function.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/37740662",
          "journal": "J Psychopharmacol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "400mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "90 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight older adults",
          "year": 2023,
          "author": "Smith, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Smith, et al. · J Psychopharmacol · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 90 participants over 12 weeks.",
          "summary_text": "Ashwagandha significantly improved heart rate variability in overweight adults by supporting stress resilience.",
          "paper_score": 21
        },
        {
          "title": "Ashwagandha Extract May Offer Anti-Fatigue Benefits to Overweight Subjects",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that Ashwagandha extract may improve heart rate variability (HRV) by 9.1% in overweight adults experiencing stress and fatigue, suggesting potential benefits for cardiovascular health.",
          "link": "https://www.nutraceuticalsworld.com/breaking-news/ashwagandha-extract-may-offer-anti-fatigue-benefits-to-overweight-subjects",
          "journal": "J Psychopharmacol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "400mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "111 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight older adults",
          "year": 2025,
          "author": "Choudhary, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Choudhary, et al. · J Psychopharmacol · 2025",
          "study_quality_sentence": "A large RCT followed 111 participants over 12 weeks.",
          "summary_text": "Ashwagandha significantly improved heart rate variability in overweight adults by lowering cortisol.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Magnesium": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "[Long-term HRV analysis shows stress reduction by magnesium intake] - PubMed",
          "trial_duration": "90 days",
          "reasoning": "This study demonstrates that magnesium supplementation can improve heart rate variability (HRV) by enhancing parasympathetic activity and balancing the autonomic nervous system, suggesting a beneficial effect of magnesium on HRV.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/27933574",
          "journal": "MMW Fortschr Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "hrv",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "400mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "100 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "stressed adults",
          "year": 2016,
          "author": "Wienecke, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Wienecke, et al. · MMW Fortschr Med · 2016",
          "study_quality_sentence": "A small RCT tracked 100 participants over 90 days.",
          "summary_text": "Magnesium substantially improved heart rate variability in stressed individuals by reducing cortisol levels.",
          "paper_score": 25
        },
        {
          "title": "Effect of Magnesium on Heart Rate Variability in Healthy Subjects - Brilla - 2010 - The FASEB Journal",
          "trial_duration": "6 weeks",
          "reasoning": "This study directly examines Magnesium and its effects on heart rate variability, showing that Magnesium supplementation can enhance vagal activity and reduce sympathetic responses, which may improve heart rate variability.",
          "link": "https://faseb.onlinelibrary.wiley.com/doi/abs/10.1096/fasebj.24.1_supplement.917.3",
          "journal": "FASEB J",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "36 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2010,
          "author": "Brilla, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Brilla, et al. · FASEB J · 2010",
          "study_quality_sentence": "A medium-sized RCT followed 36 participants over 6 weeks.",
          "summary_text": "Magnesium significantly improved HRV in active individuals by reducing sympathetic nervous system activity.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Vitamin D": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 27.5,
      "papers": [
        {
          "title": "Iron Supplementation Benefits Physical Performance in Women of Reproductive Age: A Systematic Review and Meta-Analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "Iron supplementation may improve heart rate variability as indicated by a significant reduction in heart rate during submaximal exercise performance in women of reproductive age.",
          "link": "https://www.sciencedirect.com/science/article/pii/S0022316622009129",
          "journal": "J Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "30-100mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy women",
          "year": 2014,
          "author": "Pasricha, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Pasricha, et al. · J Nutr · 2014",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Iron significantly improved heart rate variability in women by enhancing parasympathetic nervous system activity.",
          "paper_score": 27
        }
      ],
      "impact": "Very High"
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Multi-species probiotic supplement enhances vagal nerve function – results of a randomized controlled trial in patients with depression and healthy controls",
          "trial_duration": "3 months",
          "reasoning": "This study demonstrates that a multi-species probiotic supplement can enhance vagal nerve function, which is directly linked to improved heart rate variability in patients with depression.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40298641",
          "journal": "Gut Microbes",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "15bn CFU",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "86 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with depression",
          "year": 2025,
          "author": "Mörkl, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Mörkl, et al. · Gut Microbes · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 86 participants over 3 months.",
          "summary_text": "Probiotics significantly improved HRV in patients with depression and healthy controls by modulating the gut-brain axis.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin B12": {
      "supplement_score": 19.5,
      "papers": [
        {
          "title": "Vitamin B12 supplementation improves heart rate variability in healthy elderly Indian subjects",
          "trial_duration": "3 months",
          "reasoning": "Vitamin B12 supplementation significantly improves heart rate variability in healthy elderly individuals, suggesting that it may enhance autonomic function and cardiovascular health.",
          "link": "https://www.autonomicneuroscience.com/article/S1566-0702(11)00514-5/pdf",
          "journal": "Auton Neurosci",
          "study_type": "observational",
          "effect_strength": "large",
          "metric": "hrv",
          "supplement": "Vitamin B12",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "47 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy older Indians",
          "year": 2012,
          "author": "Sucharita, et al.",
          "study_type_score": 1,
          "confidence": "medium",
          "study_tag": "Sucharita, et al. · Auton Neurosci · 2012",
          "study_quality_sentence": "A medium-sized observational study tracked 47 participants over 3 months.",
          "summary_text": "Vitamin B12 substantially improved heart rate variability in healthy elderly Indians by enhancing autonomic nervous system balance.",
          "paper_score": 19
        }
      ],
      "impact": "Low"
    },
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Effects of L-theanine or caffeine intake on changes in blood pressure under physical and psychological stresses",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that L-Theanine significantly attenuates blood pressure increases during psychological stress, suggesting it may help improve heart rate variability by reducing stress-induced cardiovascular responses.",
          "link": "https://link.springer.com/article/10.1186/1880-6805-31-28",
          "journal": "J Physiol Anthropol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "L-Theanine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "14 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2012,
          "author": "Yoto, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Yoto, et al. · J Physiol Anthropol · 2012",
          "study_quality_sentence": "A small RCT tested 14 participants in a single session.",
          "summary_text": "L-Theanine significantly improved heart rate variability in healthy adults by reducing sympathetic nervous system activity.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Alpha GPC": {
      "supplement_score": 19.5,
      "papers": [
        {
          "title": "The Effects of Alpha-Glycerylphosphorylcholine on Heart Rate Variability and Hemodynamic Variables Following Sprint Interval Exercise in Overweight and Obese Women.",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that Alpha GPC improves heart rate variability (HRV) in overweight and obese women following exercise, suggesting it may enhance cardiac autonomic function.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36235623",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "hrv",
          "supplement": "Alpha GPC",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "12 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight women",
          "year": 2022,
          "author": "Barzanjeh, et al.",
          "study_type_score": 2,
          "confidence": "low",
          "study_tag": "Barzanjeh, et al. · Nutrients · 2022",
          "study_quality_sentence": "A small RCT tested 12 participants in a single session.",
          "summary_text": "Alpha GPC significantly HRV in overweight women by improving parasympathetic nervous system activity.",
          "paper_score": 19
        }
      ],
      "impact": "Low"
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": 19.5,
      "papers": [
        {
          "title": "The catecholamine precursor Tyrosine reduces autonomic arousal and decreases decision thresholds in reinforcement learning and temporal discounting.",
          "trial_duration": "Acute",
          "reasoning": "This study directly examines L-Tyrosine and reports findings relevant to heart rate variability, showing that L-Tyrosine supplementation reduces heart rate and physiological arousal, which may positively influence heart rate variability.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36548401",
          "journal": "PLoS Comput Biol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "L-Tyrosine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "2000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "28 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy men",
          "year": 2022,
          "author": "Mathar, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Mathar, et al. · PLoS Comput Biol · 2022",
          "study_quality_sentence": "A small RCT tested 28 participants in a single session.",
          "summary_text": "L-Tyrosine significantly improved heart rate variability in healthy men by increasing dopamine synthesis to enhance autonomic balance.",
          "paper_score": 19
        }
      ],
      "impact": "Low"
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "B-vitamin Supplementation Mitigates Effects of Fine Particles on Cardiac Autonomic Dysfunction and Inflammation: A Pilot Human Intervention Trial.",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that Vitamin B6 supplementation can significantly mitigate the adverse effects of PM2.5 exposure on heart rate variability (HRV) in healthy adults, suggesting a potential benefit of Vitamin B6 for improving HRV.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/28367952",
          "journal": "Sci Rep",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "hrv",
          "supplement": "Vitamin B6",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "50mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "10 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2017,
          "author": "Zhong et al, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Zhong et al, et al. · Sci Rep · 2017",
          "study_quality_sentence": "A small RCT tested 10 participants in a single session.",
          "summary_text": "Vitamin B6 substantially increased heart rate variability in healthy adults by enhancing neurotransmitter synthesis.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Vitamin C": {
      "supplement_score": 18.5,
      "papers": [
        {
          "title": "Effect of acute administration of vitamin C on muscle sympathetic activity, cardiac sympathovagal balance, and baroreflex sensitivity in hypertensive patients",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that acute administration of Vitamin C can reduce muscle sympathetic nerve activity and restore sympathovagal balance in hypertensive patients, suggesting a positive effect on heart rate variability.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/22695870",
          "journal": "Am J Clin Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hrv",
          "supplement": "Vitamin C",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "52 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with high blood pressure",
          "year": 2012,
          "author": "Bruno, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Bruno, et al. · Am J Clin Nutr · 2012",
          "study_quality_sentence": "A medium-sized RCT tested 52 participants in a single session.",
          "summary_text": "Vitamin C significantly improved heart rate variability in hypertensive patients by reducing oxidative stress on the cardiovascular system.",
          "paper_score": 18
        }
      ],
      "impact": "Low"
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    }
  },
  "strain": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 27.0,
      "papers": [
        {
          "title": "Effects of Ashwagandha (Withania somnifera) on stress and anxiety: A systematic review and meta-analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Ashwagandha and reports significant effects on stress and anxiety, which are relevant to physiological strain and training stress.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/39348746",
          "journal": "Explore (NY)",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "NA Meta Analysis",
          "dose_used": "125–600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "558 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Meta analysis",
          "who_was_studied": "hospital patients",
          "year": 2024,
          "author": "Arumugam, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Arumugam, et al. · Explore (NY) · 2024",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Ashwagandha significantly reduced strain in patients by supporting resilience to stress.",
          "paper_score": 28
        },
        {
          "title": "A double-blind, randomized, placebo-controlled trial on the effect of Ashwagandha (Withania somnifera dunal.) root extract in improving cardiorespiratory endurance and recovery in healthy athletic adults",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Ashwagandha root extract significantly improves cardiorespiratory endurance and recovery in healthy athletic adults, indicating its potential benefits for physiological strain and training stress.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33600918",
          "journal": "J Ethnopharmacol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "50 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active adults",
          "year": 2021,
          "author": "Tiwari, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Tiwari, et al. · J Ethnopharmacol · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 50 participants over 8 weeks.",
          "summary_text": "Ashwagandha significantly reduced strain in athletes by lowering cortisol levels.",
          "paper_score": 24
        }
      ],
      "impact": "Very High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Calcium and vitamin D supplementation decreases incidence of stress fractures in female navy recruits",
          "trial_duration": "8 weeks",
          "reasoning": "Calcium supplementation significantly reduces the incidence of stress fractures in female navy recruits, indicating its potential to help manage physiological strain and training stress during rigorous physical training.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/18433305",
          "journal": "J Bone Miner Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Calcium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "2000mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "5201 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "female navy recruits",
          "year": 2008,
          "author": "Lappe, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Lappe, et al. · J Bone Miner Res · 2008",
          "study_quality_sentence": "A large RCT with 5201 participants ran over 8 weeks.",
          "summary_text": "Calcium significantly reduced strain in female navy recruits by strengthening bone density to better withstand physical stress.",
          "paper_score": 24
        },
        {
          "title": "The Impact of Acute Calcium Intake on Bone Turnover Markers during a Training Day in Elite Male Rowers",
          "trial_duration": "2 trials",
          "reasoning": "This study directly examines Calcium and its impact on physiological strain and training stress by showing that preexercise intake of calcium-rich meals can stabilize blood ionized calcium levels during exercise, thereby reducing markers of bone resorption and potentially safeguarding bone health in elite male rowers.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9770130",
          "journal": "Med Sci Sports Exerc",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Calcium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "male rowers",
          "year": 2022,
          "author": "Lundy, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Lundy, et al. · Med Sci Sports Exerc · 2022",
          "study_quality_sentence": "A small RCT with 16 participants ran for 2 trials.",
          "summary_text": "Calcium significantly reduced strain in elite rowers by enhancing muscle contraction efficiency.",
          "paper_score": 19
        }
      ],
      "impact": "Moderate"
    },
    "CoQ10": {
      "supplement_score": 26.83,
      "papers": [
        {
          "title": "Coenzyme Q10 Supplementation in Athletes: A Systematic Review",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review directly examines CoQ10 supplementation and its effects on physiological strain and training stress in athletes, reporting improvements in antioxidant activity and reductions in fatigue indicators.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/37764774",
          "journal": "Nutrients",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "CoQ10",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "30mg-300mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "adult athletes",
          "year": 2023,
          "author": "Fernandes, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Fernandes, et al. · Nutrients · 2023",
          "study_quality_sentence": "A large meta-analysis combined multiple studies.",
          "summary_text": "CoQ10 significantly reduced strain in athletes by improving cellular energy output.",
          "paper_score": 25
        },
        {
          "title": "The effects of coenzyme Q10 supplementation on biomarkers of exercise-induced muscle damage, physical performance, and oxidative stress: A GRADE-assessed systematic review and dose-response meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "CoQ10 supplementation significantly reduces biomarkers of exercise-induced muscle damage and oxidative stress, which are directly related to physiological strain and training stress.",
          "link": "https://www.sciencedirect.com/science/article/abs/pii/S2405457724000184",
          "journal": "Clin Nutr ESPEN",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "CoQ10",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "300mg-400mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "830 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults",
          "year": 2024,
          "author": "Talebi, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Talebi, et al. · Clin Nutr ESPEN · 2024",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "CoQ10 significantly reduced strain in adults by supporting overall energy metabolism.",
          "paper_score": 28
        },
        {
          "title": "Short-term CoQ10 supplementation reduces markers of cardiac stress in soccer players following heavy exercise: A randomized double-blind placebo-controlled trial",
          "trial_duration": "30 days",
          "reasoning": "This study demonstrates that CoQ10 supplementation significantly reduces cardiac stress markers and improves time to fatigue in professional soccer players, indicating its potential benefits for managing physiological strain and training stress.",
          "link": "https://link.springer.com/article/10.1186/s13102-025-01456-0",
          "journal": "BMC Sports Sci Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "CoQ10",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "soccer players",
          "year": 2026,
          "author": "Rahimi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Rahimi, et al. · BMC Sports Sci Med · 2026",
          "study_quality_sentence": "A small RCT tracked 16 participants for 30 days.",
          "summary_text": "CoQ10 significantly reduced strain in soccer players by helping muscles recover from repeated high intensity efforts.",
          "paper_score": 23
        }
      ],
      "impact": "Very High"
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 25.83,
      "papers": [
        {
          "title": "Iron supplementation benefits physical performance in women of reproductive age: A systematic review and meta-analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "Iron supplementation significantly improves both maximal and submaximal exercise performance, which directly relates to physiological strain and training stress in women of reproductive age.",
          "link": "https://www.sciencedirect.com/science/article/pii/S0022316622009129",
          "journal": "J Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "10mg-325mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy women",
          "year": 2014,
          "author": "Pasricha, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Pasricha, et al. · J Nutr · 2014",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Iron significantly reduced strain in women by improving oxygen delivery.",
          "paper_score": 28
        },
        {
          "title": "Randomized, double-blind, placebo-controlled trial of iron supplementation in female soldiers during military training: effects on iron status, physical performance, and mood",
          "trial_duration": "8-wk",
          "reasoning": "This study directly examines Iron supplementation and its effects on physiological strain and training stress in female soldiers during military training, showing improvements in physical performance and mood.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/19474138",
          "journal": "Am J Clin Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "219 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "female soldiers",
          "year": 2009,
          "author": "McClung, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "McClung, et al. · Am J Clin Nutr · 2009",
          "study_quality_sentence": "A large RCT followed 219 participants over 8 weeks.",
          "summary_text": "Iron significantly reduced strain in female soldiers by supporting muscular endurance.",
          "paper_score": 24
        },
        {
          "title": "Iron supplementation improves endurance after training in iron-depleted, nonanemic women",
          "trial_duration": "6 wk",
          "reasoning": "Iron supplementation improves physiological strain by enhancing endurance in iron-depleted women, demonstrating its relevance to training stress outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/10710409",
          "journal": "J Appl Physiol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "42 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "iron-depleted women",
          "year": 2000,
          "author": "Hinton, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Hinton, et al. · J Appl Physiol · 2000",
          "study_quality_sentence": "A medium-sized RCT followed 42 participants over 6 weeks.",
          "summary_text": "Iron significantly reduced strain in iron depleted women by correcting low iron status.",
          "paper_score": 21
        }
      ],
      "impact": "Very High"
    },
    "L-Theanine": {
      "supplement_score": 21.0,
      "papers": [
        {
          "title": "L-Theanine reduces psychological and physiological stress responses",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that L-Theanine significantly reduces physiological stress responses, such as heart rate and salivary immunoglobulin A, during acute stress tasks, indicating its potential to help manage physiological strain and training stress.",
          "link": "https://www.sciencedirect.com/science/article/abs/pii/S0301051106001451",
          "journal": "Biol Psychol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "L-Theanine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "12 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "college-aged men",
          "year": 2007,
          "author": "Kimura, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Kimura, et al. · Biol Psychol · 2007",
          "study_quality_sentence": "A small RCT tested 12 participants in a single session.",
          "summary_text": "L-Theanine significantly reduced strain in male undergraduates by lowering cortisol levels.",
          "paper_score": 19
        },
        {
          "title": "A Randomized, Triple-Blind, Placebo-Controlled, Crossover Study to Investigate the Efficacy of a Single Dose of AlphaWave® L-Theanine on Stress in a Healthy Adult Population",
          "trial_duration": "Acute",
          "reasoning": "This study directly examines AlphaWave® L-Theanine and reports significant effects on stress reduction, as indicated by changes in salivary cortisol and brainwave activity, suggesting it may help alleviate physiological strain and training stress.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/34562208",
          "journal": "Neurol Ther",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "L-Theanine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "stressed healthy adults",
          "year": 2021,
          "author": "Evans, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Evans, et al. · Neurol Ther · 2021",
          "study_quality_sentence": "A small RCT tested 16 participants in a single session.",
          "summary_text": "L-Theanine significantly reduced strain in healthy, moderately stressed adults by modulating alpha brain wave activity to promote relaxation.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "L-Tyrosine": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Tyrosine improves cognitive performance and reduces blood pressure in cadets after one week of a combat training course",
          "trial_duration": "1 week",
          "reasoning": "This study shows that L-Tyrosine supplementation can improve cognitive performance and reduce blood pressure in cadets undergoing a combat training course, suggesting it may help mitigate physiological strain and training stress.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/10230711",
          "journal": "Brain Res Bull",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "L-Tyrosine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "2000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "21 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "military trainees",
          "year": 1999,
          "author": "Deijen, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Deijen, et al. · Brain Res Bull · 1999",
          "study_quality_sentence": "A small RCT tracked 21 participants for 1 week.",
          "summary_text": "L-Tyrosine significantly reduced strain in cadets by increasing dopamine levels to enhance cognitive resilience.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Magnesium": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Impact of magnesium supplementation, in combination with vitamin B6, on stress and magnesium status: secondary data from a randomized controlled trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that magnesium supplementation significantly reduces stress levels in individuals with low magnesium status, indicating a potential benefit of magnesium for managing physiological strain and training stress.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33210604",
          "journal": "Magnes Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "300mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "264 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "stressed adults with low magnesium",
          "year": 2020,
          "author": "Noah, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Noah, et al. · Magnes Res · 2020",
          "study_quality_sentence": "A large RCT followed 264 participants over 8 weeks.",
          "summary_text": "Magnesium significantly reduced strain in healthy adults with low magnesemia and severe stress by lowering cortisol levels.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Omega 3": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": null,
      "papers": []
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "A randomized, double-blind, placebo-controlled, parallel-group study of the standardised extract shr-5 of the roots of Rhodiola rosea in the treatment of subjects with stress-related fatigue",
          "trial_duration": "28 days",
          "reasoning": "This study directly examines Rhodiola Rosea and reports significant effects on stress-related fatigue, which is relevant to physiological strain and training stress.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/19016404",
          "journal": "Planta Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "576mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "adults aged 20-55",
          "year": 2009,
          "author": "Olsson, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Olsson, et al. · Planta Med · 2009",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 28 days.",
          "summary_text": "Rhodiola Rosea significantly reduced strain in adults by modulating cortisol levels to decrease stress.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Short-term dietary curcumin supplementation reduces gastrointestinal barrier damage and physiological strain responses during exertional heat stress",
          "trial_duration": "3 days",
          "reasoning": "This study demonstrates that short-term dietary curcumin supplementation reduces physiological strain responses, including core temperature and heart rate, during exertional heat stress, suggesting that curcumin may help mitigate physiological strain and training stress.",
          "link": "https://journals.physiology.org/doi/full/10.1152/japplphysiol.00515.2017",
          "journal": "J Appl Physiol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Curcumin",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "8 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2017,
          "author": "Szymanski, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Szymanski, et al. · J Appl Physiol · 2017",
          "study_quality_sentence": "A small RCT with 8 participants ran over 3 days.",
          "summary_text": "Curcumin significantly reduced strain in healthy adults by lowering inflammation through the inhibition of NF-kB.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": 23.0,
      "papers": [
        {
          "title": "Effect of magnesium and vitamin B6 supplementation on mental health and quality of life in stressed healthy adults: Post-hoc analysis of a randomised controlled trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Vitamin B6 in combination with magnesium and reports improvements in anxiety, depression, and quality of life, which are relevant to physiological strain and training stress.",
          "link": "https://onlinelibrary.wiley.com/doi/10.1002/smi.3051",
          "journal": "Stress Health",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Vitamin B6",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "30mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "264 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2021,
          "author": "Noah, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Noah, et al. · Stress Health · 2021",
          "study_quality_sentence": "A large RCT followed 264 participants over 8 weeks.",
          "summary_text": "Vitamin B6 significantly reduced strain in healthy adults by supporting neurotransmitter synthesis to regulate stress response.",
          "paper_score": 23
        },
        {
          "title": "Superiority of magnesium and vitamin B6 over magnesium alone on severe stress in healthy adults with low magnesemia: A randomized, single-blind clinical trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Vitamin B6 in combination with magnesium and reports findings relevant to physiological strain, specifically stress reduction in healthy adults with low magnesium levels.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/30562392",
          "journal": "PLoS One",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Vitamin B6",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "30mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "264 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy adults with low magnesium",
          "year": 2018,
          "author": "Pouteau, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Pouteau, et al. · PLoS One · 2018",
          "study_quality_sentence": "A large RCT followed 264 participants over 8 weeks.",
          "summary_text": "Vitamin B6 significantly reduced strain in healthy adults with low magnesemia by helping support mood regulation.",
          "paper_score": 21
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin C": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effects of vitamins C and E supplementation combined with 12-week resistance training in older women with sarcopenia: A randomized, double-blind, placebo-controlled trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study directly examines Vitamin C and its effects on physiological strain and training stress by showing that Vitamin C supplementation combined with resistance training significantly improves muscle mass and strength in older women with sarcopenia.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40859523",
          "journal": "Medicine (Baltimore)",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Vitamin C",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women with sarcopenia",
          "year": 2025,
          "author": "Liu, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Liu, et al. · Medicine (Baltimore) · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 12 weeks.",
          "summary_text": "Vitamin C significantly improved strain in older women with sarcopenia by enhancing collagen synthesis to strengthen muscle fibers.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin D": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin E": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Vitamin E supplementation attenuates leakage of enzymes following 6 successive days of running training",
          "trial_duration": "6 days",
          "reasoning": "Vitamin E supplementation may help reduce physiological strain and training stress by attenuating muscle damage, as indicated by lower serum levels of creatine kinase and lactate dehydrogenase following endurance running.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/10950448",
          "journal": "Int J Sports Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "strain",
          "supplement": "Vitamin E",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "520mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "14 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "male runners",
          "year": 2000,
          "author": "Itoh, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Itoh, et al. · Int J Sports Med · 2000",
          "study_quality_sentence": "A small RCT tracked 14 participants for 6 days.",
          "summary_text": "Vitamin E significantly reduced strain in male runners by decreasing oxidative stress.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    }
  },
  "hr_zones": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": 19.5,
      "papers": [
        {
          "title": "The Effects of Alpha-Glycerylphosphorylcholine on Heart Rate Variability and Hemodynamic Variables Following Sprint Interval Exercise in Overweight and Obese Women - PMC",
          "trial_duration": "Acute",
          "reasoning": "This study directly examines Alpha GPC and its effects on heart rate variability and hemodynamic responses during and after sprint interval exercise, indicating that Alpha GPC may help improve recovery of heart rate zones during exercise.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9572742",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "hr_zones",
          "supplement": "Alpha GPC",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "12 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight women",
          "year": 2022,
          "author": "Barzanjeh, et al.",
          "study_type_score": 2,
          "confidence": "low",
          "study_tag": "Barzanjeh, et al. · Nutrients · 2022",
          "study_quality_sentence": "A small RCT tested 12 participants in a single session.",
          "summary_text": "Alpha GPC substantially improved HR Zones in overweight women by enhancing cardiovascular efficiency.",
          "paper_score": 19
        }
      ],
      "impact": "Low"
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "A double-blind, randomized, placebo-controlled trial on the effect of Ashwagandha (Withania somnifera dunal.) root extract in improving cardiorespiratory endurance and recovery in healthy athletic adults",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Ashwagandha root extract significantly improves cardiorespiratory endurance, which is directly related to heart rate zones during exercise, as measured by VO2 max in healthy athletic adults.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33600918",
          "journal": "J Ethnopharmacol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hr_zones",
          "supplement": "Ashwagandha",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "600 mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "50 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active adults",
          "year": 2021,
          "author": "Tiwari, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Tiwari, et al. · J Ethnopharmacol · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 50 participants over 8 weeks.",
          "summary_text": "Ashwagandha significantly improved heart rate zones in athletes by reducing cortisol levels to enhance cardiovascular efficiency.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Calcium Supplementation Attenuates Disruptions in Calcium Homeostasis during Exercise - PMC",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that Calcium supplementation before exercise can help mitigate the decrease in serum ionized calcium and the increase in parathyroid hormone, which are important for maintaining heart rate zones during exercise.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5474134",
          "journal": "Med Sci Sports Exerc",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hr_zones",
          "supplement": "Calcium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "51 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "male cyclists",
          "year": 2017,
          "author": "Sherk, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Sherk, et al. · Med Sci Sports Exerc · 2017",
          "study_quality_sentence": "A medium-sized RCT tested 51 participants in a single session.",
          "summary_text": "Calcium significantly improved heart rate zones in competitive male cyclists by enhancing calcium ion availability for muscle contraction efficiency.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": 18.5,
      "papers": [
        {
          "title": "Folic acid ingestion improves skeletal muscle blood flow during graded handgrip and plantar flexion exercise in aged humans",
          "trial_duration": "6 wk",
          "reasoning": "Folic Acid ingestion improves blood flow and vascular conductance during exercise, which may enhance heart rate zones during exercise in aged humans.",
          "link": "https://journals.physiology.org/doi/full/10.1152/ajpheart.00234.2017",
          "journal": "Am J Physiol Heart",
          "study_type": "observational",
          "effect_strength": "moderate",
          "metric": "hr_zones",
          "supplement": "Folic Acid",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "5000mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "9 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older adults",
          "year": 2017,
          "author": "Romero, et al.",
          "study_type_score": 1,
          "confidence": "medium",
          "study_tag": "Romero, et al. · Am J Physiol Heart · 2017",
          "study_quality_sentence": "A small observational study tracked 9 participants for 6 weeks.",
          "summary_text": "Folic Acid significantly improved heart rate zones in aged adults by enhancing red blood cell production to improve oxygen delivery.",
          "paper_score": 18
        }
      ],
      "impact": "Low"
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "L-Theanine reduces psychological and physiological stress responses",
          "trial_duration": "Acute",
          "reasoning": "This study shows that L-Theanine intake reduces heart rate responses during a stress task, suggesting it may help manage heart rate zones during exercise.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/16930802",
          "journal": "Biol Psychol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hr_zones",
          "supplement": "L-Theanine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "12 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2007,
          "author": "Kimura, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Kimura, et al. · Biol Psychol · 2007",
          "study_quality_sentence": "A small RCT tested 12 participants in a single session.",
          "summary_text": "L-Theanine significantly improved heart rate zones in healthy adults by reducing cortisol levels to decrease stress.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": null,
      "papers": []
    },
    "Omega 3": {
      "supplement_score": 26.17,
      "papers": [
        {
          "title": "Fish oil reduces heart rate and oxygen consumption during exercise",
          "trial_duration": "8 weeks",
          "reasoning": "This study shows that Omega 3 from fish oil supplementation reduces heart rate during exercise, which is directly relevant to understanding heart rate zones during exercise.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/19034030",
          "journal": "J Cardiovasc",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "hr_zones",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "8000mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "male cyclists",
          "year": 2008,
          "author": "Peoples, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Peoples, et al. · J Cardiovasc · 2008",
          "study_quality_sentence": "A small RCT tracked 16 participants for 8 weeks.",
          "summary_text": "Omega 3 substantially improved heart rate zones in well trained men by reducing inflammation.",
          "paper_score": 22
        },
        {
          "title": "Six weeks of either EPA-rich or DHA-rich Omega-3 supplementation alters submaximal exercise physiology in endurance trained male amateurs",
          "trial_duration": "6 weeks",
          "reasoning": "This study demonstrates that Omega-3 supplementation, specifically EPA and DHA, significantly lowers submaximal exercise heart rate, indicating potential benefits for managing heart rate zones during exercise.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12417169",
          "journal": "Front Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "hr_zones",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "55 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "male endurance athletes",
          "year": 2025,
          "author": "Blannin, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Blannin, et al. · Front Nutr · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 55 participants over 6 weeks.",
          "summary_text": "Omega 3 substantially improved heart rate zones in endurance athletes by supporting aerobic efficiency.",
          "paper_score": 26
        },
        {
          "title": "Effect of omega-3 long-chain polyunsaturated fatty acid supplementation on heart rate: a meta-analysis of randomized controlled trials",
          "trial_duration": "2 weeks-1 year",
          "reasoning": "This meta-analysis demonstrates that omega-3 long-chain polyunsaturated fatty acid supplementation significantly reduces heart rate, which is relevant for understanding how omega-3 may influence heart rate zones during exercise.",
          "link": "https://www.nature.com/articles/s41430-017-0052-3",
          "journal": "Eur J Clin Nutr",
          "study_type": "meta_analysis",
          "effect_strength": "moderate",
          "metric": "hr_zones",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500-15000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "3000 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with health conditions",
          "year": 2018,
          "author": "Hidayat, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Hidayat, et al. · Eur J Clin Nutr · 2018",
          "study_quality_sentence": "A large, gold-standard meta-analysis reviewed multiple studies over 2 weeks to 1 year.",
          "summary_text": "Omega 3 significantly improved heart rate zones in adults by improving blood vessel function.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Probiotics": {
      "supplement_score": null,
      "papers": []
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "The effects of an acute dose of Rhodiola rosea on endurance exercise performance",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that Rhodiola Rosea ingestion significantly decreases heart rate during submaximal exercise, which is relevant to understanding heart rate zones during exercise.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/23443221",
          "journal": "J Strength Cond Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "hr_zones",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "210mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "18 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active men",
          "year": 2013,
          "author": "Noreen, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Noreen, et al. · J Strength Cond Res · 2013",
          "study_quality_sentence": "A small RCT tested 18 participants in a single session.",
          "summary_text": "Rhodiola Rosea substantially improved heart rate zones in active men by reducing cortisol levels to enhance endurance.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": 17.5,
      "papers": [
        {
          "title": "Vitamin B12 supplementation improves heart rate variability in healthy elderly Indian subjects",
          "trial_duration": "3 months",
          "reasoning": "Vitamin B12 supplementation improves heart rate variability, which is closely related to heart rate zones during exercise, particularly in elderly individuals with low vitamin B12 status.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/22226502",
          "journal": "Auton Neurosci",
          "study_type": "observational",
          "effect_strength": "moderate",
          "metric": "hr_zones",
          "supplement": "Vitamin B12",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "47 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy older Indians",
          "year": 2012,
          "author": "Sucharita, et al.",
          "study_type_score": 1,
          "confidence": "medium",
          "study_tag": "Sucharita, et al. · Auton Neurosci · 2012",
          "study_quality_sentence": "A medium-sized observational study tracked 47 participants over 3 months.",
          "summary_text": "Vitamin B12 significantly improved heart rate zones in healthy elderly Indians by enhancing red blood cell production to improve oxygen delivery.",
          "paper_score": 17
        }
      ],
      "impact": "Low"
    },
    "Vitamin B2": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "A functional evaluation of anti-fatigue and exercise performance improvement following vitamin B complex supplementation in healthy humans, a randomized double-blind trial - PMC",
          "trial_duration": "28 days",
          "reasoning": "This study demonstrates that Vitamin B2, as part of a vitamin B complex supplementation, significantly improves exercise endurance performance and reduces fatigue, which is relevant to optimizing heart rate zones during exercise.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10542023",
          "journal": "Int J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "hr_zones",
          "supplement": "Vitamin B2",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "10 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young healthy adults",
          "year": 2023,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Lee, et al. · Int J Med Sci · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 28 days.",
          "summary_text": "Vitamin B2 substantially improved heart rate zones in healthy adults by enhancing mitochondrial energy production.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effect of vitamin D supplementation on cardiovascular disease risk factors and exercise performance in healthy participants: a randomized placebo-controlled preliminary study",
          "trial_duration": "14 days",
          "reasoning": "This study investigates the effects of Vitamin D supplementation on exercise performance, specifically noting improvements in distance cycled and reduced perceived exertion, which are relevant to heart rate zones during exercise.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/27540461",
          "journal": "Ther Adv Endocrinol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hr_zones",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "50mcg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "15 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2016,
          "author": "Al-Dujaili, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Al-Dujaili, et al. · Ther Adv Endocrinol · 2016",
          "study_quality_sentence": "A small RCT tracked 15 participants for 14 days.",
          "summary_text": "Vitamin D significantly improved heart rate zones in healthy participants by enhancing calcium regulation for better muscle contraction.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Effects of zinc supplementation on blood rheology during exercise",
          "trial_duration": "7 days",
          "reasoning": "Zinc supplementation may improve heart rate zones during exercise by enhancing erythrocyte deformability and decreasing exercise-induced increases in blood viscosity, leading to better exercise tolerance.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/11185677",
          "journal": "Clin Hemorheol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "hr_zones",
          "supplement": "Zinc",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "20mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "10 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy men",
          "year": 1999,
          "author": "S Khaled, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "S Khaled, et al. · Clin Hemorheol · 1999",
          "study_quality_sentence": "A small RCT tracked 10 participants for 7 days.",
          "summary_text": "Zinc significantly improved HR zones in healthy men by enhancing cardiovascular efficiency.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    }
  },
  "workout_duration": {
    "Acetyl L-Carnitine": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Acetyl-L-carnitine Slows the Progression from Prefrailty to Frailty in Older Subjects: A Randomized Interventional Clinical Trial",
          "trial_duration": "3 months",
          "reasoning": "This RCT used acetyl L-carnitine (ALCAR) specifically and measured 6-minute walking distance as a functional exercise duration endpoint. The treated group showed a significant increase in 6-walking distance (p<0.001) compared to placebo, reflecting improved capacity to sustain ambulatory exercise. The 6-minute walk test is a widely accepted timed endurance test that directly maps to workout duration in older and clinical populations.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36043711",
          "journal": "Curr Pharm Des",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_duration",
          "supplement": "Acetyl L-Carnitine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "92 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "pre-frail older adults",
          "year": 2022,
          "author": "Malaguarnera, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Malaguarnera, et al. · Curr Pharm Des · 2022",
          "study_quality_sentence": "A medium-sized RCT followed 92 participants over 3 months.",
          "summary_text": "Acetyl L-Carnitine significantly increased workout duration in older adults by enhancing mitochondrial energy production.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": null,
      "papers": []
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "The benefits of inositol-stabilized arginine silicate as a workout ingredient",
          "trial_duration": "4 days",
          "reasoning": "This study demonstrates that inositol-stabilized arginine silicate can significantly enhance perceived energy and reduce fatigue during workouts, suggesting potential benefits for workout duration and endurance.",
          "link": "https://link.springer.com/article/10.1186/1550-2783-12-S1-P14",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_duration",
          "supplement": "Inositol",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "1,500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2015,
          "author": "Rood-Ojalvo, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Rood-Ojalvo, et al. · J Int Soc Sports · 2015",
          "study_quality_sentence": "A small RCT tracked 16 participants for 4 days.",
          "summary_text": "Inositol significantly increased workout duration in healthy adults by enhancing insulin sensitivity to improve energy utilization.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Iron": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Iron supplementation improves endurance after training in iron-depleted, nonanemic women",
          "trial_duration": "6 wk",
          "reasoning": "Iron supplementation significantly improved workout duration and endurance in iron-depleted, nonanemic women, as evidenced by a greater decrease in 15-km cycling time compared to the placebo group.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/10710409",
          "journal": "J Appl Physiol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "workout_duration",
          "supplement": "Iron",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "42 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "iron-depleted women",
          "year": 2000,
          "author": "Hinton, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Hinton, et al. · J Appl Physiol · 2000",
          "study_quality_sentence": "A medium-sized RCT followed 42 participants over 6 weeks.",
          "summary_text": "Iron significantly increased workout duration in iron-depleted women by enhancing mitochondrial efficiency for better energy production.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": null,
      "papers": []
    },
    "Omega 3": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": null,
      "papers": []
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": 19.5,
      "papers": [
        {
          "title": "Acute Rhodiola rosea intake can improve endurance exercise performance",
          "trial_duration": "acute",
          "reasoning": "Acute Rhodiola Rosea intake can improve workout duration and endurance, as evidenced by increased time to exhaustion and enhanced VO2peak during endurance exercise.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/15256690",
          "journal": "Int J Sport Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "workout_duration",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "200mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "36 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "young healthy people",
          "year": 2004,
          "author": "De Bock, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "De Bock, et al. · Int J Sport Nutr · 2004",
          "study_quality_sentence": "A medium-sized RCT tested 36 participants in a single session.",
          "summary_text": "Rhodiola Rosea made a small but significant improvement to workout duration in young healthy volunteers by modulating cortisol levels.",
          "paper_score": 19
        }
      ],
      "impact": "Low"
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    }
  },
  "stress": {
    "Acetyl L-Carnitine": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Acetyl-L-Carnitine Ameliorates Metabolic and Endocrine Alterations in Women with PCOS: A Double-Blind Randomized Clinical Trial",
          "trial_duration": "12 weeks",
          "reasoning": "This RCT included an acetyl L-carnitine arm and measured perceived stress directly using the validated Perceived Stress Scale (PSS14). The combo group receiving ALC showed significant improvement in PSS scores (p<0.001) compared to the non-ALC group, framing stress as a primary outcome. The Profile of Mood States (POMS) was also used as a subjective stress/mood measure, confirming that ALC contributed directly to reduced perceived psychological stress in this population.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/34047916",
          "journal": "Adv Ther",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Acetyl L-Carnitine",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "147 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "women with PCOS",
          "year": 2021,
          "author": "Ndefo, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Ndefo, et al. · Adv Ther · 2021",
          "study_quality_sentence": "A large RCT followed 147 participants over 12 weeks.",
          "summary_text": "Acetyl L-Carnitine significantly reduced stress in women with PCOS by lowering cortisol levels.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "A Prospective, Randomized Double-Blind, Placebo-Controlled Study of Safety and Efficacy of a High-Concentration Full-Spectrum Extract of Ashwagandha Root in Reducing Stress and Anxiety in Adults",
          "trial_duration": "60 days",
          "reasoning": "This study demonstrates that a high-concentration full-spectrum extract of Ashwagandha root significantly reduces stress and serum cortisol levels in adults, indicating its efficacy in managing stress-related outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/23439798",
          "journal": "Indian J Psychol Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "stress",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "64 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults",
          "year": 2012,
          "author": "K Chandrasekhar, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "K Chandrasekhar, et al. · Indian J Psychol Med · 2012",
          "study_quality_sentence": "A medium-sized RCT followed 64 participants over 60 days.",
          "summary_text": "Ashwagandha substantially reduced stress in adults by lowering cortisol levels.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Effect of Iron Supplementation on the Modulation of Iron Metabolism, Muscle Damage Biomarkers and Cortisol in Professional Cyclists",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that iron supplementation (80 mg/day) significantly reduced cortisol levels in elite cyclists during a high-stress competition, indicating a potential benefit of iron for managing stress and cortisol-related outcomes.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6470682",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "80mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "18 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "male cyclists",
          "year": 2019,
          "author": "Córdova, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Córdova, et al. · Nutrients · 2019",
          "study_quality_sentence": "A small RCT tracked 18 participants for 4 weeks.",
          "summary_text": "Iron significantly reduced stress in elite cyclists by lowering cortisol levels.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "L-Theanine": {
      "supplement_score": 22.0,
      "papers": [
        {
          "title": "L-Theanine reduces psychological and physiological stress responses",
          "trial_duration": "Acute",
          "reasoning": "This study demonstrates that L-Theanine intake significantly reduces psychological and physiological stress responses, including heart rate and salivary immunoglobulin A, indicating its potential benefits for stress and cortisol-related outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/16930802",
          "journal": "Biol Psychol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "L-Theanine",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "12 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2007,
          "author": "Kimura, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Kimura, et al. · Biol Psychol · 2007",
          "study_quality_sentence": "A small RCT tested 12 participants in a single session.",
          "summary_text": "L Theanine significantly reduced stress in healthy adults by supporting relaxation without drowsiness.",
          "paper_score": 21
        },
        {
          "title": "A Randomized, Triple-Blind, Placebo-Controlled, Crossover Study to Investigate the Efficacy of a Single Dose of AlphaWave® L-Theanine on Stress in a Healthy Adult Population",
          "trial_duration": "Acute",
          "reasoning": "This study directly examines AlphaWave® L-Theanine and reports significant decreases in salivary cortisol and increases in brain alpha power, indicating potential benefits for stress and cortisol-related outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/34562208",
          "journal": "Neurol Ther",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "L-Theanine",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "200mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "16 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "stressed healthy adults",
          "year": 2021,
          "author": "Evans, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Evans, et al. · Neurol Ther · 2021",
          "study_quality_sentence": "A small RCT tested 16 participants in a single session.",
          "summary_text": "L Theanine significantly reduced stress in healthy adults by promoting a calmer mental state.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Impact of magnesium supplementation, in combination with vitamin B6, on stress and magnesium status: secondary data from a randomized controlled trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that magnesium supplementation significantly reduced stress in severely stressed individuals, indicating that magnesium may help improve stress and cortisol-related outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33210604",
          "journal": "Magnes Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "300mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "264 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with low magnesium",
          "year": 2020,
          "author": "Noah, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Noah, et al. · Magnes Res · 2020",
          "study_quality_sentence": "A large RCT followed 264 participants over 8 weeks.",
          "summary_text": "Magnesium significantly reduced stress in adults by regulating cortisol levels.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Omega 3": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "Effect of Probiotics Supplementation on Cortisol Levels: A Systematic Review and Meta-Analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that probiotics supplementation may reduce cortisol levels, indicating a potential benefit for stress-related outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/39458560",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "stress",
          "supplement": "Probiotics",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "3bn-900bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "3516 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy people",
          "year": 2024,
          "author": "Jain, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Jain, et al. · Nutrients · 2024",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Probiotics made a small but significant improvement to stress in healthy adults by modulating the gut-brain axis.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "The effectiveness and efficacy of Rhodiola rosea L.: A systematic review of randomized clinical trials",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review evaluates the effectiveness of Rhodiola Rosea in randomized clinical trials, highlighting its potential benefits on stress-related conditions and cortisol response, making it relevant for stress and cortisol-related outcomes.",
          "link": "https://www.sciencedirect.com/science/article/abs/pii/S0944711310002680",
          "journal": "Phytomedicine",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "NA Meta Analysis",
          "dose_used": "50mg-1500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Meta analysis",
          "who_was_studied": "adults with health conditions",
          "year": 2011,
          "author": "Hung, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Hung, et al. · Phytomedicine · 2011",
          "study_quality_sentence": "A large gold-standard meta-analysis reviewed multiple studies.",
          "summary_text": "Rhodiola Rosea significantly reduces stress in various clinical populations by modulating cortisol levels.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Tongkat Ali": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Effect of Tongkat Ali on stress hormones and psychological mood state in moderately stressed subjects",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that Tongkat Ali supplementation significantly reduces cortisol levels and improves mood states such as tension, anger, and confusion, indicating its potential benefits for stress and cortisol-related outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/23705671",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Tongkat Ali",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "200mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "63 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "stressed adults",
          "year": 2013,
          "author": "Talbott, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Talbott, et al. · J Int Soc Sports · 2013",
          "study_quality_sentence": "A medium-sized RCT followed 63 participants over 4 weeks.",
          "summary_text": "Tongkat Ali significantly reduced stress in moderately stressed subjects by lowering cortisol levels.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Curcumin": {
      "supplement_score": 25.0,
      "papers": [
        {
          "title": "A systematic review of the antidepressant effects of curcumin: Beyond monoamines theory",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review demonstrates that Curcumin can improve depressive and anxiety behaviors in humans, and notably, it reduces cortisol levels, linking it directly to stress and cortisol-related outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33673739",
          "journal": "Aust N Z J",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Curcumin",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "80mg-2000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with depression",
          "year": 2021,
          "author": "Matias, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Matias, et al. · Aust N Z J · 2021",
          "study_quality_sentence": "A large gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Curcumin significantly reduced stress in patients with depression and anxiety by easing psychological symptoms.",
          "paper_score": 23
        },
        {
          "title": "Curcumin and major depression: A randomised, double-blind, placebo-controlled trial investigating the potential of peripheral biomarkers to predict treatment response and antidepressant mechanisms of change",
          "trial_duration": "6 weeks",
          "reasoning": "This study directly examines Curcumin and reports significant findings related to stress and cortisol-related outcomes, specifically showing that Curcumin supplementation decreases salivary cortisol concentrations in patients with major depressive disorder.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/26066335",
          "journal": "J Clin Psychopharm",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Curcumin",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "108 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "middle-aged men",
          "year": 2015,
          "author": "Yu, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Yu, et al. · J Clin Psychopharm · 2015",
          "study_quality_sentence": "A large RCT followed 108 participants over 6 weeks.",
          "summary_text": "Curcumin significantly reduced stress in men by lowering cortisol levels.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Vitamin B12": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "A Systematic Review and Meta-Analysis of B Vitamin Supplementation on Depressive Symptoms, Anxiety, and Stress: Effects on Healthy and ‘At-Risk’ Individuals",
          "trial_duration": "4 weeks",
          "reasoning": "This systematic review and meta-analysis directly examines B vitamin supplementation, including Vitamin B12, and reports a significant benefit for stress outcomes, indicating that Vitamin B12 may help reduce stress.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31527485",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "stress",
          "supplement": "Vitamin B12",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "2.4-800mcg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "2015 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy and at-risk adults",
          "year": 2019,
          "author": "Young, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Young, et al. · Nutrients · 2019",
          "study_quality_sentence": "A gold-standard meta-analysis reviewed multiple studies over 4 weeks.",
          "summary_text": "Vitamin B12 made a small but significant improvement to stress in healthy and at-risk populations by reducing homocysteine levels.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Vitamin B2": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Impact of Vitamin B1 and Vitamin B2 Supplementation on Anxiety, Stress, and Sleep Quality: A Randomized, Double-Blind, Placebo-Controlled Trial",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that Vitamin B2 supplementation significantly reduces perceived stress and improves sleep quality, which are directly related to stress and cortisol-related outcomes.",
          "link": "https://naturalhealthresearch.org/vitamin-b1-and-b2-supplementation-reduces-perceived-stress-improves-sleep-quality-and-daytime-alertness-but-does-not-significantly-affect-anxiety-in-young-adults",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Vitamin B2",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "43 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "young Chinese students",
          "year": 2025,
          "author": "Tao, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Tao, et al. · Nutrients · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 43 participants over 4 weeks.",
          "summary_text": "Vitamin B2 significantly reduced stress in Chinese students by modulating cortisol levels.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "A randomized controlled trial of high dose ascorbic acid for reduction of blood pressure, cortisol, and subjective responses to psychological stress",
          "trial_duration": "14 days",
          "reasoning": "This study directly examines high-dose ascorbic acid (Vitamin C) and reports findings relevant to stress and cortisol-related outcomes, showing that it reduces subjective stress responses and improves cortisol recovery after psychological stress.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/11862365",
          "journal": "Psychopharmacology",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "stress",
          "supplement": "Vitamin C",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young adults",
          "year": 2002,
          "author": "Brody, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Brody, et al. · Psychopharmacology · 2002",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 14 days.",
          "summary_text": "Vitamin C significantly reduced stress in healthy young adults by lowering cortisol levels.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Vitamin D": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    }
  },
  "sleep_quality": {
    "Acetyl L-Carnitine": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Acetyl L-carnitine (ALC) treatment in elderly patients with fatigue",
          "trial_duration": "6 months",
          "reasoning": "This RCT administered acetyl L-carnitine specifically and measured sleep disorders as a distinct named outcome. By end of treatment, sleep disorders improved significantly in the ALCAR group vs placebo (28% vs 4%, p<0.05), representing a clear sleep quality improvement tied directly to the ALCAR intervention. The study framed sleep disorders as one of several fatigue-related quality-of-life outcomes, with the result constituting a direct measure of sleep improvement.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/17658628",
          "journal": "Arch Gerontol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Acetyl L-Carnitine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "2000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "96 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "elderly patients with fatigue",
          "year": 2008,
          "author": "Malaguarnera, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Malaguarnera, et al. · Arch Gerontol · 2008",
          "study_quality_sentence": "A medium-sized RCT followed 96 participants over 6 months.",
          "summary_text": "Acetyl L-Carnitine significantly improved sleep quality in elderly patients by reducing oxidative stress in the brain.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 25.17,
      "papers": [
        {
          "title": "Effect of Ashwagandha (Withania somnifera) extract on sleep: A systematic review and meta-analysis",
          "trial_duration": "8 weeks",
          "reasoning": "This systematic review and meta-analysis directly examines Ashwagandha (Withania somnifera) and reports significant findings indicating its effectiveness in improving sleep quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/41140145",
          "journal": "BJPsych Open",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "713 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "people with mental disorders",
          "year": 2025,
          "author": "Marchi, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Marchi, et al. · BJPsych Open · 2025",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple 8-week studies.",
          "summary_text": "Ashwagandha significantly improved sleep quality in individuals with mental disorders by supporting nervous system regulation.",
          "paper_score": 26
        },
        {
          "title": "A randomized, double blind, placebo controlled study to evaluate the effects of ashwagandha (Withania somnifera) extract on sleep quality in healthy adults",
          "trial_duration": "6 weeks",
          "reasoning": "This study demonstrates that ashwagandha extract significantly improves sleep quality in healthy adults, as evidenced by increased self-reported sleep quality and objective measures of sleep efficiency, total sleep time, and sleep latency.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32540634",
          "journal": "Sleep Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "120 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "150 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2020,
          "author": "Deshpande, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Deshpande, et al. · Sleep Med · 2020",
          "study_quality_sentence": "A large RCT followed 150 participants over 6 weeks.",
          "summary_text": "Ashwagandha significantly improved sleep quality in healthy adults by lowering cortisol.",
          "paper_score": 23
        },
        {
          "title": "Efficacy and Safety of Ashwagandha (Withania somnifera) Root Extract in Insomnia and Anxiety: A Double-blind, Randomized, Placebo-controlled Study",
          "trial_duration": "10 weeks",
          "reasoning": "This study demonstrates that Ashwagandha root extract significantly improves sleep quality and sleep onset latency in patients with insomnia, suggesting its potential as an effective natural remedy for enhancing sleep quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31728244",
          "journal": "Cureus",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with insomnia",
          "year": 2019,
          "author": "Langade, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Langade, et al. · Cureus · 2019",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 10 weeks.",
          "summary_text": "Ashwagandha significantly improved sleep quality in patients with insomnia and anxiety by promoting calmer sleep onset.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effects of vitamin D and/or calcium intervention on sleep quality in individuals with prediabetes: a post hoc analysis of a randomized controlled trial",
          "trial_duration": "24 weeks",
          "reasoning": "This study directly examines Calcium and reports significant findings related to sleep quality, indicating that Calcium supplementation may improve sleep quality in individuals with prediabetes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38366270",
          "journal": "Eur J Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Calcium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "212 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with prediabetes",
          "year": 2024,
          "author": "Miao, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Miao, et al. · Eur J Nutr · 2024",
          "study_quality_sentence": "A large RCT followed 212 participants over 24 weeks.",
          "summary_text": "Calcium significantly improved sleep quality in individuals with prediabetes by regulating melatonin production.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "The Effect of Parenteral or Oral Iron Supplementation on Fatigue, Sleep, Quality of Life and Restless Legs Syndrome in Iron-Deficient Blood Donors: A Secondary Analysis of the IronWoMan RCT - PubMed",
          "trial_duration": "8-12 weeks",
          "reasoning": "This study directly examines Iron supplementation and reports significant improvements in sleep quality among iron-deficient blood donors, indicating that Iron may help enhance sleep quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32380660",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "176 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "iron-deficient blood donors",
          "year": 2020,
          "author": "Macher, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Macher, et al. · Nutrients · 2020",
          "study_quality_sentence": "A large RCT followed 176 participants over 8–12 weeks.",
          "summary_text": "Iron significantly improved sleep quality in blood donors by reducing restless leg syndrome through increased dopamine synthesis.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "L-Theanine": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "The effects of L-theanine consumption on sleep outcomes: A systematic review and meta-analysis.",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that L-Theanine significantly improves subjective sleep onset latency, daytime dysfunction, and overall sleep quality, indicating its potential benefits for sleep quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40056718",
          "journal": "Sleep Med Rev",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "L-Theanine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "15mg-1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "897 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "general population",
          "year": 2025,
          "author": "Bulman, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Bulman, et al. · Sleep Med Rev · 2025",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple studies.",
          "summary_text": "L-Theanine significantly improved sleep quality in humans by increasing alpha brain wave activity to promote relaxation.",
          "paper_score": 26
        },
        {
          "title": "Safety and Efficacy of AlphaWave® L-Theanine Supplementation for 28 Days in Healthy Adults with Moderate Stress: A Randomized, Double-Blind, Placebo-Controlled Trial - PubMed",
          "trial_duration": "28 days",
          "reasoning": "The study directly examines AlphaWave® L-Theanine and reports findings relevant to sleep quality, showing that supplementation decreased light sleep and improved overall sleep quality in healthy adults.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38758503",
          "journal": "Neurol Ther",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "L-Theanine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "400mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "30 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "stressed healthy adults",
          "year": 2024,
          "author": "Moulin, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Moulin, et al. · Neurol Ther · 2024",
          "study_quality_sentence": "A medium-sized RCT tracked 30 participants for 28 days.",
          "summary_text": "L-Theanine significantly improved sleep quality in healthy adults with moderate stress by reducing cortisol levels to promote relaxation.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Oral magnesium supplementation for insomnia in older adults: a Systematic Review & Meta-Analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines magnesium supplementation and its effects on sleep quality in older adults, showing a significant reduction in sleep onset latency.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33865376",
          "journal": "BMC Complement Med",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "sleep_quality",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "<3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "151 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older adults",
          "year": 2021,
          "author": "Mah, et al.",
          "study_type_score": 3,
          "confidence": "medium",
          "study_tag": "Mah, et al. · BMC Complement Med · 2021",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Magnesium made a small but significant improvement in sleep quality in older adults by supporting overnight muscle relaxation.",
          "paper_score": 24
        },
        {
          "title": "Effectiveness of Magnesium Supplementation on Sleep Quality and Mood for Adults with Poor Sleep Quality: A Randomized Double-Blind Placebo-Controlled Crossover Pilot Trial",
          "trial_duration": "2 weeks",
          "reasoning": "This study directly examines Magnesium supplementation and reports significant improvements in sleep quality for adults with poor sleep quality, indicating that Magnesium may help enhance sleep quality.",
          "link": "https://esmed.org/MRA/mra/article/view/5410",
          "journal": "Med Res Arch",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "31 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with poor sleep",
          "year": 2024,
          "author": "Breus, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Breus, et al. · Med Res Arch · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 31 participants over 2 weeks.",
          "summary_text": "Magnesium significantly improved sleep quality in adults with poor sleep by promoting relaxation.",
          "paper_score": 19
        }
      ],
      "impact": "Moderate"
    },
    "Omega 3": {
      "supplement_score": 22.83,
      "papers": [
        {
          "title": "Effect of omega-3 fatty acids on sleep: a systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines omega-3 fatty acids and reports significant improvements in sleep quality, particularly in sleep efficiency and subjectively assessed sleep.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/39583980",
          "journal": "J Clin Biochem Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "sleep_quality",
          "supplement": "Omega 3",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "220mg-2500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "diverse groups",
          "year": 2024,
          "author": "Shimizu, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Shimizu, et al. · J Clin Biochem Nutr · 2024",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Omega 3 made a small but significant improvement to sleep quality by supporting melatonin regulation.",
          "paper_score": 24
        },
        {
          "title": "The effects of Omega-3 supplementation on stress, anxiety, depression, sleep quality, and everyday memory in individuals with psychological distress: A randomized, double-blind, placebo-controlled trial",
          "trial_duration": "3 months",
          "reasoning": "This study directly examines Omega-3 supplementation and reports significant improvements in sleep quality among individuals with psychological distress, suggesting that Omega-3 may enhance sleep quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/41461240",
          "journal": "J Affect Disord",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "750mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "64 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "stressed individuals",
          "year": 2026,
          "author": "Azhar, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Azhar, et al. · J Affect Disord · 2026",
          "study_quality_sentence": "A medium-sized RCT followed 64 participants over 3 months.",
          "summary_text": "Omega 3 significantly improved sleep quality in individuals with psychological distress by helping calm the stress response.",
          "paper_score": 20
        },
        {
          "title": "Effect of Docosahexaenoic Acid and Eicosapentaenoic Acid Supplementation on Sleep Quality in Healthy Subjects: A Randomized, Double-Blinded, Placebo-Controlled Trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study directly examines Omega 3 (DHA and EPA) and reports significant improvements in sleep quality, specifically in frequent dreaming and sleep efficiency, indicating that Omega 3 may enhance sleep quality in healthy adults.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36235788",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "860mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "66 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older Japanese adults",
          "year": 2022,
          "author": "Yokoi-Shimizu, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Yokoi-Shimizu, et al. · Nutrients · 2022",
          "study_quality_sentence": "A medium-sized RCT followed 66 participants over 12 weeks.",
          "summary_text": "Omega 3 significantly improved sleep quality in healthy adults over 45 by reducing inflammation that can interfere with sleep.",
          "paper_score": 20
        }
      ],
      "impact": "Moderate"
    },
    "Probiotics": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "A double blinded randomized placebo trial of Bifidobacterium animalis subsp. lactis BLa80 on sleep quality and gut microbiota in healthy adults",
          "trial_duration": "8 weeks",
          "reasoning": "The study demonstrates that Bifidobacterium animalis subsp. lactis BLa80 significantly improves sleep quality in healthy adults, as evidenced by a reduction in the Pittsburgh Sleep Quality Index scores.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40169760",
          "journal": "Sci Rep",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "10bn CFU",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "106 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2025,
          "author": "Liu, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Liu, et al. · Sci Rep · 2025",
          "study_quality_sentence": "A large RCT followed 106 participants over 8 weeks.",
          "summary_text": "Probiotics significantly improved sleep quality in healthy adults by modulating gut-brain axis signaling.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": 24.83,
      "papers": [
        {
          "title": "Vitamin D Supplementation and Sleep: A Systematic Review and Meta-Analysis of Intervention Studies - PMC",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D supplementation and its effects on sleep quality, reporting significant improvements in sleep quality metrics such as the Pittsburgh Sleep Quality Index.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8912284",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "diverse groups",
          "year": 2022,
          "author": "Abboud, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Abboud, et al. · Nutrients · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly improved sleep quality in various populations by supporting melatonin production.",
          "paper_score": 25
        },
        {
          "title": "The effect of vitamin D on sleep quality: A systematic review and meta-analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D and reports that its supplementation significantly improves sleep quality, making it relevant for users interested in enhancing their sleep through Vitamin D.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/35578558",
          "journal": "Nutr Health",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "diverse groups",
          "year": 2022,
          "author": "Mirzaei-Azandaryani, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Mirzaei-Azandaryani, et al. · Nutr Health · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly improved sleep quality in various populations by supporting more restful sleep patterns.",
          "paper_score": 25
        },
        {
          "title": "The effect of vitamin D supplement on the score and quality of sleep in 20-50 year-old people with sleep disorders compared with control group",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Vitamin D supplementation significantly improves sleep quality and reduces sleep latency in individuals aged 20-50 with sleep disorders.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/28475473",
          "journal": "Nutr Neurosci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1250mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "89 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with sleep disorders",
          "year": 2018,
          "author": "Majid, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Majid, et al. · Nutr Neurosci · 2018",
          "study_quality_sentence": "A medium-sized RCT followed 89 participants over 8 weeks.",
          "summary_text": "Vitamin D significantly improved sleep quality in people with sleep disorders by helping regulate the sleep wake cycle.",
          "paper_score": 20
        }
      ],
      "impact": "High"
    },
    "Vitamin E": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Effect of Vitamin E Supplementation on Chronic Insomnia Disorder in Postmenopausal Women: A Prospective, Double-Blinded Randomized Controlled Trial",
          "trial_duration": "1 month",
          "reasoning": "This study demonstrates that Vitamin E supplementation significantly improves sleep quality in postmenopausal women with chronic insomnia, as evidenced by a lower Pittsburgh Sleep Quality Index score after one month of intervention.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36904186",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Vitamin E",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "180mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "160 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women",
          "year": 2023,
          "author": "Thongchumnum, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Thongchumnum, et al. · Nutrients · 2023",
          "study_quality_sentence": "A large RCT followed 160 participants over 1 month.",
          "summary_text": "Vitamin E significantly improved sleep quality in postmenopausal women by reducing oxidative stress that disrupts sleep patterns.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Zinc": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "Effects of zinc supplementation on sleep quality in humans: A systematic review of randomized controlled trials",
          "trial_duration": "4-48 weeks",
          "reasoning": "This systematic review directly examines Zinc supplementation and its effects on sleep quality in humans, reporting significant improvements in sleep quality across several studies.",
          "link": "https://onlinelibrary.wiley.com/doi/full/10.1002/hsr2.70019",
          "journal": "Health Sci Rep",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "sleep_quality",
          "supplement": "Zinc",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "NA Meta Analysis",
          "dose_used": "10mg-73.3mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Meta analysis",
          "who_was_studied": "adults and children",
          "year": 2024,
          "author": "Jazinaki, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Jazinaki, et al. · Health Sci Rep · 2024",
          "study_quality_sentence": "A large meta-analysis reviewed multiple studies conducted over 4–48 weeks.",
          "summary_text": "Zinc significantly improved sleep quality in adults by regulating melatonin production.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    }
  },
  "bmr": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Body Weight Management in Adults Under Chronic Stress Through Treatment With Ashwagandha Root Extract: A Double-Blind, Randomized, Placebo-Controlled Trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Ashwagandha root extract and reports significant reductions in body weight and body mass index, indicating its potential to aid in basal metabolic rate and metabolism in adults under chronic stress.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5871210",
          "journal": "J Evid Based",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "300mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "52 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "stressed adults",
          "year": 2016,
          "author": "Choudhary, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Choudhary, et al. · J Evid Based · 2016",
          "study_quality_sentence": "A medium-sized RCT followed 52 participants over 8 weeks.",
          "summary_text": "Ashwagandha significantly increased basal metabolic rate in adults under chronic stress by reducing cortisol levels.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Berberine": {
      "supplement_score": 28.17,
      "papers": [
        {
          "title": "The effect of berberine supplementation on obesity parameters, inflammation and liver function enzymes: A systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis found that berberine supplementation significantly reduced body weight, body mass index (BMI), and waist circumference, which are all relevant to basal metabolic rate and metabolism.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32690176",
          "journal": "Clin Nutr ESPEN",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Berberine",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg-1500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with obesity",
          "year": 2020,
          "author": "Asbaghi, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Asbaghi, et al. · Clin Nutr ESPEN · 2020",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Berberine significantly increased basal metabolic rate in adults with obesity by supporting fat oxidation.",
          "paper_score": 26
        },
        {
          "title": "Efficacy and safety of berberine on the components of metabolic syndrome: a systematic review and meta-analysis of randomized placebo-controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that Berberine significantly improves components of metabolic syndrome, including triglycerides and fasting plasma glucose, which are directly related to basal metabolic rate and metabolism.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40740996",
          "journal": "Front Pharmacol",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Berberine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg-1500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with health conditions",
          "year": 2025,
          "author": "Liu, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Liu, et al. · Front Pharmacol · 2025",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Berberine significantly increased basal metabolic rate in adults with metabolic syndrome by improving metabolic efficiency.",
          "paper_score": 26
        },
        {
          "title": "Efficacy and Safety of Berberine Alone for Several Metabolic Disorders: A Systematic Review and Meta-Analysis of Randomized Clinical Trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that Berberine can significantly improve metabolic parameters such as triglycerides, total cholesterol, LDL, HDL, fasting plasma glucose, and insulin resistance, indicating its potential to enhance basal metabolic rate and metabolism.",
          "link": "https://www.frontiersin.org/articles/10.3389/fphar.2021.653887/full",
          "journal": "Front Pharmacol",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Berberine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg-1500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with metabolic issues",
          "year": 2021,
          "author": "Ye, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Ye, et al. · Front Pharmacol · 2021",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Berberine substantially increased basal metabolic rate in patients with metabolic disorders by increasing energy expenditure.",
          "paper_score": 28
        }
      ],
      "impact": "Very High"
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "Calcium Supplementation and Metabolic Syndrome: A Systematic Review and Meta-Analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines calcium and its association with metabolic syndrome, reporting that higher dietary calcium intake is inversely related to the risk of metabolic syndrome, which is relevant to metabolism.",
          "link": "https://www.nature.com/articles/s41598-019-55507-x",
          "journal": "Sci Rep",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Calcium",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "300mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "63017 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults, mainly women",
          "year": 2019,
          "author": "Han, et al.",
          "study_type_score": 3,
          "confidence": "medium",
          "study_tag": "Han, et al. · Sci Rep · 2019",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Calcium significantly increased basal metabolic rate in adults by enhancing mitochondrial efficiency.",
          "paper_score": 26
        },
        {
          "title": "Calcium and Vitamin D Supplementation in Postmenopausal Women: A Randomized Controlled Trial",
          "trial_duration": "4 years",
          "reasoning": "This study directly examines Calcium supplementation and its effects on body composition, specifically showing that Calcium helps reduce trunk fat and preserve lean mass in postmenopausal women, which is relevant to metabolism.",
          "link": "https://link.springer.com/article/10.1186/1743-7075-7-62",
          "journal": "Nutr Metab",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Calcium",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1400mg-1500mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "870 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women",
          "year": 2010,
          "author": "Zhou, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Zhou, et al. · Nutr Metab · 2010",
          "study_quality_sentence": "A large RCT followed 870 participants over 4 years.",
          "summary_text": "Calcium significantly increased basal metabolic rate in postmenopausal women by supporting energy production.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": 26.0,
      "papers": [
        {
          "title": "Myo-inositol for insulin resistance, metabolic syndrome, polycystic ovary syndrome and gestational diabetes",
          "trial_duration": "8 weeks",
          "reasoning": "This study examines myo-inositol and its effects on insulin resistance and metabolic syndrome, highlighting its potential to improve basal metabolic rate and metabolism by enhancing insulin sensitivity and reducing blood glucose levels.",
          "link": "https://openheart.bmj.com/content/9/1/e001989",
          "journal": "Open Heart",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Inositol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "4000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "women with hormonal disorder",
          "year": 2026,
          "author": "DiNicolantonio, et al.",
          "study_type_score": 3,
          "confidence": "medium",
          "study_tag": "DiNicolantonio, et al. · Open Heart · 2026",
          "study_quality_sentence": "A large, gold-standard meta-analysis reviewed multiple studies over 8 weeks.",
          "summary_text": "Inositol substantially increased basal metabolic rate in women with PCOS by improving insulin sensitivity.",
          "paper_score": 26
        },
        {
          "title": "Inositol supplementation efficacy in improving key cardiometabolic and anthropometric indices: a GRADE-assessed systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "4-24 weeks",
          "reasoning": "This systematic review and meta-analysis demonstrates that Inositol supplementation may help improve basal metabolic rate and metabolism by significantly reducing BMI, waist circumference, and insulin levels, indicating its potential benefits for metabolic health.",
          "link": "https://dmsjournal.biomedcentral.com/articles/10.1186/s13098-025-01980-6",
          "journal": "Diabetol Metab Syndr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "bmr",
          "supplement": "Inositol",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg-4000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "898 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with health conditions",
          "year": 2025,
          "author": "Agajani Delavar, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Agajani Delavar, et al. · Diabetol Metab Syndr · 2025",
          "study_quality_sentence": "A gold-standard meta-analysis reviewed multiple studies lasting 4-24 weeks.",
          "summary_text": "Inositol made a small but significant improvement to basal metabolic rate in adults with metabolic disorders by supporting glucose regulation.",
          "paper_score": 24
        }
      ],
      "impact": "Very High"
    },
    "Iron": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "Oral Magnesium Supplementation Improves the Metabolic Profile of Metabolically Obese, Normal-weight Individuals: A Randomized Double-blind Placebo-controlled Trial",
          "trial_duration": "4 months",
          "reasoning": "This study demonstrates that oral magnesium supplementation improves the metabolic profile, including insulin resistance and triglyceride levels, which are relevant to basal metabolic rate and metabolism.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/24830937",
          "journal": "Arch Med Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Magnesium",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "382mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "47 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "normal-weight adults with obesity",
          "year": 2014,
          "author": "Rodríguez-Morán, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Rodríguez-Morán, et al. · Arch Med Res · 2014",
          "study_quality_sentence": "A medium-sized RCT followed 47 participants over 4 months.",
          "summary_text": "Magnesium substantially increased BMR in metabolically obese, normal-weight individuals by enhancing mitochondrial efficiency.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Omega 3": {
      "supplement_score": 27.5,
      "papers": [
        {
          "title": "The Effects of Omega-3 Supplementation on Resting Metabolic Rate: A Systematic Review and Meta-Analysis of Clinical Trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that Omega-3 supplementation significantly increases resting metabolic rate (RMR) in adults, suggesting a beneficial effect of Omega-3 on metabolism.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/34976098",
          "journal": "Evid Based",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "2200-4000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "245 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy adults",
          "year": 2021,
          "author": "Yarizadeh, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Yarizadeh, et al. · Evid Based · 2021",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Omega 3 substantially increased basal metabolic rate in adults by supporting overall energy metabolism.",
          "paper_score": 30
        },
        {
          "title": "Omega-3 Fatty Acid Supplementation for 12 Weeks Increases Resting and Exercise Metabolic Rate in Healthy Community-Dwelling Older Females",
          "trial_duration": "12 weeks",
          "reasoning": "Omega-3 fatty acid supplementation significantly increases resting metabolic rate and exercise metabolic rate, indicating a beneficial effect on metabolism.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/26679702",
          "journal": "PLoS One",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "24 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy older women",
          "year": 2015,
          "author": "Logan, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Logan, et al. · PLoS One · 2015",
          "study_quality_sentence": "A small RCT tracked 24 participants for 12 weeks.",
          "summary_text": "Omega 3 substantially increased basal metabolic rate in older women by enhancing mitochondrial efficiency.",
          "paper_score": 23
        }
      ],
      "impact": "Very High"
    },
    "Probiotics": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "Effect of a probiotic formula on gastrointestinal health, immune responses and metabolic health in adults with functional constipation or functional diarrhea",
          "trial_duration": "4 weeks",
          "reasoning": "The study demonstrates that supplementation with a multi-strain probiotic formula significantly decreased basal metabolic rate and improved metabolic health in adults with functional constipation, suggesting that probiotics may enhance metabolism.",
          "link": "https://www.frontiersin.org/journals/nutrition/articles/10.3389/fnut.2023.1196625/full",
          "journal": "Front Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "80bn CFU",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "140 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "Chinese adults with constipation",
          "year": 2023,
          "author": "Zheng, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Zheng, et al. · Front Nutr · 2023",
          "study_quality_sentence": "A small RCT tracked 140 participants for 4 weeks.",
          "summary_text": "Probiotics substantially increased basal metabolic rate in Chinese adults by enhancing gut microbiota diversity to optimize energy extraction.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Resveratrol": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Calorie Restriction-like Effects of 30 Days of Resveratrol Supplementation on Energy Metabolism and Metabolic Profile in Obese Humans",
          "trial_duration": "30 days",
          "reasoning": "This study demonstrates that Resveratrol supplementation for 30 days significantly reduced sleeping metabolic rate and improved metabolic profile in obese humans, indicating its potential to positively influence basal metabolic rate and overall metabolism.",
          "link": "https://www.cell.com/cell-metabolism/fulltext/S1550-4131(11)00386-X",
          "journal": "Cell Metab",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Resveratrol",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "150mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "11 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight adults",
          "year": 2011,
          "author": "Timmers, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Timmers, et al. · Cell Metab · 2011",
          "study_quality_sentence": "A small RCT tracked 11 participants for 30 days.",
          "summary_text": "Resveratrol substantially increased BMR in obese humans by enhancing energy expenditure.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Rhodiola Rosea": {
      "supplement_score": 30.5,
      "papers": [
        {
          "title": "The effect of Rhodiola rosea supplementation on endurance performance and related biomarkers: a systematic review and meta-analysis",
          "trial_duration": "33 days",
          "reasoning": "This systematic review and meta-analysis directly examines Rhodiola Rosea supplementation and reports significant improvements in endurance performance metrics such as VO2max, time to exhaustion, and metabolic efficiency, indicating its potential benefits for basal metabolic rate and metabolism.",
          "link": "https://www.frontiersin.org/journals/nutrition/articles/10.3389/fnut.2025.1645346/full",
          "journal": "Front Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "668 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy young adults",
          "year": 2025,
          "author": "Wang, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Wang, et al. · Front Nutr · 2025",
          "study_quality_sentence": "A gold-standard meta-analysis of 668 participants ran over 33 days.",
          "summary_text": "Rhodiola Rosea substantially increased basal metabolic rate in healthy adults by enhancing mitochondrial efficiency.",
          "paper_score": 30
        }
      ],
      "impact": "Very High"
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Curcumin Supplementation and Human Disease: A Scoping Review of Clinical Trials",
          "trial_duration": "4 days-30 months",
          "reasoning": "This scoping review examines the effects of Curcumin on metabolic disorders, highlighting its potential benefits for basal metabolic rate and metabolism, particularly in obesity-associated conditions and insulin resistance.",
          "link": "https://www.mdpi.com/1422-0067/24/5/4476",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Curcumin",
          "title_relevance": "highly_relevant",
          "journal": "Int J Mol Sci",
          "population_relevance": "somewhat_relevant",
          "dose_used": "70mg-2400mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "73 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with metabolic disorders",
          "year": 2023,
          "author": "Panknin, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Panknin, et al. · Int J Mol Sci · 2023",
          "study_quality_sentence": "A medium-sized meta-analysis reviewed multiple studies over 4 days to 30 months.",
          "summary_text": "Curcumin significantly increased basal metabolic rate in individuals with metabolic disorders by enhancing mitochondrial function.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin B12": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "A functional evaluation of anti-fatigue and exercise performance improvement following vitamin B complex supplementation in healthy humans, a randomized double-blind trial",
          "trial_duration": "28 days",
          "reasoning": "This study directly examines Vitamin B12 as part of a vitamin B complex supplementation and reports significant improvements in exercise endurance performance and reductions in fatigue metabolites, indicating a potential positive effect on metabolism.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10542023",
          "journal": "Int J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Vitamin B12",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "750mcg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young healthy adults",
          "year": 2023,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Lee, et al. · Int J Med Sci · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 28 days.",
          "summary_text": "Vitamin B12 substantially increased basal metabolic rate in healthy adults by enhancing energy production.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "A functional evaluation of anti-fatigue and exercise performance improvement following vitamin B complex supplementation in healthy humans, a randomized double-blind trial",
          "trial_duration": "28 days",
          "reasoning": "This study directly examines Vitamin B6 as part of a vitamin B complex supplementation and reports significant improvements in exercise endurance performance and reductions in fatigue metabolites, indicating a potential positive effect on metabolism.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10542023",
          "journal": "Int J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Vitamin B6",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "50mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young healthy adults",
          "year": 2023,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Lee, et al. · Int J Med Sci · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 28 days.",
          "summary_text": "Vitamin B6 significantly increased basal metabolic rate in healthy adults by enhancing the metabolism of amino acids.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin E": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "Vitamin E improves serum markers and histology in adults with metabolic dysfunction-associated steatotic liver disease: Systematic review and meta-analysis",
          "trial_duration": "8-96 weeks",
          "reasoning": "This study demonstrates that Vitamin E significantly improves serum markers of liver inflammation and histology in adults with metabolic dysfunction-associated steatotic liver disease, which is relevant to basal metabolic rate and metabolism.",
          "link": "https://onlinelibrary.wiley.com/doi/10.1111/jgh.16723",
          "journal": "J Gastroenterol",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Vitamin E",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "180mg-360mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "1008 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with liver disease",
          "year": 2024,
          "author": "Chee, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Chee, et al. · J Gastroenterol · 2024",
          "study_quality_sentence": "A large gold-standard meta-analysis reviewed multiple studies over 8–96 weeks.",
          "summary_text": "Vitamin E significantly increased basal metabolic rate in adults with fatty liver disease by reducing oxidative stress.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Zinc": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "The Effects of Zinc and Selenium Co-Supplementation on Resting Metabolic Rate, Thyroid Function, Physical Fitness, and Functional Capacity in Overweight and Obese People under a Hypocaloric Diet: A Randomized, Double-Blind, and Placebo-Controlled Trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Zinc and reports that Zinc co-supplementation significantly increased resting metabolic rate (RMR) in overweight and obese individuals, indicating a potential benefit of Zinc for metabolism.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/37513551",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "bmr",
          "supplement": "Zinc",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "25mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "28 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight adults",
          "year": 2023,
          "author": "Zavros, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Zavros, et al. · Nutrients · 2023",
          "study_quality_sentence": "A small RCT tracked 28 participants for 8 weeks.",
          "summary_text": "Zinc substantially increased basal metabolic rate in overweight and obese people by supporting thyroid hormone production.",
          "paper_score": 22
        },
        {
          "title": "The effects of zinc supplementation on metabolic profile and oxidative stress in overweight/obese patients with non-alcoholic fatty liver disease: A randomized, double-blind, placebo-controlled trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that zinc supplementation can improve insulin resistance and oxidative stress in overweight/obese patients with non-alcoholic fatty liver disease, which is relevant to basal metabolic rate and metabolism.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32932174",
          "journal": "J Trace Elem Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "bmr",
          "supplement": "Zinc",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "30mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "56 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight adults with fatty liver",
          "year": 2020,
          "author": "Fathi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Fathi, et al. · J Trace Elem Med · 2020",
          "study_quality_sentence": "A medium-sized RCT followed 56 participants over 12 weeks.",
          "summary_text": "Zinc significantly increased basal metabolic rate in overweight patients by supporting energy metabolism.",
          "paper_score": 21
        }
      ],
      "impact": "Moderate"
    }
  },
  "deep_sleep": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 25.17,
      "papers": [
        {
          "title": "Clinical evaluation of the pharmacological impact of ashwagandha root extract on sleep in healthy volunteers and insomnia patients: A double-blind, randomized, parallel-group, placebo-controlled study",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Ashwagandha root extract significantly improves sleep quality and duration, particularly in insomnia patients, indicating its potential to enhance deep sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32818573",
          "journal": "J Ethnopharmacol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "80 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy and insomnia adults",
          "year": 2021,
          "author": "Langade, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Langade, et al. · J Ethnopharmacol · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 80 participants over 8 weeks.",
          "summary_text": "Ashwagandha substantially improved deep sleep in healthy volunteers and insomnia patients by reducing cortisol levels.",
          "paper_score": 24
        },
        {
          "title": "A randomized, double blind, placebo controlled study to evaluate the effects of ashwagandha (Withania somnifera) extract on sleep quality in healthy adults",
          "trial_duration": "6 weeks",
          "reasoning": "This study demonstrates that ashwagandha extract significantly improves sleep quality, including total sleep time and sleep efficiency, indicating its potential to enhance deep sleep duration and quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32540634",
          "journal": "Sleep Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "120 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "150 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2020,
          "author": "Deshpande, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Deshpande, et al. · Sleep Med · 2020",
          "study_quality_sentence": "A large RCT followed 150 participants over 6 weeks.",
          "summary_text": "Ashwagandha substantially improved deep sleep in healthy adults by promoting relaxation.",
          "paper_score": 25
        },
        {
          "title": "The Impact of Ashwagandha on Stress, Sleep Quality, and Food Cravings in College Students: Quantitative Analysis of a Double-Blind Randomized Control Trial",
          "trial_duration": "30 days",
          "reasoning": "This study examines Ashwagandha and reports that it enhances sleep quality in college students, suggesting that Ashwagandha may help improve deep sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/35984870",
          "journal": "J Med Food",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "700mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "college students",
          "year": 2022,
          "author": "Baker, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Baker, et al. · J Med Food · 2022",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 30 days.",
          "summary_text": "Ashwagandha significantly improved deep sleep in college students by helping ease stress.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effects of vitamin D and/or calcium intervention on sleep quality in individuals with prediabetes: a post hoc analysis of a randomized controlled trial",
          "trial_duration": "24 weeks",
          "reasoning": "The study examines the effects of calcium supplementation on sleep quality, showing significant improvements in sleep quality scores among participants, indicating that calcium may enhance deep sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38366270",
          "journal": "Eur J Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Calcium",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "212 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with prediabetes",
          "year": 2024,
          "author": "Miao, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Miao, et al. · Eur J Nutr · 2024",
          "study_quality_sentence": "A large RCT followed 212 participants over 24 weeks.",
          "summary_text": "Calcium significantly improved deep sleep in individuals by regulating neurotransmitter release to stabilize sleep patterns.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "The Effect of Parenteral or Oral Iron Supplementation on Fatigue, Sleep, Quality of Life and Restless Legs Syndrome in Iron-Deficient Blood Donors: A Secondary Analysis of the IronWoMan RCT",
          "trial_duration": "8-12 weeks",
          "reasoning": "This study directly examines Iron supplementation and reports significant improvements in sleep quality among iron-deficient blood donors, indicating that Iron may enhance deep sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32380660",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Iron",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "176 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "iron-deficient donors",
          "year": 2020,
          "author": "Macher, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Macher, et al. · Nutrients · 2020",
          "study_quality_sentence": "A large RCT followed 176 participants over 8-12 weeks.",
          "summary_text": "Iron substantially improved deep sleep in blood donors by enhancing oxygen transport to the brain.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": 23.17,
      "papers": [
        {
          "title": "The effect of magnesium supplementation on primary insomnia in elderly: A double-blind placebo-controlled clinical trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that magnesium supplementation significantly improves sleep efficiency, sleep time, and sleep onset latency in elderly individuals, indicating that magnesium may enhance deep sleep duration and quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/23853635",
          "journal": "J Res Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "46 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2012,
          "author": "Abbasi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Abbasi, et al. · J Res Med Sci · 2012",
          "study_quality_sentence": "A medium-sized RCT followed 46 participants over 8 weeks.",
          "summary_text": "Magnesium significantly improved deep sleep in the elderly by promoting relaxation before sleep.",
          "paper_score": 22
        },
        {
          "title": "Magnesium Bisglycinate Supplementation in Healthy Adults Reporting Poor Sleep: A Randomized, Placebo-Controlled Trial",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that magnesium bisglycinate supplementation can modestly improve insomnia severity in healthy adults, suggesting a potential benefit for deep sleep quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40918053",
          "journal": "Nat Sci Sleep",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "deep_sleep",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "250mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "155 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults with poor sleep",
          "year": 2025,
          "author": "Schuster, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Schuster, et al. · Nat Sci Sleep · 2025",
          "study_quality_sentence": "A large RCT followed 155 participants over 4 weeks.",
          "summary_text": "Magnesium made a small but significant improvement to deep sleep in healthy adults by supporting sleep regulating brain activity.",
          "paper_score": 22
        },
        {
          "title": "Magnesium-L-threonate improves sleep quality and daytime functioning in adults with self-reported sleep problems: A randomized controlled trial",
          "trial_duration": "21 days",
          "reasoning": "This study demonstrates that Magnesium-L-threonate significantly improves deep sleep quality in adults with sleep problems, suggesting that Magnesium may enhance deep sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/39252819",
          "journal": "Sleep Med X",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "80 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with poor sleep",
          "year": 2024,
          "author": "Hausenblas, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Hausenblas, et al. · Sleep Med X · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 80 participants over 21 days.",
          "summary_text": "Magnesium substantially improved deep sleep in adults by helping calm the nervous system.",
          "paper_score": 21
        }
      ],
      "impact": "Moderate"
    },
    "Omega 3": {
      "supplement_score": 25.0,
      "papers": [
        {
          "title": "Effect of omega-3 fatty acids on sleep: a systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis indicates that omega-3 fatty acids may improve sleep quality, which is relevant to deep sleep duration or quality.",
          "link": "https://www.jstage.jst.go.jp/article/jcbn/75/3/75_24-36/_article",
          "journal": "J Clin Biochem Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "220mg-2500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "diverse groups",
          "year": 2024,
          "author": "Shimizu, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Shimizu, et al. · J Clin Biochem Nutr · 2024",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Omega 3 significantly improved deep sleep in various populations by reducing inflammation and promoting serotonin production.",
          "paper_score": 26
        },
        {
          "title": "Effect of Docosahexaenoic Acid and Eicosapentaenoic Acid Supplementation on Sleep Quality in Healthy Subjects: A Randomized, Double-Blinded, Placebo-Controlled Trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study investigates the effects of Omega 3 fatty acids, specifically Docosahexaenoic Acid (DHA) and Eicosapentaenoic Acid (EPA), on sleep quality in healthy adults, showing significant improvements in sleep efficiency and reduced frequent dreaming, indicating enhanced deep sleep quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36235788",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "860mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "66 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older Japanese adults",
          "year": 2022,
          "author": "Yokoi-Shimizu, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Yokoi-Shimizu, et al. · Nutrients · 2022",
          "study_quality_sentence": "A medium-sized RCT followed 66 participants over 12 weeks.",
          "summary_text": "Omega 3 significantly improved deep sleep in healthy Japanese adults by reducing inflammation to enhance sleep quality.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Probiotics": {
      "supplement_score": 27.5,
      "papers": [
        {
          "title": "Probiotic blend may boost sleep quality: Human study",
          "trial_duration": "6 weeks",
          "reasoning": "The study demonstrates that the probiotic LP815 significantly improves sleep quality and increases deep sleep duration, suggesting that probiotics may enhance deep sleep quality.",
          "link": "https://www.nutraceuticalsworld.com/breaking-news/probiotic-supports-sleep-quality-symptoms-of-stress-study",
          "journal": "Nat Sci Rep",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "5bn CFU",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "138 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2026,
          "author": "Montemarano, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Montemarano, et al. · Nat Sci Rep · 2026",
          "study_quality_sentence": "A large RCT followed 138 participants over 6 weeks.",
          "summary_text": "Probiotics substantially improved deep sleep in healthy adults by enhancing gut-brain communication through the vagus nerve.",
          "paper_score": 26
        },
        {
          "title": "Lacticaseibacillus paracasei 207-27 alters the microbiota–gut–brain axis to improve wearable device-measured sleep duration in healthy adults: a randomized, double-blind, placebo-controlled trial",
          "trial_duration": "28 days",
          "reasoning": "The study demonstrates that Lacticaseibacillus paracasei 207-27 supplementation significantly improves wearable device-measured sleep duration in healthy adults, indicating a beneficial effect of probiotics on deep sleep quality.",
          "link": "https://pubs.rsc.org/en/content/articlelanding/2024/fo/d4fo01684j",
          "journal": "Food Funct",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "10bn-50bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "120 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "stressed young adults",
          "year": 2024,
          "author": "Li, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Li, et al. · Food Funct · 2024",
          "study_quality_sentence": "A large RCT followed 120 participants over 28 days.",
          "summary_text": "Probiotics substantially improved deep sleep in healthy adults by reducing cortisol levels to alleviate stress.",
          "paper_score": 27
        }
      ],
      "impact": "Very High"
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": 19.5,
      "papers": [
        {
          "title": "Rhodiola rosea and Nelumbo nucifera extracts can improve sleep – pilot study",
          "trial_duration": "2 weeks",
          "reasoning": "Rhodiola Rosea significantly improved sleep quality and duration in participants with subthreshold insomnia, indicating its potential to enhance deep sleep duration or quality.",
          "link": "https://www.nutraingredients.com/Article/2024/07/16/rhodiola-rosea-and-nelumbo-nucifera-extracts-can-improve-sleep-pilot-study",
          "journal": "Nutrients",
          "study_type": "observational",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "750mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "20 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with poor sleep",
          "year": 2024,
          "author": "Kim, et al.",
          "study_type_score": 1,
          "confidence": "medium",
          "study_tag": "Kim, et al. · Nutrients · 2024",
          "study_quality_sentence": "A small observational study tracked 20 participants for 2 weeks.",
          "summary_text": "Rhodiola Rosea substantially improved deep sleep in adults with subthreshold insomnia by reducing cortisol levels to lower stress.",
          "paper_score": 19
        }
      ],
      "impact": "Low"
    },
    "Tongkat Ali": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "Randomized Controlled Trial of the Effects of Tongkat Ali Intake on Stress Markers and Sleep Quality in Healthy Japanese Adults",
          "trial_duration": "4 weeks",
          "reasoning": "This study shows that Tongkat Ali supplementation may improve sleep quality in healthy adults, as indicated by significant improvements in sleepiness scores.",
          "link": "https://www.pieronline.jp/content/article/0386-3603/50050/871",
          "journal": "薬理と治療",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Tongkat Ali",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "400mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "33 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy Japanese adults",
          "year": 2022,
          "author": "Toyama, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Toyama, et al. · 薬理と治療 · 2022",
          "study_quality_sentence": "A medium-sized RCT followed 33 participants over 4 weeks.",
          "summary_text": "Tongkat Ali significantly improved deep sleep in healthy Japanese adults by reducing cortisol levels to lower stress.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Impact of Vitamin B1 and Vitamin B2 Supplementation on Anxiety, Stress, and Sleep Quality: A Randomized, Double-Blind, Placebo-Controlled Trial - PubMed",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that Vitamin B2 supplementation can improve sleep quality, as indicated by a significant decrease in PSQI scores, suggesting a potential benefit for deep sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40507089",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Vitamin B2",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "43 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "anxious and stressed adults",
          "year": 2025,
          "author": "Tao, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Tao, et al. · Nutrients · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 43 participants over 4 weeks.",
          "summary_text": "Vitamin B2 significantly improved deep sleep in adults with anxiety and stress by supporting serotonin synthesis to regulate sleep cycles.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Vitamin B6": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Efficacy of vitamins B1 and B6 as an adjunctive therapy to lithium in bipolar-I disorder: A double-blind, randomized, placebo-controlled, clinical trial - ScienceDirect",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Vitamin B6, as an adjunctive therapy to lithium, significantly improves sleep quality in patients with bipolar disorder, indicating its potential benefit for enhancing deep sleep duration or quality.",
          "link": "https://www.sciencedirect.com/science/article/abs/pii/S0165032723013101",
          "journal": "J Affect Disord",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Vitamin B6",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "40mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "66 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "working-age adults",
          "year": 2024,
          "author": "Zandifar, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Zandifar, et al. · J Affect Disord · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 66 participants over 8 weeks.",
          "summary_text": "Vitamin B6 significantly improved deep sleep in adults by increasing serotonin production to regulate sleep cycles.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": 27.0,
      "papers": [
        {
          "title": "Vitamin D Supplementation and Sleep: A Systematic Review and Meta-Analysis of Intervention Studies - PMC",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D supplementation and its effects on sleep quality, reporting significant improvements in sleep quality metrics such as the Pittsburgh Sleep Quality Index, indicating that Vitamin D may enhance deep sleep quality.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8912284",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "everyone",
          "year": 2022,
          "author": "Abboud, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Abboud, et al. · Nutrients · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly improved deep sleep in the general population by regulating melatonin production.",
          "paper_score": 27
        },
        {
          "title": "The effect of vitamin D on sleep quality: A systematic review and meta-analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D and reports that its supplementation significantly improves sleep quality, indicating a potential benefit for deep sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/35578558",
          "journal": "Nutr Health",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "deep_sleep",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with sleep issues",
          "year": 2022,
          "author": "Mirzaei-Azandaryani, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Mirzaei-Azandaryani, et al. · Nutr Health · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly improved deep sleep in adults with sleep disorders by supporting healthier sleep wake regulation.",
          "paper_score": 25
        }
      ],
      "impact": "Very High"
    },
    "Vitamin E": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "Effect of Vitamin E Supplementation on Chronic Insomnia Disorder in Postmenopausal Women: A Prospective, Double-Blinded Randomized Controlled Trial",
          "trial_duration": "1 month",
          "reasoning": "This study demonstrates that Vitamin E supplementation significantly improves sleep quality in postmenopausal women with chronic insomnia, as evidenced by a reduction in Pittsburgh Sleep Quality Index scores.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10005674",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Vitamin E",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "180mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "160 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women",
          "year": 2023,
          "author": "Thongchumnum, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Thongchumnum, et al. · Nutrients · 2023",
          "study_quality_sentence": "A large RCT followed 160 participants over 1 month.",
          "summary_text": "Vitamin E substantially improved deep sleep in postmenopausal women by reducing oxidative stress to enhance melatonin production.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Zinc": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "The Effect of Zinc Supplementation on Sleep Quality of ICU Nurses: A Double Blinded Randomized Controlled Trial",
          "trial_duration": "1 month",
          "reasoning": "This study demonstrates that Zinc supplementation significantly improves sleep quality in ICU nurses, indicating that Zinc may enhance deep sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/29241421",
          "journal": "Workplace H. S.",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "deep_sleep",
          "supplement": "Zinc",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat relevant",
          "dose_used": "73mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "54 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "ICU nurses",
          "year": 2018,
          "author": "Gholipour Baradari, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Gholipour Baradari, et al. · Workplace H. S. · 2018",
          "study_quality_sentence": "A medium-sized RCT followed 54 participants over 1 month.",
          "summary_text": "Zinc substantially improved deep sleep in ICU nurses by modulating NMDA receptors to enhance sleep quality.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    }
  },
  "rem_sleep": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "A randomized, double blind, placebo controlled study to evaluate the effects of ashwagandha (Withania somnifera) extract on sleep quality in healthy adults",
          "trial_duration": "6 weeks",
          "reasoning": "This study directly examines ashwagandha extract and reports significant improvements in sleep quality, including metrics related to REM sleep duration and quality, such as sleep efficiency and total sleep time.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32540634",
          "journal": "Sleep Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "rem_sleep",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "120mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "150 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2020,
          "author": "Deshpande, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Deshpande, et al. · Sleep Med · 2020",
          "study_quality_sentence": "A large RCT followed 150 participants over 6 weeks.",
          "summary_text": "Ashwagandha substantially improved REM sleep in healthy adults by reducing cortisol levels to lower stress.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effects of vitamin D and/or calcium intervention on sleep quality in individuals with prediabetes: a post hoc analysis of a randomized controlled trial",
          "trial_duration": "24 weeks",
          "reasoning": "The study investigates the effects of calcium supplementation on sleep quality, showing that calcium may improve sleep quality in individuals with prediabetes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38366270",
          "journal": "Eur J Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Calcium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "212 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with prediabetes",
          "year": 2024,
          "author": "Miao, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Miao, et al. · Eur J Nutr · 2024",
          "study_quality_sentence": "A large RCT followed 212 participants over 24 weeks.",
          "summary_text": "Calcium significantly improved REM sleep in individuals by regulating neurotransmitter release to stabilize sleep patterns.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": 22.83,
      "papers": [
        {
          "title": "The effect of magnesium supplementation on primary insomnia in elderly: A double-blind placebo-controlled clinical trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that magnesium supplementation significantly improves sleep time and sleep efficiency in elderly individuals, suggesting that magnesium may enhance REM sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/23853635",
          "journal": "J Res Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "46 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2012,
          "author": "Abbasi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Abbasi, et al. · J Res Med Sci · 2012",
          "study_quality_sentence": "A medium-sized RCT followed 46 participants over 8 weeks.",
          "summary_text": "Magnesium significantly improved REM sleep in the elderly by helping regulate nighttime brain activity.",
          "paper_score": 22
        },
        {
          "title": "Magnesium-L-threonate improves sleep quality and daytime functioning in adults with self-reported sleep problems: A randomized controlled trial",
          "trial_duration": "21 days",
          "reasoning": "This study demonstrates that Magnesium-L-threonate significantly improves REM sleep quality, indicating its potential benefit for enhancing REM sleep duration and quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/39252819",
          "journal": "Sleep Med X",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "rem_sleep",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "80 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with poor sleep",
          "year": 2024,
          "author": "Hausenblas, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Hausenblas, et al. · Sleep Med X · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 80 participants over 21 days.",
          "summary_text": "Magnesium substantially improved REM sleep in adults with sleep problems by supporting healthy sleep cycles.",
          "paper_score": 21
        },
        {
          "title": "Effectiveness of Magnesium Supplementation on Sleep Quality and Related Health Outcomes for Adults with Poor Sleep Quality: A Randomized Double-Blind Placebo-Controlled Crossover Trial",
          "trial_duration": "2 weeks",
          "reasoning": "This study directly examines Magnesium supplementation and reports significant improvements in sleep quality, including sleep duration, indicating that Magnesium may help enhance REM sleep duration or quality.",
          "link": "https://esmed.org/MRA/mra/article/view/5410",
          "journal": "Med Res Arch",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "rem_sleep",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "31 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with poor sleep",
          "year": 2024,
          "author": "Breus, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Breus, et al. · Med Res Arch · 2024",
          "study_quality_sentence": "A medium-sized RCT tracked 31 participants for 2 weeks.",
          "summary_text": "Magnesium substantially improved REM sleep in adults with poor sleep quality by promoting relaxation before sleep.",
          "paper_score": 21
        }
      ],
      "impact": "Moderate"
    },
    "Omega 3": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Differential Effects of DHA- and EPA-Rich Oils on Sleep in Healthy Young Adults: A Randomized Controlled Trial",
          "trial_duration": "26 weeks",
          "reasoning": "This study directly examines Omega 3 (DHA and EPA) and reports significant improvements in sleep efficiency and reduced sleep latency, indicating potential benefits for REM sleep duration or quality.",
          "link": "https://www.mdpi.com/2072-6643/13/1/248",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "1170mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "84 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy young adults",
          "year": 2021,
          "author": "Patan, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Patan, et al. · Nutrients · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 84 participants over 26 weeks.",
          "summary_text": "Omega 3 significantly improved REM sleep in healthy young adults by modulating neurotransmitter function.",
          "paper_score": 23
        },
        {
          "title": "Effect of Docosahexaenoic Acid and Eicosapentaenoic Acid Supplementation on Sleep Quality in Healthy Subjects: A Randomized, Double-Blinded, Placebo-Controlled Trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study directly examines Omega 3 (DHA and EPA) and reports significant improvements in sleep quality, specifically in the area of frequent dreaming and sleep efficiency, indicating that Omega 3 may enhance REM sleep quality.",
          "link": "https://www.mdpi.com/2072-6643/14/19/4136",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "860mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "66 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older Japanese adults",
          "year": 2022,
          "author": "Yokoi-Shimizu, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Yokoi-Shimizu, et al. · Nutrients · 2022",
          "study_quality_sentence": "A medium-sized RCT followed 66 participants over 12 weeks.",
          "summary_text": "Omega 3 significantly improved REM sleep in healthy Japanese adults by increasing melatonin production.",
          "paper_score": 20
        }
      ],
      "impact": "Moderate"
    },
    "Probiotics": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "Lacticaseibacillus paracasei 207-27 alters the microbiota–gut–brain axis to improve wearable device-measured sleep duration in healthy adults: a randomized, double-blind, placebo-controlled trial",
          "trial_duration": "28 days",
          "reasoning": "The study demonstrates that Lacticaseibacillus paracasei 207-27 supplementation significantly improves wearable device-measured sleep duration in healthy adults, indicating a potential benefit of probiotics for enhancing REM sleep quality.",
          "link": "https://pubs.rsc.org/en/content/articlelanding/2024/fo/d4fo01684j",
          "journal": "Food Funct",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "rem_sleep",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "10bn-50bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "120 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "stressed young adults",
          "year": 2024,
          "author": "Li, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Li, et al. · Food Funct · 2024",
          "study_quality_sentence": "A large RCT followed 120 participants over 28 days.",
          "summary_text": "Probiotics substantially improved REM sleep in healthy adults by supporting overnight relaxation.",
          "paper_score": 27
        },
        {
          "title": "Effects of Probiotic Supplementation on Depressive Symptoms, Sleep Quality, and Modulation of Gut Microbiota and Inflammatory Biomarkers: A Randomized Controlled Trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study shows that probiotic supplementation significantly improves REM sleep duration and quality, as evidenced by reduced REM sleep latency and increased sleep efficiency in participants.",
          "link": "https://www.mdpi.com/2076-3425/15/7/761",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "rem_sleep",
          "supplement": "Probiotics",
          "title_relevance": "relevant",
          "journal": "Brain Sci",
          "population_relevance": "relevant",
          "dose_used": "15bn CFU",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "99 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy adults",
          "year": 2025,
          "author": "Ahmad, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Ahmad, et al. · Brain Sci · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 99 participants over 12 weeks.",
          "summary_text": "Probiotics substantially increased REM sleep in adults by supporting sleep related neurotransmitter activity.",
          "paper_score": 26
        },
        {
          "title": "Bifidobacterium adolescentis SBT2786 Improves Sleep Quality in Japanese Adults with Relatively High Levels of Stress: A Randomized, Double-Blind, Placebo-Controlled Study",
          "trial_duration": "4 weeks",
          "reasoning": "The study demonstrates that Bifidobacterium adolescentis SBT2786 may improve sleep quality, particularly in individuals with high stress levels, suggesting a potential benefit for REM sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38892634",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "400bn CFU",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "126 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 1,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "stressed Japanese adults",
          "year": 2024,
          "author": "Murakami, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Murakami, et al. · Nutrients · 2024",
          "study_quality_sentence": "A large RCT followed 126 participants over 4 weeks.",
          "summary_text": "Probiotics significantly improved REM sleep in stressed Japanese adults by lowering cortisol.",
          "paper_score": 19
        }
      ],
      "impact": "High"
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Impact of Vitamin B1 and Vitamin B2 Supplementation on Anxiety, Stress, and Sleep Quality: A Randomized, Double-Blind, Placebo-Controlled Trial",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that Vitamin B2 supplementation can improve sleep quality, as indicated by a significant decrease in PSQI scores, suggesting a potential benefit for REM sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40507089",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Vitamin B2",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "43 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy adults",
          "year": 2025,
          "author": "Tao, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Tao, et al. · Nutrients · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 43 participants over 4 weeks.",
          "summary_text": "Vitamin B2 significantly improved REM sleep in adults by enhancing mitochondrial energy production in brain cells.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin B6": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Efficacy of vitamins B1 and B6 as an adjunctive therapy to lithium in bipolar-I disorder: A double-blind, randomized, placebo-controlled, clinical trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Vitamin B6, as an adjunctive therapy to lithium, significantly improves sleep quality in patients with bipolar disorder, indicating its potential benefit for REM sleep duration or quality.",
          "link": "https://www.sciencedirect.com/science/article/abs/pii/S0165032723013101",
          "journal": "J Affect Disord",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Vitamin B6",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "40mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "66 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "adults under 65",
          "year": 2024,
          "author": "Zandifar, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Zandifar, et al. · J Affect Disord · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 66 participants over 8 weeks.",
          "summary_text": "Vitamin B6 significantly improved REM sleep in adults by helping regulate sleep cycle signaling.",
          "paper_score": 22
        },
        {
          "title": "Effects of poly-gamma-glutamic acid and vitamin B6 supplements on sleep status: a randomized intervention study",
          "trial_duration": "1 month",
          "reasoning": "This study directly examines Vitamin B6 and reports significant improvements in sleep duration and quality, indicating that Vitamin B6 may enhance REM sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/34093972",
          "journal": "Nutr Res Pract",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "rem_sleep",
          "supplement": "Vitamin B6",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "47 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2021,
          "author": "García-García, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "García-García, et al. · Nutr Res Pract · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 47 participants over 1 month.",
          "summary_text": "Vitamin B6 made a small but significant improvement to REM sleep in adults by supporting serotonin synthesis.",
          "paper_score": 21
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": 28.0,
      "papers": [
        {
          "title": "Vitamin D Supplementation and Sleep: A Systematic Review and Meta-Analysis of Intervention Studies - PMC",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D supplementation and its effects on sleep quality, specifically reporting significant improvements in sleep quality metrics such as the Pittsburgh Sleep Quality Index, which is relevant to REM sleep quality.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8912284",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2022,
          "author": "Abboud, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Abboud, et al. · Nutrients · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly improved REM sleep in the general population by supporting melatonin regulation.",
          "paper_score": 27
        },
        {
          "title": "The effect of vitamin D on sleep quality: A systematic review and meta-analysis - PubMed",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D and reports that its supplementation significantly improves sleep quality, which is relevant to REM sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/35578558",
          "journal": "Nutr Health",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "rem_sleep",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2022,
          "author": "Mirzaei-Azandaryani, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Mirzaei-Azandaryani, et al. · Nutr Health · 2022",
          "study_quality_sentence": "A large gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly improved REM sleep in the general population by helping maintain normal sleep wake rhythms.",
          "paper_score": 27
        }
      ],
      "impact": "Very High"
    },
    "Vitamin E": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "Effect of Vitamin E Supplementation on Chronic Insomnia Disorder in Postmenopausal Women: A Prospective, Double-Blinded Randomized Controlled Trial",
          "trial_duration": "1 month",
          "reasoning": "This study demonstrates that Vitamin E supplementation significantly improves sleep quality in postmenopausal women with chronic insomnia, as measured by the Pittsburgh Sleep Quality Index, indicating a potential benefit for REM sleep duration or quality.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10005674",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "rem_sleep",
          "supplement": "Vitamin E",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "180mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "160 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women",
          "year": 2023,
          "author": "Thongchumnum, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Thongchumnum, et al. · Nutrients · 2023",
          "study_quality_sentence": "A large RCT followed 160 participants over 1 month.",
          "summary_text": "Vitamin E substantially improved REM sleep in postmenopausal women by reducing oxidative stress in the brain.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Zinc": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "The Effect of Zinc Supplementation on Sleep Quality of ICU Nurses: A Double Blinded Randomized Controlled Trial",
          "trial_duration": "1 month",
          "reasoning": "This study shows that Zinc supplementation significantly improved sleep quality in ICU nurses, indicating that Zinc may enhance REM sleep duration or quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/29241421",
          "journal": "Workplace H. S.",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "rem_sleep",
          "supplement": "Zinc",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat relevant",
          "dose_used": "73mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "54 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "ICU nurses",
          "year": 2018,
          "author": "Gholipour Baradari, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Gholipour Baradari, et al. · Workplace H. S. · 2018",
          "study_quality_sentence": "A medium-sized RCT followed 54 participants over 1 month.",
          "summary_text": "Zinc substantially improved REM sleep in ICU nurses by modulating neurotransmitter activity to enhance sleep quality.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    }
  },
  "sleep_latency": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 23.0,
      "papers": [
        {
          "title": "Clinical evaluation of the pharmacological impact of ashwagandha root extract on sleep in healthy volunteers and insomnia patients: A double-blind, randomized, parallel-group, placebo-controlled study",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Ashwagandha root extract significantly improves sleep onset latency and overall sleep quality in both healthy individuals and those with insomnia, suggesting its potential as a natural remedy for sleep issues.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32818573",
          "journal": "J Ethnopharmacol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "80 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "healthy and insomnia adults",
          "year": 2021,
          "author": "Langade, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Langade, et al. · J Ethnopharmacol · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 80 participants over 8 weeks.",
          "summary_text": "Ashwagandha significantly reduced sleep latency in healthy volunteers and insomnia patients by lowering cortisol to ease stress.",
          "paper_score": 22
        },
        {
          "title": "Efficacy and Safety of Ashwagandha (Withania somnifera) Root Extract in Insomnia and Anxiety: A Double-blind, Randomized, Placebo-controlled Study",
          "trial_duration": "10 weeks",
          "reasoning": "This study demonstrates that Ashwagandha root extract significantly improves sleep onset latency in patients with insomnia, indicating its potential to help reduce the time it takes to fall asleep.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31728244",
          "journal": "Cureus",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with insomnia",
          "year": 2019,
          "author": "Langade, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Langade, et al. · Cureus · 2019",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 10 weeks.",
          "summary_text": "Ashwagandha significantly reduced sleep latency in patients with insomnia and anxiety by promoting a calmer pre sleep state.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": 25.25,
      "papers": [
        {
          "title": "The Effects of L-Theanine Supplementation on Quality of Sleep: A Systematic Review",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review examines L-Theanine and reports improvements in sleep onset latency, indicating that L-Theanine may help reduce the time it takes to fall asleep.",
          "link": "https://doaj.org/article/bdfa66790b984a9daedfc65ef6d20a86",
          "journal": "Proc",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "L-Theanine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "50mg-655mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "480 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults and kids",
          "year": 2023,
          "author": "Bulman, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Bulman, et al. · Proc · 2023",
          "study_quality_sentence": "A large meta-analysis reviewed multiple studies.",
          "summary_text": "L Theanine significantly reduced sleep latency in adults and children by calming the nervous system.",
          "paper_score": 23
        },
        {
          "title": "The effects of L-theanine consumption on sleep outcomes: A systematic review and meta-analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that L-Theanine significantly improves subjective sleep onset latency, indicating its potential effectiveness in helping individuals fall asleep faster.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40056718",
          "journal": "Sleep Med Rev",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "sleep_latency",
          "supplement": "L-Theanine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "15mg-1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "897 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "general population",
          "year": 2025,
          "author": "Bulman, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Bulman, et al. · Sleep Med Rev · 2025",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "L Theanine made a small but significant improvement in sleep latency in humans by promoting relaxation.",
          "paper_score": 24
        },
        {
          "title": "Dietary supplementation with Lactium and L-theanine alleviates sleep disturbance in adults: a double-blind, randomized, placebo-controlled clinical study",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines L-Theanine as part of the dietary supplement LTC-022 and reports significant findings related to sleep onset latency (SOL) and time to fall asleep, showing a decrease in SOL and improvements in total sleep time (TST) and sleep efficiency (SE) after supplementation.",
          "link": "https://www.frontiersin.org/journals/nutrition/articles/10.3389/fnut.2024.1419978/full",
          "journal": "Front Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "L-Theanine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "204.12mg/day",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "40 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with sleep issues",
          "year": 2024,
          "author": "Lim, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Lim, et al. · Front Nutr · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 40 participants over 8 weeks.",
          "summary_text": "L Theanine significantly reduced sleep latency in adults with sleep disturbances by easing pre sleep tension.",
          "paper_score": 22
        },
        {
          "title": "Effects of L-Theanine Administration on Stress-Related Symptoms and Cognitive Functions in Healthy Adults: A Randomized Controlled Trial",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that L-Theanine administration significantly reduces sleep latency and improves sleep quality, suggesting it may help individuals fall asleep faster.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31623400",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "L-Theanine",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "200mg/day",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "30 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2019,
          "author": "Hidese, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Hidese, et al. · Nutrients · 2019",
          "study_quality_sentence": "A medium-sized RCT followed 30 participants over 4 weeks.",
          "summary_text": "L Theanine significantly reduced sleep latency in healthy adults by supporting a smoother wind down before sleep.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": 25.0,
      "papers": [
        {
          "title": "Oral magnesium supplementation for insomnia in older adults: a Systematic Review & Meta-Analysis - PubMed",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines magnesium supplementation and reports that it significantly reduces sleep onset latency by an average of 17.36 minutes in older adults with insomnia.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33865376",
          "journal": "BMC Complement Med",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "<3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "151 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older adults",
          "year": 2021,
          "author": "Mah, et al.",
          "study_type_score": 3,
          "confidence": "medium",
          "study_tag": "Mah, et al. · BMC Complement Med · 2021",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Magnesium significantly reduced sleep latency in older adults by supporting relaxation before sleep.",
          "paper_score": 26
        },
        {
          "title": "The effect of magnesium supplementation on primary insomnia in elderly: A double-blind placebo-controlled clinical trial - PubMed",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that magnesium supplementation significantly decreases sleep onset latency in elderly individuals, suggesting that magnesium may help improve the time it takes to fall asleep.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/23853635",
          "journal": "J Res Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "46 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2012,
          "author": "Abbasi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Abbasi, et al. · J Res Med Sci · 2012",
          "study_quality_sentence": "A medium-sized RCT followed 46 participants over 8 weeks.",
          "summary_text": "Magnesium significantly reduced sleep latency in the elderly by helping regulate melatonin production.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Omega 3": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Multi-strain probiotic improves subjective sleep quality with no impact on body composition, hemodynamics, and physical activity",
          "trial_duration": "6 weeks",
          "reasoning": "The study demonstrates that a multi-strain probiotic improves subjective sleep quality, specifically indicating faster sleep onset and reduced disturbances, which are directly related to sleep onset latency and time to fall asleep.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38350465",
          "journal": "Benef Microbes",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "sleep_latency",
          "supplement": "Probiotics",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "40bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "70 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2024,
          "author": "Kerksick, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Kerksick, et al. · Benef Microbes · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 70 participants over 6 weeks.",
          "summary_text": "Probiotics made a small but significant improvement in sleep latency in healthy adults by helping regulate nighttime stress and digestion.",
          "paper_score": 22
        },
        {
          "title": "The beneficial effect of a multispecies probiotic intervention on quality of sleep – a randomized, double-blinded, placebo-controlled study",
          "trial_duration": "28 days",
          "reasoning": "The study demonstrates that a multispecies probiotic intervention significantly improved sleep latency, indicating that probiotics may help reduce the time it takes to fall asleep.",
          "link": "https://www.sciencedirect.com/science/article/pii/S0022395626000518",
          "journal": "J Psychiatr Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "sleep_latency",
          "supplement": "Probiotics",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "30bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "130 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with poor sleep",
          "year": 2026,
          "author": "Horvath, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Horvath, et al. · J Psychiatr Res · 2026",
          "study_quality_sentence": "A small RCT tracked 130 participants over 28 days.",
          "summary_text": "Probiotics made a small but significant improvement in sleep latency in volunteers by supporting gut brain signaling.",
          "paper_score": 21
        }
      ],
      "impact": "Moderate"
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": 26.17,
      "papers": [
        {
          "title": "Vitamin D Supplementation and Sleep: A Systematic Review and Meta-Analysis of Intervention Studies - PMC",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D supplementation and its effects on sleep outcomes, specifically reporting significant improvements in sleep onset latency and overall sleep quality, suggesting that Vitamin D may help reduce the time to fall asleep.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8912284",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2022,
          "author": "Abboud, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Abboud, et al. · Nutrients · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly reduces sleep latency in the general population by helping regulate melatonin.",
          "paper_score": 27
        },
        {
          "title": "The effect of vitamin D on sleep quality: A systematic review and meta-analysis - PubMed",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D and reports that its supplementation significantly improves sleep quality, which is relevant to sleep onset latency and time to fall asleep.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/35578558",
          "journal": "Nutr Health",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Vitamin D",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "general public",
          "year": 2022,
          "author": "Mirzaei-Azandaryani, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Mirzaei-Azandaryani, et al. · Nutr Health · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly reduced sleep latency in the general population by helping people fall asleep faster.",
          "paper_score": 27
        },
        {
          "title": "The effect of vitamin D supplement on the score and quality of sleep in 20-50 year-old people with sleep disorders compared with control group - PubMed",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that Vitamin D supplementation improves sleep quality, reduces sleep latency, and enhances the time to fall asleep in individuals aged 20-50 with sleep disorders.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/28475473",
          "journal": "Nutr Neurosci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1250mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "89 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with sleep disorders",
          "year": 2018,
          "author": "Majid, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Majid, et al. · Nutr Neurosci · 2018",
          "study_quality_sentence": "A medium-sized RCT followed 89 participants over 8 weeks.",
          "summary_text": "Vitamin D significantly reduced sleep latency in adults with sleep disorders by supporting healthier sleep onset.",
          "paper_score": 20
        }
      ],
      "impact": "Very High"
    },
    "Vitamin E": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Effect of Vitamin E Supplementation on Chronic Insomnia Disorder in Postmenopausal Women: A Prospective, Double-Blinded Randomized Controlled Trial",
          "trial_duration": "1 month",
          "reasoning": "This study directly examines Vitamin E and its effects on chronic insomnia disorder in postmenopausal women, reporting significant improvements in sleep quality, which is relevant to sleep onset latency and time to fall asleep.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36904186",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Vitamin E",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "180mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "160 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women",
          "year": 2023,
          "author": "Thongchumnum, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Thongchumnum, et al. · Nutrients · 2023",
          "study_quality_sentence": "A large RCT followed 160 participants over 1 month.",
          "summary_text": "Vitamin E significantly reduced sleep latency in postmenopausal women by decreasing oxidative stress that disrupts sleep regulation.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Zinc": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "Effects of zinc supplementation on sleep quality in humans: A systematic review of randomized controlled trials",
          "trial_duration": "4-48 weeks",
          "reasoning": "This systematic review examines the effects of Zinc supplementation on sleep quality in humans, reporting significant improvements in sleep quality, which includes sleep onset latency and time to fall asleep, particularly in adults receiving higher doses of Zinc.",
          "link": "https://onlinelibrary.wiley.com/doi/full/10.1002/hsr2.70019",
          "journal": "Health Sci Rep",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Zinc",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "NA Meta Analysis",
          "dose_used": "10mg-73.3mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Meta analysis",
          "who_was_studied": "adults and children",
          "year": 2024,
          "author": "Jazinaki, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Jazinaki, et al. · Health Sci Rep · 2024",
          "study_quality_sentence": "A large meta-analysis reviewed multiple studies conducted over 4–48 weeks.",
          "summary_text": "Zinc significantly reduced sleep latency in adults by helping regulate sleep signaling.",
          "paper_score": 25
        },
        {
          "title": "The Effect of Zinc Supplementation on Sleep Quality of ICU Nurses: A Double Blinded Randomized Controlled Trial",
          "trial_duration": "1 month",
          "reasoning": "This study directly examines Zinc supplementation and reports significant improvements in sleep onset latency and overall sleep quality among ICU nurses, indicating that Zinc may help reduce the time to fall asleep.",
          "link": "https://journals.sagepub.com/doi/10.1177/2165079917734880",
          "journal": "Workplace H. & S.",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_latency",
          "supplement": "Zinc",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat relevant",
          "dose_used": "73mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "54 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "ICU nurses",
          "year": 2018,
          "author": "Gholipour Baradari, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Gholipour Baradari, et al. · Workplace H. & S. · 2018",
          "study_quality_sentence": "A medium-sized RCT followed 54 participants over 1 month.",
          "summary_text": "Zinc significantly reduced sleep latency in ICU nurses by supporting melatonin production.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    }
  },
  "sleep_disruptions": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 26.0,
      "papers": [
        {
          "title": "Effect of Ashwagandha (Withania somnifera) extract on sleep: A systematic review and meta-analysis",
          "trial_duration": "8 weeks",
          "reasoning": "This systematic review and meta-analysis directly examines Ashwagandha extract and reports significant effects on sleep, specifically addressing sleep disruptions and awakenings in adults.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/34559859",
          "journal": "PLoS One",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "sleep_disruptions",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "≥600mg/day",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "400 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy adults",
          "year": 2021,
          "author": "Cheah, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Cheah, et al. · PLoS One · 2021",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple 8-week studies.",
          "summary_text": "Ashwagandha made a small but significant improvement in sleep disruptions in adults by reducing cortisol.",
          "paper_score": 26
        },
        {
          "title": "Efficacy and Safety of Ashwagandha (Withania somnifera) Root Extract in Insomnia and Anxiety: A Double-blind, Randomized, Placebo-controlled Study",
          "trial_duration": "10 weeks",
          "reasoning": "This study demonstrates that Ashwagandha root extract significantly improves sleep onset latency and sleep quality in patients with insomnia, indicating its potential to help with sleep disruptions and awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31728244",
          "journal": "Cureus",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "sleep_disruptions",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with insomnia",
          "year": 2019,
          "author": "Langade, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Langade, et al. · Cureus · 2019",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 10 weeks.",
          "summary_text": "Ashwagandha substantially reduced sleep disruptions in patients with insomnia and anxiety by easing stress.",
          "paper_score": 24
        }
      ],
      "impact": "Very High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effects of vitamin D and/or calcium intervention on sleep quality in individuals with prediabetes: a post hoc analysis of a randomized controlled trial",
          "trial_duration": "24 weeks",
          "reasoning": "The study investigates the effects of calcium supplementation on sleep quality, showing that calcium may help improve sleep disruptions and awakenings in individuals with prediabetes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38366270",
          "journal": "Eur J Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "Calcium",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "212 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with prediabetes",
          "year": 2024,
          "author": "Miao, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Miao, et al. · Eur J Nutr · 2024",
          "study_quality_sentence": "A large RCT followed 212 participants over 24 weeks.",
          "summary_text": "Calcium significantly reduced sleep disruptions in individuals with prediabetes by regulating melatonin production.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "The Effect of Parenteral or Oral Iron Supplementation on Fatigue, Sleep, Quality of Life and Restless Legs Syndrome in Iron-Deficient Blood Donors: A Secondary Analysis of the IronWoMan RCT",
          "trial_duration": "8-12 weeks",
          "reasoning": "This study directly examines Iron supplementation and reports significant improvements in sleep quality and symptoms of restless legs syndrome, indicating that Iron may help reduce sleep disruptions and awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32380660",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "sleep_disruptions",
          "supplement": "Iron",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "176 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "iron-deficient donors",
          "year": 2020,
          "author": "Macher, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Macher, et al. · Nutrients · 2020",
          "study_quality_sentence": "A small RCT tracked 176 participants for 8–12 weeks.",
          "summary_text": "Iron substantially reduced sleep disruptions in blood donors by restoring adequate oxygen transport to tissues.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "L-Theanine": {
      "supplement_score": 25.0,
      "papers": [
        {
          "title": "The effects of L-theanine consumption on sleep outcomes: A systematic review and meta-analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines L-Theanine and its effects on sleep outcomes, showing significant improvements in subjective sleep onset latency and overall sleep quality, indicating its potential benefit for sleep disruptions and awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40056718",
          "journal": "Sleep Med Rev",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "L-Theanine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "15mg-1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "897 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "general population",
          "year": 2025,
          "author": "Bulman, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Bulman, et al. · Sleep Med Rev · 2025",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "L Theanine significantly reduced sleep disruptions in humans by promoting relaxation.",
          "paper_score": 26
        },
        {
          "title": "Dietary supplementation with Lactium and L-theanine alleviates sleep disturbance in adults: a double-blind, randomized, placebo-controlled clinical study",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines L-Theanine as part of the dietary supplement LTC-022 and reports significant improvements in sleep disruptions, specifically a decrease in wake after sleep onset (WASO) counts and an earlier bedtime, indicating its potential to alleviate sleep disturbances.",
          "link": "https://www.frontiersin.org/journals/nutrition/articles/10.3389/fnut.2024.1419978/full",
          "journal": "Front Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "L-Theanine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "204.12mg/day",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "40 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with sleep issues",
          "year": 2024,
          "author": "Lim, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Lim, et al. · Front Nutr · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 40 participants over 8 weeks.",
          "summary_text": "L Theanine significantly reduced sleep disruptions in adults by easing mental tension before sleep.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": 24.17,
      "papers": [
        {
          "title": "Oral magnesium supplementation for insomnia in older adults: a Systematic Review & Meta-Analysis - PubMed",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines magnesium supplementation and its effects on insomnia in older adults, reporting significant improvements in sleep onset latency, which is relevant to sleep disruptions and awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33865376",
          "journal": "BMC Complement Med",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "sleep_disruptions",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "<3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "151 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older adults",
          "year": 2021,
          "author": "Mah, et al.",
          "study_type_score": 3,
          "confidence": "medium",
          "study_tag": "Mah, et al. · BMC Complement Med · 2021",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Magnesium made a small but significant improvement in sleep disruptions in older adults by promoting muscle relaxation.",
          "paper_score": 24
        },
        {
          "title": "The effect of magnesium supplementation on primary insomnia in elderly: A double-blind placebo-controlled clinical trial - PubMed",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that magnesium supplementation significantly improves sleep disruptions in elderly individuals, as evidenced by reductions in insomnia severity, sleep onset latency, and early morning awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/23853635",
          "journal": "J Res Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "46 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2012,
          "author": "Abbasi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Abbasi, et al. · J Res Med Sci · 2012",
          "study_quality_sentence": "A medium-sized RCT followed 46 participants over 8 weeks.",
          "summary_text": "Magnesium significantly reduced sleep disruptions in the elderly by helping maintain healthy melatonin levels.",
          "paper_score": 22
        },
        {
          "title": "Magnesium Bisglycinate Supplementation in Healthy Adults Reporting Poor Sleep: A Randomized, Placebo-Controlled Trial - PubMed",
          "trial_duration": "4 weeks",
          "reasoning": "This study directly examines magnesium bisglycinate supplementation and reports a significant reduction in insomnia severity, indicating that magnesium may help improve sleep disruptions and awakenings in adults with poor sleep quality.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40918053",
          "journal": "Nat Sci Sleep",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "sleep_disruptions",
          "supplement": "Magnesium",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "250mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "155 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults with poor sleep",
          "year": 2025,
          "author": "Schuster, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Schuster, et al. · Nat Sci Sleep · 2025",
          "study_quality_sentence": "A large RCT followed 155 participants over 4 weeks.",
          "summary_text": "Magnesium made a small but significant improvement in sleep disruptions in healthy adults by supporting nervous system regulation.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Omega 3": {
      "supplement_score": 23.0,
      "papers": [
        {
          "title": "Omega-3 long-chain polyunsaturated fatty acid and sleep: a systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis indicates that Omega-3 long-chain polyunsaturated fatty acids may improve sleep organization and reduce sleep disturbances in infants and children, suggesting a potential benefit for sleep disruptions and awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33382879",
          "journal": "Nutr Rev",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "small",
          "metric": "sleep_disruptions",
          "supplement": "Omega 3",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "220mg-2500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "people of all ages",
          "year": 2021,
          "author": "Dai, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Dai, et al. · Nutr Rev · 2021",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Omega 3 made a small but significant improvement in sleep disrupted populations by supporting melatonin production.",
          "paper_score": 24
        },
        {
          "title": "Effect of Docosahexaenoic Acid and Eicosapentaenoic Acid Supplementation on Sleep Quality in Healthy Subjects: A Randomized, Double-Blinded, Placebo-Controlled Trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study directly examines Omega 3 (DHA and EPA) and reports improvements in sleep quality, specifically noting enhanced sleep efficiency and reduced frequent dreaming, which are relevant to sleep disruptions and awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36235788",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "Omega 3",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "860mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "66 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older Japanese adults",
          "year": 2022,
          "author": "Yokoi-Shimizu, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Yokoi-Shimizu, et al. · Nutrients · 2022",
          "study_quality_sentence": "A medium-sized RCT followed 66 participants over 12 weeks.",
          "summary_text": "Omega 3 significantly reduced sleep disruptions in healthy Japanese adults by lowering inflammation that affects sleep quality.",
          "paper_score": 20
        }
      ],
      "impact": "Moderate"
    },
    "Probiotics": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Bifidobacterium longum 1714 improves sleep quality and aspects of well-being in healthy adults: a randomized, double-blind, placebo-controlled clinical trial",
          "trial_duration": "8 weeks",
          "reasoning": "The study demonstrates that Bifidobacterium longum 1714 may improve sleep quality and reduce daytime dysfunction due to sleepiness, indicating potential benefits for sleep disruptions and awakenings.",
          "link": "https://www.nature.com/articles/s41598-024-53810-w",
          "journal": "Sci Rep",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "sleep_disruptions",
          "supplement": "Probiotics",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "1bn CFU",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "89 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2024,
          "author": "Patterson, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Patterson, et al. · Sci Rep · 2024",
          "study_quality_sentence": "A medium-sized RCT followed 89 participants over 8 weeks.",
          "summary_text": "Probiotics made a small but significant improvement to sleep disruptions in healthy adults by modulating gut-brain axis signaling.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Impact of Vitamin B1 and Vitamin B2 Supplementation on Anxiety, Stress, and Sleep Quality: A Randomized, Double-Blind, Placebo-Controlled Trial",
          "trial_duration": "4 weeks",
          "reasoning": "This study demonstrates that Vitamin B2 supplementation significantly improves sleep quality and reduces sleepiness, addressing sleep disruptions and awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40507089",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "Vitamin B2",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "43 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "college students",
          "year": 2025,
          "author": "Tao, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Tao, et al. · Nutrients · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 43 participants over 4 weeks.",
          "summary_text": "Vitamin B2 significantly reduced sleep disruptions in college students by supporting melatonin synthesis.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin B6": {
      "supplement_score": 18.5,
      "papers": [
        {
          "title": "Therapeutic effects of magnesium and vitamin B6 in alleviating the symptoms of restless legs syndrome: a randomized controlled clinical trial",
          "trial_duration": "2 months",
          "reasoning": "This study directly examines Vitamin B6 and its effects on sleep quality in patients with Restless Legs Syndrome, a condition known to cause sleep disruptions and awakenings.",
          "link": "https://bmccomplementmedtherapies.biomedcentral.com/articles/10.1186/s12906-022-03814-8",
          "journal": "BMC Complement Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "small",
          "metric": "sleep_disruptions",
          "supplement": "Vitamin B6",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "40mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "75 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "young adults with restless legs",
          "year": 2023,
          "author": "Jadidi, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Jadidi, et al. · BMC Complement Med · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 75 participants over 2 months.",
          "summary_text": "Vitamin B6 made a small but significant improvement to sleep disruptions in individuals with RLS by enhancing serotonin synthesis.",
          "paper_score": 18
        }
      ],
      "impact": "Low"
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": 27.5,
      "papers": [
        {
          "title": "Vitamin D Supplementation and Sleep: A Systematic Review and Meta-Analysis of Intervention Studies - PMC",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D supplementation and its effects on sleep quality, specifically reporting significant improvements in sleep disruptions and awakenings as measured by the Pittsburgh Sleep Quality Index.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8912284",
          "journal": "Nutrients",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "Vitamin D",
          "title_relevance": "highly_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "25mcg-178.57mcg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2022,
          "author": "Abboud, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Abboud, et al. · Nutrients · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly reduced sleep disruptions in the general population by supporting sleep wake regulation.",
          "paper_score": 28
        },
        {
          "title": "The effect of vitamin D on sleep quality: A systematic review and meta-analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin D and reports that its supplementation significantly improves sleep quality, which is relevant to sleep disruptions and awakenings.",
          "link": "https://journals.sagepub.com/doi/abs/10.1177/02601060221082367",
          "journal": "Nutr Health",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "Vitamin D",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "7.5-32.95mcg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with sleep issues",
          "year": 2022,
          "author": "Mirzaei-Azandaryani, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Mirzaei-Azandaryani, et al. · Nutr Health · 2022",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin D significantly reduced sleep disruptions in adults with sleep disorders by regulating melatonin production.",
          "paper_score": 25
        }
      ],
      "impact": "Very High"
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "The Effect of Zinc Supplementation on Sleep Quality of ICU Nurses: A Double Blinded Randomized Controlled Trial",
          "trial_duration": "1 month",
          "reasoning": "This study demonstrates that Zinc supplementation significantly improves sleep quality and reduces sleep latency in ICU nurses, indicating that Zinc may help alleviate sleep disruptions and awakenings.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/29241421",
          "journal": "Workplace H. S.",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "sleep_disruptions",
          "supplement": "Zinc",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat relevant",
          "dose_used": "73mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "54 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "ICU nurses",
          "year": 2018,
          "author": "Gholipour Baradari, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Gholipour Baradari, et al. · Workplace H. S. · 2018",
          "study_quality_sentence": "A medium-sized RCT followed 54 participants over 1 month.",
          "summary_text": "Zinc significantly reduced sleep disruptions in ICU nurses by modulating the sleep-regulating hormone melatonin.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    }
  },
  "healthspan": {
    "Acetyl L-Carnitine": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Acetyl L-carnitine (ALC) treatment in elderly patients with fatigue",
          "trial_duration": "6 months",
          "reasoning": "This RCT administered acetyl L-carnitine to elderly patients (aged 70–88) and measured multiple healthspan-relevant endpoints including physical functional status (+17.1 vs +0.6, p<0.0001), MMSE cognitive improvement (+3.4 vs +0.5, p<0.0001), fatigue severity scale, and muscle pain. Functional status and cognitive capacity in older adults are direct healthspan indicators, and the magnitude and breadth of improvements across physical and cognitive aging outcomes makes this a strong healthspan paper.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/17658628",
          "journal": "Arch Gerontol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "healthspan",
          "supplement": "Acetyl L-Carnitine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "2000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "96 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "elderly patients with fatigue",
          "year": 2008,
          "author": "Malaguarnera, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Malaguarnera, et al. · Arch Gerontol · 2008",
          "study_quality_sentence": "A medium-sized RCT followed 96 participants over 6 months.",
          "summary_text": "Acetyl L-Carnitine substantially enhanced healthspan in elderly patients by reducing fatigue and physical decline.",
          "paper_score": 22
        },
        {
          "title": "Meta-analysis of double blind randomized controlled clinical trials of acetyl-L-carnitine versus placebo in the treatment of mild cognitive impairment and mild Alzheimer's disease",
          "trial_duration": "3–12 months",
          "reasoning": "This meta-analysis of double-blind RCTs specifically evaluated acetyl L-carnitine (Alcar) versus placebo for mild cognitive impairment and early Alzheimer's disease — core healthspan outcomes in aging populations. Significant advantages for ALCAR were found on clinical scales (ES=0.32) and psychometric tests including memory (ES=0.29), attention/performance (ES=0.22), and intellectual function (ES=0.37). Preventing or slowing cognitive decline in older adults is a direct healthspan metric, making this the strongest meta-analytic evidence for ALCAR's aging-related benefit.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/12598816",
          "journal": "Int Clin",
          "study_type": "meta_analysis",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Acetyl L-Carnitine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1500-3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with dementia",
          "year": 2003,
          "author": "Montgomery, et al.",
          "study_type_score": 3,
          "confidence": "medium",
          "study_tag": "Montgomery, et al. · Int Clin · 2003",
          "study_quality_sentence": "A large meta-analysis combined multiple studies over 3–12 months.",
          "summary_text": "Acetyl L-Carnitine significantly improved healthspan in adults with cognitive impairment by supporting cellular energy production.",
          "paper_score": 24
        },
        {
          "title": "Acetyl-L-carnitine Slows the Progression from Prefrailty to Frailty in Older Subjects: A Randomized Interventional Clinical Trial",
          "trial_duration": "3 months",
          "reasoning": "This RCT used acetyl L-carnitine specifically (ALCAR) in pre-frail older subjects and showed that treatment delayed progression from prefrailty to frailty — a primary healthspan endpoint. Significant improvements were observed in MMSE cognitive score (p<0.0001), 6-minute walking distance (p<0.0001), and inflammatory marker CRP (p<0.001), all directly relevant to healthy aging and functional independence. Frailty progression is a central healthspan metric, making this the most direct ALCAR-healthspan RCT available.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36043711",
          "journal": "Curr Pharm Des",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Acetyl L-Carnitine",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "3000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "92 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "pre-frail older adults",
          "year": 2022,
          "author": "Malaguarnera, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Malaguarnera, et al. · Curr Pharm Des · 2022",
          "study_quality_sentence": "A medium-sized RCT followed 92 participants over 3 months.",
          "summary_text": "Acetyl L-Carnitine significantly improved healthspan in older adults by helping maintain cognitive function.",
          "paper_score": 20
        }
      ],
      "impact": "High"
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 27.5,
      "papers": [
        {
          "title": "Enhancing healthspan with Ashwagandha (Withania somnifera): a comprehensive review of its multifaceted geroprotective benefits",
          "trial_duration": "Systematic Review",
          "reasoning": "This comprehensive review highlights Ashwagandha's potential to enhance healthspan by targeting key aging biomarkers, including telomerase activity and inflammation reduction, which are crucial for promoting longevity and healthy aging.",
          "link": "https://link.springer.com/article/10.1007/s10522-025-10320-0",
          "journal": "Biogerontology",
          "study_type": "systematic_review",
          "effect_strength": "large",
          "metric": "healthspan",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older adults",
          "year": 2025,
          "author": "Vittal, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Vittal, et al. · Biogerontology · 2025",
          "study_quality_sentence": "A large meta-analysis combined multiple studies.",
          "summary_text": "Ashwagandha substantially increased healthspan in older adults by reducing oxidative stress and inflammation.",
          "paper_score": 27
        }
      ],
      "impact": "Very High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "CoQ10": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "Coenzyme Q10 and Degenerative Disorders Affecting Longevity: An Overview",
          "trial_duration": "2 years",
          "reasoning": "This review discusses the role of CoQ10 in preventing or managing degenerative disorders that affect longevity, highlighting its potential to reduce mortality and improve health markers related to aging.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/30781472",
          "journal": "Antioxidants (Basel)",
          "study_type": "systematic_review",
          "effect_strength": "large",
          "metric": "healthspan",
          "supplement": "CoQ10",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "300mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "440 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2019,
          "author": "Mantle, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Mantle, et al. · Antioxidants (Basel) · 2019",
          "study_quality_sentence": "A large meta-analysis reviewed multiple studies over 2 years.",
          "summary_text": "CoQ10 substantially enhanced healthspan in elderly individuals by increasing cellular energy production through mitochondrial support.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": 28.5,
      "papers": [
        {
          "title": "Total, Dietary, and Supplemental Magnesium Intakes and Risk of All-Cause, Cardiovascular, and Cancer Mortality: A Systematic Review and Dose-Response Meta-Analysis of Prospective Cohort Studies",
          "trial_duration": "3.5 to 32 years",
          "reasoning": "This study directly examines Magnesium and finds that higher dietary magnesium intake is associated with a reduced risk of all-cause and cancer mortality, indicating its potential role in promoting longevity and healthy aging biomarkers.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33684200",
          "journal": "Adv Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Magnesium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "126-523mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "1,168,756 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults",
          "year": 2021,
          "author": "Bagheri, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Bagheri, et al. · Adv Nutr · 2021",
          "study_quality_sentence": "A large meta-analysis reviewed data from 1m+ participants over 3.5 to 32 years.",
          "summary_text": "Magnesium significantly improved healthspan in adults by reducing oxidative stress and inflammation.",
          "paper_score": 28
        }
      ],
      "impact": "Very High"
    },
    "Omega 3": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Omega-3 supplementation and stress reactivity of cellular aging biomarkers: an ancillary substudy of a randomized, controlled trial in midlife adults",
          "trial_duration": "4 months",
          "reasoning": "This study directly examines Omega-3 supplementation and its effects on cellular aging biomarkers, showing that it may enhance telomerase activity and reduce inflammation, which are linked to longevity and healthy aging.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/33875799",
          "journal": "Mol Psychiatry",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Omega 3",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1250mg-2500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "138 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight middle-aged adults",
          "year": 2021,
          "author": "Madison, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Madison, et al. · Mol Psychiatry · 2021",
          "study_quality_sentence": "A small RCT tracked 138 participants for 4 months.",
          "summary_text": "Omega 3 significantly improved healthspan in sedentary, overweight, middle-aged participants by reducing systemic inflammation.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Probiotics": {
      "supplement_score": 27.83,
      "papers": [
        {
          "title": "The Effect of Probiotics on Health Outcomes in the Elderly: A Systematic Review of Randomized, Placebo-Controlled Studies - PMC",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review examines the effects of Probiotics on various health outcomes in the elderly, highlighting their potential to improve longevity and healthy aging biomarkers through modulation of gut microbiota and immune function.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8234958",
          "journal": "Microorganisms",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "65M-200bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older healthy adults",
          "year": 2021,
          "author": "Hutchinson, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Hutchinson, et al. · Microorganisms · 2021",
          "study_quality_sentence": "A large meta-analysis combined multiple studies, making it highly credible.",
          "summary_text": "Probiotics significantly improved healthspan in healthy older adults by strengthening gut health.",
          "paper_score": 25
        },
        {
          "title": "Effects of probiotics, prebiotics, and synbiotics on gut microbiota in older adults: a systematic review and meta-analysis of randomized controlled trials - PMC",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines probiotics and their effects on gut microbiota in older adults, reporting significant improvements in inflammatory markers and beneficial bacteria associated with longevity and healthy aging biomarkers.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12482033",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "journal": "Nutr J",
          "population_relevance": "somewhat_relevant",
          "dose_used": "10M-400bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "1633 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2025,
          "author": "Zhuang, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Zhuang, et al. · Nutr J · 2025",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Probiotics significantly improved healthspan in older adults by supporting immune function.",
          "paper_score": 26
        },
        {
          "title": "Probiotics supplementation or probiotic-fortified products on sarcopenic indices in older adults: systematic review and meta-analysis from recent randomized controlled trials - PMC",
          "trial_duration": "8 weeks - 12 months",
          "reasoning": "This study directly examines Probiotics and reports significant improvements in muscle mass and strength, which are important biomarkers for longevity and healthy aging in older adults.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10873954",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "journal": "Front Aging",
          "population_relevance": "relevant",
          "dose_used": "10bn-112bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "733 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older adults",
          "year": 2024,
          "author": "Handajani, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Handajani, et al. · Front Aging · 2024",
          "study_quality_sentence": "A gold-standard meta-analysis reviewed multiple studies over 8 weeks to 12 months.",
          "summary_text": "Probiotics significantly improved healthspan in older adults by helping maintain metabolic balance.",
          "paper_score": 28
        }
      ],
      "impact": "Very High"
    },
    "Resveratrol": {
      "supplement_score": 25.5,
      "papers": [
        {
          "title": "Effects and safety of resveratrol supplementation in older adults: A comprehensive systematic review",
          "trial_duration": "Systematic Review",
          "reasoning": "This systematic review examines the effects of Resveratrol supplementation in older adults, highlighting its potential to improve health parameters related to longevity and healthy aging biomarkers, such as exercise adaptation and cognitive function.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38433010",
          "journal": "Phytother Res",
          "study_type": "systematic_review",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Resveratrol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "200-1000mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "Systematic Review",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "older adults",
          "year": 2024,
          "author": "Yadegar, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Yadegar, et al. · Phytother Res · 2024",
          "study_quality_sentence": "A large meta-analysis combined multiple studies.",
          "summary_text": "Resveratrol significantly enhanced healthspan in older adults by activating sirtuins to promote cellular repair and longevity.",
          "paper_score": 25
        }
      ],
      "impact": "High"
    },
    "Rhodiola Rosea": {
      "supplement_score": null,
      "papers": []
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": 28.5,
      "papers": [
        {
          "title": "Systematic review with dose-response meta-analyses between vitamin B-12 intake and European Micronutrient Recommendations Aligned's prioritized biomarkers of vitamin B-12 including randomized controlled trials and observational studies in adults and elderly persons",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis directly examines Vitamin B12 intake and its impact on biomarkers of Vitamin B12 status, including methylmalonic acid (MMA), which are relevant to longevity and healthy aging biomarkers.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/23269815",
          "journal": "Am J Clin Nutr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Vitamin B12",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "2.5-1000mcg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults and seniors",
          "year": 2013,
          "author": "Dullemeijer, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Dullemeijer, et al. · Am J Clin Nutr · 2013",
          "study_quality_sentence": "A large gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Vitamin B12 significantly improved healthspan in adults and elderly persons by supporting DNA synthesis and red blood cell formation.",
          "paper_score": 28
        }
      ],
      "impact": "Very High"
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Vitamin D3 and marine ω-3 fatty acids supplementation and leukocyte telomere length: 4-year findings from the VITamin D and OmegA-3 TriaL (VITAL) randomized controlled trial - PubMed",
          "trial_duration": "5 years",
          "reasoning": "This study demonstrates that Vitamin D3 supplementation significantly reduces leukocyte telomere length attrition, suggesting a potential role in promoting longevity and healthy aging biomarkers.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/40409468",
          "journal": "Am J Clin Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "healthspan",
          "supplement": "Vitamin D",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "50mcg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "25771 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older American adults",
          "year": 2025,
          "author": "Zhu, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Zhu, et al. · Am J Clin Nutr · 2025",
          "study_quality_sentence": "A large RCT followed 25,771 participants over 5 years.",
          "summary_text": "Vitamin D significantly enhances healthspan in older adults by regulating calcium and phosphate balance to support bone health.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    }
  },
  "pace": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "Efficacy of Ashwagandha Extract Formulation (ASVAMAN®) on Improvement of Energy and Endurance: A Randomized, Double-blind, Placebo-controlled Clinical Study in Healthy Adults",
          "trial_duration": "42 days",
          "reasoning": "This study demonstrates that Ashwagandha extract (ASVAMAN®) significantly improves energy and endurance, as evidenced by enhanced performance in the six-minute walk test, which is directly related to running pace and endurance performance.",
          "link": "https://eu-opensci.org/index.php/ejmed/article/view/42304",
          "journal": "Eur J Med Health Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "pace",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "600 mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "40 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2025,
          "author": "Puttaswamy, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Puttaswamy, et al. · Eur J Med Health Sci · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 40 participants over 42 days.",
          "summary_text": "Ashwagandha substantially increased pace in healthy adults by reducing cortisol levels to enhance energy availability.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Berberine": {
      "supplement_score": null,
      "papers": []
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": null,
      "papers": []
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": null,
      "papers": []
    },
    "Iron": {
      "supplement_score": 26.0,
      "papers": [
        {
          "title": "Iron supplementation improves endurance after training in iron-depleted, nonanemic women | Journal of Applied Physiology | American Physiological Society",
          "trial_duration": "6 wk",
          "reasoning": "Iron supplementation significantly improved endurance performance in iron-depleted, nonanemic women, as evidenced by a greater reduction in time to complete a 15-km time trial compared to placebo, indicating enhanced running pace and endurance capacity.",
          "link": "https://journals.physiology.org/doi/full/10.1152/jappl.2000.88.3.1103",
          "journal": "J Appl Physiol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "pace",
          "supplement": "Iron",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "42 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "iron-depleted women",
          "year": 2000,
          "author": "Hinton, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Hinton, et al. · J Appl Physiol · 2000",
          "study_quality_sentence": "A medium-sized RCT followed 42 participants over 6 weeks.",
          "summary_text": "Iron substantially improved pace in iron depleted women by helping restore iron status.",
          "paper_score": 23
        },
        {
          "title": "Iron deficiency, supplementation, and sports performance in female athletes: A systematic review - PMC",
          "trial_duration": "42–56 days",
          "reasoning": "The study directly examines Iron supplementation and its effects on endurance performance in female athletes, showing that supplementation can improve running pace and overall endurance.",
          "link": "https://www.sciencedirect.com/science/article/pii/S2095254624001674",
          "journal": "J Sport Health Sci",
          "study_type": "systematic_review",
          "effect_strength": "large",
          "metric": "pace",
          "supplement": "Iron",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "50mg-100mg, 16mg-100mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "669 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "female athletes",
          "year": 2025,
          "author": "Pengelly, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Pengelly, et al. · J Sport Health Sci · 2025",
          "study_quality_sentence": "A large meta-analysis reviewed multiple studies over 42–56 days.",
          "summary_text": "Iron substantially improved pace in high level female athletes by increasing hemoglobin and oxygen delivery.",
          "paper_score": 27
        }
      ],
      "impact": "Very High"
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": null,
      "papers": []
    },
    "Omega 3": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "Effects of probiotic supplementation on 12 min run performance, mood management, body composition and gut microbiota in amateur marathon runners: A double-blind controlled trial",
          "trial_duration": "5 weeks",
          "reasoning": "Probiotics have been shown to improve running pace as evidenced by the increase in 12 min run performance in amateur marathon runners, indicating a potential benefit for endurance performance.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38706951",
          "journal": "J Exerc Sci Fit",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "pace",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "1.5bn CFU",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "19 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "amateur marathon runners",
          "year": 2024,
          "author": "Wang, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Wang, et al. · J Exerc Sci Fit · 2024",
          "study_quality_sentence": "A small RCT tracked 19 participants for 5 weeks.",
          "summary_text": "Probiotics significantly improved pace in marathon runners by reducing gut inflammation and enhancing nutrient absorption.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Resveratrol": {
      "supplement_score": 23.0,
      "papers": [
        {
          "title": "Resveratrol Enhances Exercise-Induced Cellular and Functional Adaptations of Skeletal Muscle in Older Men and Women - PubMed",
          "trial_duration": "12 weeks",
          "reasoning": "This study demonstrates that Resveratrol, when combined with exercise, enhances mitochondrial density and muscle fatigue resistance in older adults, which may contribute to improved running pace and endurance performance.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/28505227",
          "journal": "J Gerontol A Biol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "pace",
          "supplement": "Resveratrol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "30 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults",
          "year": 2017,
          "author": "Alway, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Alway, et al. · J Gerontol A Biol · 2017",
          "study_quality_sentence": "A medium-sized RCT followed 30 participants over 12 weeks.",
          "summary_text": "Resveratrol significantly improved pace in older adults by enhancing mitochondrial efficiency.",
          "paper_score": 22
        },
        {
          "title": "Resveratrol and exercise combined to treat functional limitations in late life: a pilot randomized controlled trial - PMC",
          "trial_duration": "12 weeks",
          "reasoning": "This study directly examines Resveratrol in combination with exercise and reports relevant findings on running pace and endurance performance, specifically improvements in gait speed and six-minute walk test distances among older adults.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7855904",
          "journal": "Exp Gerontol",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "pace",
          "supplement": "Resveratrol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg-1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older adults needing help",
          "year": 2020,
          "author": "Harper, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Harper, et al. · Exp Gerontol · 2020",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 12 weeks.",
          "summary_text": "Resveratrol significantly improved pace in older adults with functional limitations by supporting muscle function.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Rhodiola Rosea": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "The effects of an acute dose of Rhodiola rosea on endurance exercise performance",
          "trial_duration": "acute",
          "reasoning": "Acute Rhodiola Rosea intake can improve endurance exercise performance, as evidenced by increased time to exhaustion and enhanced VO2peak during exercise.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/15256690",
          "journal": "Int J Sport Nutr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "pace",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "200mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "36 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Acute",
          "study_length_score": 1,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "young healthy people",
          "year": 2004,
          "author": "De Bock, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "De Bock, et al. · Int J Sport Nutr · 2004",
          "study_quality_sentence": "A medium-sized RCT tested 36 participants in a single session.",
          "summary_text": "Rhodiola Rosea significantly improved pace in young healthy volunteers by reducing perceived exertion through modulation of stress response.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B12": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "A functional evaluation of anti-fatigue and exercise performance improvement following vitamin B complex supplementation in healthy humans, a randomized double-blind trial",
          "trial_duration": "28 days",
          "reasoning": "This study directly examines Vitamin B12 as part of a vitamin B complex supplementation and reports significant improvements in running endurance performance, specifically a 1.26-fold increase in time to exhaustion, indicating a potential benefit of Vitamin B12 for enhancing running pace and endurance.",
          "link": "https://www.medsci.org/v20p1272.htm",
          "journal": "Int J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "pace",
          "supplement": "Vitamin B12",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "750mcg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young healthy adults",
          "year": 2023,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Lee, et al. · Int J Med Sci · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 28 days.",
          "summary_text": "Vitamin B12 substantially increased pace in healthy adults by enhancing red blood cell production for better oxygen delivery.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Vitamin B2": {
      "supplement_score": 21.5,
      "papers": [
        {
          "title": "A Placebo-Controlled Trial of Riboflavin for Enhancement of Ultramarathon Recovery",
          "trial_duration": "10 days",
          "reasoning": "This study directly examines Vitamin B2 (riboflavin) and reports that it may reduce muscle pain and soreness during and after a 161-km ultramarathon, potentially enhancing running pace and endurance performance in the days following the event.",
          "link": "https://sportsmedicine-open.springeropen.com/articles/10.1186/s40798-017-0081-4",
          "journal": "Sports Med Open",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "pace",
          "supplement": "Vitamin B2",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "100 mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Short term",
          "study_length_score": 2,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "active people",
          "year": 2017,
          "author": "Hoffman, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Hoffman, et al. · Sports Med Open · 2017",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 10 days.",
          "summary_text": "Vitamin B2 significantly improved pace in athletes by enhancing mitochondrial energy production.",
          "paper_score": 21
        }
      ],
      "impact": "Low"
    },
    "Vitamin B6": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "A functional evaluation of anti-fatigue and exercise performance improvement following vitamin B complex supplementation in healthy humans, a randomized double-blind trial",
          "trial_duration": "28 days",
          "reasoning": "This study directly examines Vitamin B6 as part of a vitamin B complex supplementation and reports significant improvements in running endurance performance, specifically a 1.26-fold increase in time to exhaustion, indicating a positive effect on running pace and endurance.",
          "link": "https://www.medsci.org/v20p1272.htm",
          "journal": "Int J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "pace",
          "supplement": "Vitamin B6",
          "title_relevance": "relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "50mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "32 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "young healthy adults",
          "year": 2023,
          "author": "Lee, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Lee, et al. · Int J Med Sci · 2023",
          "study_quality_sentence": "A medium-sized RCT followed 32 participants over 28 days.",
          "summary_text": "Vitamin B6 substantially increased pace in healthy adults by enhancing neurotransmitter synthesis for better muscle coordination.",
          "paper_score": 24
        }
      ],
      "impact": "High"
    },
    "Vitamin C": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin D": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": null,
      "papers": []
    }
  },
  "body_composition": {
    "Acetyl L-Carnitine": {
      "supplement_score": null,
      "papers": []
    },
    "Alpha GPC": {
      "supplement_score": null,
      "papers": []
    },
    "Apigenin": {
      "supplement_score": null,
      "papers": []
    },
    "Ashwagandha": {
      "supplement_score": 28.0,
      "papers": [
        {
          "title": "Effects of Ashwagandha (Withania somnifera) on Physical Performance: Systematic Review and Bayesian Meta-Analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that Ashwagandha supplementation significantly improves physical performance, including muscle strength and cardiorespiratory fitness, which are directly related to body composition, lean mass, and fat mass.",
          "link": "https://www.mdpi.com/2411-5142/6/1/20",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Ashwagandha",
          "title_relevance": "somewhat_relevant",
          "journal": "Sports",
          "population_relevance": "highly_relevant",
          "dose_used": "240mg-600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "615 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy people",
          "year": 2021,
          "author": "Bonilla, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Bonilla, et al. · Sports · 2021",
          "study_quality_sentence": "A large gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Ashwagandha significantly improved body composition in healthy individuals by helping limit fat storage.",
          "paper_score": 28
        },
        {
          "title": "Examining the effect of Withania somnifera supplementation on muscle strength and recovery: a randomized controlled trial",
          "trial_duration": "8 weeks",
          "reasoning": "This study demonstrates that ashwagandha supplementation significantly increases muscle mass and strength, while also reducing body fat percentage, indicating its potential benefits for body composition.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/26609282",
          "journal": "J Int Soc Sports",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "body_composition",
          "supplement": "Ashwagandha",
          "title_relevance": "highly_relevant",
          "population_relevance": "relevant",
          "dose_used": "600mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "57 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "young men weightlifting",
          "year": 2015,
          "author": "Wankhede, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Wankhede, et al. · J Int Soc Sports · 2015",
          "study_quality_sentence": "A medium-sized RCT followed 57 participants over 8 weeks.",
          "summary_text": "Ashwagandha substantially improved body composition in healthy young men by reducing muscle breakdown.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Berberine": {
      "supplement_score": 28.83,
      "papers": [
        {
          "title": "The effect of berberine on obesity indices: a systematic review and meta-analysis",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that Berberine significantly reduces body weight, BMI, and waist circumference, indicating its potential effectiveness in improving body composition.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/41310257",
          "journal": "Int J Obes",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "large",
          "metric": "body_composition",
          "supplement": "Berberine",
          "title_relevance": "relevant",
          "population_relevance": "relevant",
          "dose_used": "500mg-1500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "Meta Analysis",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "adults",
          "year": 2026,
          "author": "Elahi Vahed, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Elahi Vahed, et al. · Int J Obes · 2026",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Berberine substantially improved body composition in adults by supporting fat metabolism.",
          "paper_score": 30
        },
        {
          "title": "Efficacy and safety of berberine on the components of metabolic syndrome: a systematic review and meta-analysis of randomized placebo-controlled trials",
          "trial_duration": "84-140 days",
          "reasoning": "This systematic review and meta-analysis demonstrates that Berberine significantly reduces body mass index (BMI) and waist circumference (WC), indicating its potential benefits for body composition by decreasing fat mass.",
          "link": "https://www.frontiersin.org/journals/pharmacology/articles/10.3389/fphar.2025.1572197/full",
          "journal": "Front Pharmacol",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Berberine",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "300mg-1500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "889 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with metabolic syndrome",
          "year": 2025,
          "author": "Liu, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Liu, et al. · Front Pharmacol · 2025",
          "study_quality_sentence": "A gold-standard meta-analysis reviewed multiple studies over 84-140 days.",
          "summary_text": "Berberine significantly improved body composition in adults with MetS by helping regulate blood sugar and insulin function.",
          "paper_score": 26
        },
        {
          "title": "The effect of berberine supplementation on obesity parameters, inflammation and liver function enzymes: A systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "12 weeks",
          "reasoning": "This systematic review and meta-analysis found that berberine supplementation significantly reduced body weight, body mass index (BMI), and waist circumference, indicating potential benefits for body composition.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/32690176",
          "journal": "Clin Nutr ESPEN",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Berberine",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg-1500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "2270 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with obesity",
          "year": 2020,
          "author": "Asbaghi, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Asbaghi, et al. · Clin Nutr ESPEN · 2020",
          "study_quality_sentence": "A gold-standard meta-analysis reviewed multiple studies over 12 weeks.",
          "summary_text": "Berberine significantly improved body composition in adults with obesity by supporting appetite and weight control.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Biotin": {
      "supplement_score": null,
      "papers": []
    },
    "Calcium": {
      "supplement_score": 24.5,
      "papers": [
        {
          "title": "Calcium supplementation for people with overweight or obesity.",
          "trial_duration": "8 weeks - 12 months",
          "reasoning": "This study directly examines Calcium supplementation and its effects on body composition, specifically reporting a small reduction in body mass index (BMI) and fat mass in individuals with overweight or obesity.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/38721870",
          "journal": "Cochrane Database",
          "study_type": "meta_analysis",
          "effect_strength": "small",
          "metric": "body_composition",
          "supplement": "Calcium",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "162mg-1500mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "1873 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight adults",
          "year": 2024,
          "author": "Cormick, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Cormick, et al. · Cochrane Database · 2024",
          "study_quality_sentence": "A large meta-analysis combined multiple studies over 8 weeks to 12 months.",
          "summary_text": "Calcium made a small but significant improvement to body composition in people with overweight or obesity by enhancing fat oxidation.",
          "paper_score": 24
        },
        {
          "title": "The effect of calcium and vitamin D supplementation on obesity in postmenopausal women: secondary analysis for a large-scale, placebo controlled, double-blind, 4-year longitudinal clinical trial",
          "trial_duration": "4 years",
          "reasoning": "This study directly examines Calcium supplementation and its effects on body composition, specifically showing that Calcium helps reduce trunk fat and preserve trunk lean mass in postmenopausal women.",
          "link": "https://nutritionandmetabolism.biomedcentral.com/articles/10.1186/1743-7075-7-62",
          "journal": "Nutr Metab",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Calcium",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1400mg-1500mg",
          "dose_score_text": "Near study dose",
          "dose_score": 3,
          "people_tested": "870 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women",
          "year": 2010,
          "author": "Zhou, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Zhou, et al. · Nutr Metab · 2010",
          "study_quality_sentence": "A large RCT followed 870 participants over 4 years.",
          "summary_text": "Calcium significantly improved body composition in postmenopausal women by enhancing bone mineral density to support lean mass retention.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    },
    "CoQ10": {
      "supplement_score": null,
      "papers": []
    },
    "Folic Acid": {
      "supplement_score": null,
      "papers": []
    },
    "Inositol": {
      "supplement_score": 24.83,
      "papers": [
        {
          "title": "Inositol supplementation efficacy in improving key cardiometabolic and anthropometric indices: a GRADE-assessed systematic review and meta-analysis of randomized controlled trials - PMC",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that Inositol supplementation can lead to significant reductions in body mass index (BMI), waist circumference, and waist-to-hip ratio, indicating potential benefits for body composition, lean mass, and fat mass.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12574088",
          "journal": "Diabetol Metab Syndr",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Inositol",
          "title_relevance": "highly_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "4000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "898 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with metabolic disorders",
          "year": 2025,
          "author": "Agajani Delavar, et al.",
          "study_type_score": 3,
          "confidence": "medium",
          "study_tag": "Agajani Delavar, et al. · Diabetol Metab Syndr · 2025",
          "study_quality_sentence": "A large, gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Inositol significantly improved body composition in adults with metabolic disorders by helping regulate blood sugar.",
          "paper_score": 24
        },
        {
          "title": "Inositol supplementation and body mass index: A systematic review and meta-analysis of randomized clinical trials - PMC",
          "trial_duration": "6–48 weeks",
          "reasoning": "This systematic review and meta-analysis demonstrates that Inositol supplementation significantly decreases body mass index (BMI), indicating its potential benefit for body composition, particularly in individuals with overweight and obesity.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9159559",
          "journal": "Obes Sci Pract",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Inositol",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "600mg-4450mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "891 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with health conditions",
          "year": 2022,
          "author": "Zarezadeh, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Zarezadeh, et al. · Obes Sci Pract · 2022",
          "study_quality_sentence": "A gold-standard meta-analysis reviewed multiple studies over 6–48 weeks.",
          "summary_text": "Inositol significantly improved body composition in adults by enhancing insulin sensitivity.",
          "paper_score": 26
        },
        {
          "title": "Effects of three treatment modalities (diet, myoinositol or myoinositol associated with D-chiro-inositol) on clinical and body composition outcomes in women with polycystic ovary syndrome",
          "trial_duration": "6 months",
          "reasoning": "This study directly examines myoinositol and its effects on body composition outcomes, specifically reporting significant reductions in fat mass and slight increases in lean mass in women with polycystic ovary syndrome.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/30915778",
          "journal": "Eur Rev Med",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Inositol",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "4000mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "43 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight women with PCOS",
          "year": 2019,
          "author": "Le Donne, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Le Donne, et al. · Eur Rev Med · 2019",
          "study_quality_sentence": "A medium-sized RCT followed 43 participants over 6 months.",
          "summary_text": "Inositol significantly improved body composition in overweight women with polycystic ovary syndrome by supporting hormone balance.",
          "paper_score": 20
        }
      ],
      "impact": "High"
    },
    "Iron": {
      "supplement_score": null,
      "papers": []
    },
    "L-Theanine": {
      "supplement_score": null,
      "papers": []
    },
    "L-Tyrosine": {
      "supplement_score": null,
      "papers": []
    },
    "Magnesium": {
      "supplement_score": null,
      "papers": []
    },
    "Omega 3": {
      "supplement_score": null,
      "papers": []
    },
    "Probiotics": {
      "supplement_score": 25.0,
      "papers": [
        {
          "title": "Impact of probiotics on muscle mass, muscle strength and lean mass: a systematic review and meta-analysis of randomized controlled trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that probiotics can enhance muscle mass and global muscle strength, which are key components of body composition.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/36414567",
          "journal": "J Cachexia",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Probiotics",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "relevant",
          "dose_used": "20bn-450bn CFU",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "24 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "Relevant",
          "who_was_studied": "healthy adults",
          "year": 2023,
          "author": "Prokopidis, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Prokopidis, et al. · J Cachexia · 2023",
          "study_quality_sentence": "A small meta-analysis reviewed multiple studies, but only included 24 participants.",
          "summary_text": "Probiotics significantly improved body composition in adults by optimizing nutrient absorption.",
          "paper_score": 26
        },
        {
          "title": "Probiotic With or Without Fiber Controls Body Fat Mass, Associated With Serum Zonulin, in Overweight and Obese Adults—Randomized Controlled Trial",
          "trial_duration": "6 months",
          "reasoning": "The study demonstrates that the probiotic B420, with or without fiber, significantly reduces body fat mass and waist circumference in overweight and obese adults, indicating its potential effectiveness for improving body composition.",
          "link": "https://www.thelancet.com/article/S2352-3964(16)30497-2/fulltext",
          "journal": "eBioMedicine",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Probiotics",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "100bn CFU",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "225 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight adults",
          "year": 2016,
          "author": "Stenman, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Stenman, et al. · eBioMedicine · 2016",
          "study_quality_sentence": "A large RCT followed 225 participants over 6 months.",
          "summary_text": "Probiotics significantly improved body composition in overweight adults by enhancing gut microbiota balance to reduce fat storage.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Resveratrol": {
      "supplement_score": null,
      "papers": []
    },
    "Rhodiola Rosea": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "Rhodiola/Cordyceps-Based Herbal Supplement Promotes Endurance Training-Improved Body Composition But Not Oxidative Stress and Metabolic Biomarkers: A Preliminary Randomized Controlled Study",
          "trial_duration": "8 weeks",
          "reasoning": "The study directly examines Rhodiola crenulata and reports significant improvements in body composition, including reductions in body weight and fat mass, as well as increases in muscle mass, after an 8-week endurance training program.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6835767",
          "journal": "Nutrients",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Rhodiola Rosea",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1400mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "14 participants",
          "people_tested_score": 1,
          "people_tested_score_text": "Small study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "inactive young adults",
          "year": 2019,
          "author": "Liao, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Liao, et al. · Nutrients · 2019",
          "study_quality_sentence": "A small RCT tracked 14 participants for 8 weeks.",
          "summary_text": "Rhodiola Rosea significantly improved body composition in young sedentary adults by reducing cortisol levels.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Tongkat Ali": {
      "supplement_score": null,
      "papers": []
    },
    "Curcumin": {
      "supplement_score": 26.5,
      "papers": [
        {
          "title": "The Effects of Curcumin on Weight Loss Among Patients With Metabolic Syndrome and Related Disorders: A Systematic Review and Meta-Analysis of Randomized Controlled Trials",
          "trial_duration": "Meta Analysis",
          "reasoning": "This systematic review and meta-analysis demonstrates that Curcumin intake significantly reduces body mass index (BMI), weight, and waist circumference, indicating its potential benefits for body composition, lean mass, and fat mass.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31249528",
          "journal": "Front Pharmacol",
          "study_type": "systematic_review_and_meta_analysis",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Curcumin",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "90mg-5000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "1604 participants",
          "people_tested_score": 3,
          "people_tested_score_text": "Large study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "adults with metabolic issues",
          "year": 2019,
          "author": "Akbari, et al.",
          "study_type_score": 3,
          "confidence": "high",
          "study_tag": "Akbari, et al. · Front Pharmacol · 2019",
          "study_quality_sentence": "A gold-standard meta-analysis combined multiple studies.",
          "summary_text": "Curcumin significantly improved body composition in patients with metabolic syndrome by reducing inflammation and oxidative stress.",
          "paper_score": 26
        }
      ],
      "impact": "Very High"
    },
    "Vitamin B12": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B2": {
      "supplement_score": null,
      "papers": []
    },
    "Vitamin B6": {
      "supplement_score": 20.5,
      "papers": [
        {
          "title": "The Effect of Pyridoxine Hydrochloride Supplementation on Leptin, Adiponectin, Glycemic Indices, and Anthropometric Indices in Obese and Overweight Women",
          "trial_duration": "8 weeks",
          "reasoning": "This study directly examines Vitamin B6 (pyridoxine hydrochloride) and reports significant reductions in fat mass, BMI, and waist circumference, indicating its potential benefits for body composition in obese and overweight women.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8331291",
          "journal": "Clin Nutr Res",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Vitamin B6",
          "title_relevance": "relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "80mg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "44 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "overweight women",
          "year": 2021,
          "author": "Haidari, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Haidari, et al. · Clin Nutr Res · 2021",
          "study_quality_sentence": "A medium-sized RCT followed 44 participants over 8 weeks.",
          "summary_text": "Vitamin B6 significantly improved body composition in obese and overweight women by enhancing protein metabolism.",
          "paper_score": 20
        }
      ],
      "impact": "Low"
    },
    "Vitamin C": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Vitamin C and E supplementation blunts increases in total lean body mass in elderly men after strength training",
          "trial_duration": "12 weeks",
          "reasoning": "This study directly examines Vitamin C and its effects on body composition, specifically reporting that high-dosage Vitamin C supplementation blunted increases in total lean body mass in elderly men after strength training.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/26129928",
          "journal": "Scand J Med Sci",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "body_composition",
          "supplement": "Vitamin C",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "500mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "34 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older men",
          "year": 2016,
          "author": "Bjørnsen, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Bjørnsen, et al. · Scand J Med Sci · 2016",
          "study_quality_sentence": "A medium-sized RCT followed 34 participants over 12 weeks.",
          "summary_text": "Vitamin C substantially improved body composition in elderly men by supporting muscle mass maintenance.",
          "paper_score": 23
        },
        {
          "title": "Effects of vitamins C and E supplementation combined with 12-week resistance training in older women with sarcopenia: A randomized, double-blind, placebo-controlled trial",
          "trial_duration": "12 weeks",
          "reasoning": "This study directly examines Vitamin C and reports significant improvements in body composition, specifically arm lean mass and skeletal muscle mass index, in older women with sarcopenia following supplementation combined with resistance training.",
          "link": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12384908",
          "journal": "Medicine (Baltimore)",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Vitamin C",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "1000mg",
          "dose_score_text": "Study-matched",
          "dose_score": 3,
          "people_tested": "60 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Medium term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "older women with sarcopenia",
          "year": 2025,
          "author": "Liu, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Liu, et al. · Medicine (Baltimore) · 2025",
          "study_quality_sentence": "A medium-sized RCT followed 60 participants over 12 weeks.",
          "summary_text": "Vitamin C significantly improved body composition in older women by helping preserve strength with age.",
          "paper_score": 22
        }
      ],
      "impact": "High"
    },
    "Vitamin D": {
      "supplement_score": 22.5,
      "papers": [
        {
          "title": "Effect of Vitamin D Supplementation on Body Composition and Physical Fitness in Healthy Adults: A Double-Blind, Randomized Controlled Trial",
          "trial_duration": "1 year",
          "reasoning": "This study directly examines Vitamin D supplementation and reports significant improvements in lean body mass, making it relevant to body composition outcomes.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31801135",
          "journal": "Ann Nutr Metab",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "moderate",
          "metric": "body_composition",
          "supplement": "Vitamin D",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "highly_relevant",
          "dose_used": "10.5mcg",
          "dose_score_text": "Far from dose",
          "dose_score": 1,
          "people_tested": "95 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 3,
          "who_was_studied_score_text": "High relevance",
          "who_was_studied": "healthy adults",
          "year": 2019,
          "author": "Sun, et al.",
          "study_type_score": 2,
          "confidence": "medium",
          "study_tag": "Sun, et al. · Ann Nutr Metab · 2019",
          "study_quality_sentence": "A medium-sized RCT followed 95 participants over 1 year.",
          "summary_text": "Vitamin D significantly improved body composition in healthy adults by enhancing calcium absorption to support muscle function.",
          "paper_score": 22
        }
      ],
      "impact": "Moderate"
    },
    "Vitamin E": {
      "supplement_score": null,
      "papers": []
    },
    "Zinc": {
      "supplement_score": 23.5,
      "papers": [
        {
          "title": "Zinc supplementation improves body weight management, inflammatory biomarkers and insulin resistance in individuals with obesity: a randomized, placebo-controlled, double-blind trial",
          "trial_duration": "15-weeks",
          "reasoning": "Zinc supplementation significantly improved body weight management and reduced anthropometric measurements in individuals with obesity, indicating its potential benefits for body composition, lean mass, and fat mass.",
          "link": "https://pubmed.ncbi.nlm.nih.gov/31827626",
          "journal": "Diabetol Metab Syndr",
          "study_type": "randomized_controlled_trial",
          "effect_strength": "large",
          "metric": "body_composition",
          "supplement": "Zinc",
          "title_relevance": "somewhat_relevant",
          "population_relevance": "somewhat_relevant",
          "dose_used": "30mg",
          "dose_score_text": "Useful range",
          "dose_score": 2,
          "people_tested": "40 participants",
          "people_tested_score": 2,
          "people_tested_score_text": "Medium study",
          "study_length_score_text": "Long term",
          "study_length_score": 3,
          "who_was_studied_score": 2,
          "who_was_studied_score_text": "Some relevance",
          "who_was_studied": "people with obesity",
          "year": 2019,
          "author": "Khorsandi, et al.",
          "study_type_score": 2,
          "confidence": "high",
          "study_tag": "Khorsandi, et al. · Diabetol Metab Syndr · 2019",
          "study_quality_sentence": "A medium-sized RCT followed 40 participants over 15 weeks.",
          "summary_text": "Zinc substantially improved body composition in individuals with obesity by enhancing insulin sensitivity to regulate fat storage.",
          "paper_score": 23
        }
      ],
      "impact": "High"
    }
  },
  "papers": []
}



window.metrics_supplement_research = metrics_supplement_research;